<template>
  <div>
    <!--    Loader-->
    <loading-panel :loading="loading"></loading-panel>
    <base-alert-dialog
      :show="credentialsAlert.show"
      :variant="credentialsAlert.variant"
      :title="credentialsAlert.title"
      :message="credentialsAlert.message"
      @confirm="credentialsAlert.show = false"
      @cancel="credentialsAlert.show = false"
    />
    <base-alert-dialog
      :show="confirmDialog.show"
      :variant="confirmDialog.variant"
      :title="confirmDialog.title"
      :message="confirmDialog.message"
      :confirm-text="confirmDialog.confirmText"
      :confirm-variant="confirmDialog.confirmVariant"
      show-cancel
      @confirm="onConfirmDialogConfirm"
      @cancel="onConfirmDialogCancel"
    />
    <!--   No data panel -->
    <div v-if="empty==true" class="mt-3" >
      <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
        <h4 class="mt-3">No data available.</h4>
      </div>
    </div>
<!--    <base-alert type="info">-->
<!--      <p>-->
<!--        Optionally apply a maximum of one payment gateway, to accept online card payments on your booking site, and take payments in your admin.-->
<!--      </p>-->
<!--      Please note: Your booking site will be offline until you activate at least one payment option (payment on arrival, invoice, paypal or a payment gateway)-->
<!--    </base-alert>-->
<!--    Payment Gateways-->
    <div class="row" v-if="!gateway_configured && payment_gateways.length >0">
      <div class="col-lg-3 col-md-6 col-sm-6 col-12" v-for="(p, i) in payment_gateways" :key="'A' + i">
        <card class="card-white">
          <div class="row justify-content-center">
            <img :src="p.img" style="object-fit: scale-down" height="60"/>
          </div>
          <div class="row mt-3 justify-content-center">
            {{p.description}}
          </div>
          <div class="row mt-3 justify-content-center">
            <base-button class="button-wide" v-on:click="goToIntegrationSetup(p)" type="info" >Set up integration</base-button>
          </div>
        </card>
      </div>
    </div>

    <div class="row" v-if="gateway_configured">
      <div class="col">
        <card card-body-classes="table-full-width" style="word-break: break-word">
          <div class="row mb-3">
            <div class="col">
              <tab-rail :tabs="categories" :value="activeTabIndex" @input="switchTab" />
            </div>
          </div>

<!-- Taxes-->
          <div v-if="activeTabIndex === 2">
            <div class="row">
              <div class="col">
                <base-button v-if="!create_new_tax" size="sm" v-on:click="create_new_tax = true" type="primary">
                  <i class="tim-icons icon-simple-add mr-2"></i>
                  Create new tax</base-button>
              </div>
            </div>

            <div class="mt-3" v-if="taxes.length <= 0 && !create_new_tax">
              <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
                <h4 class="mt-3">No taxes have been created.</h4>
              </div>
            </div>
            <div v-if="create_new_tax">
              <div class="row">
                <div class="col-lg-4">
                  <p class="text-uppercase card-title">Tax details</p>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-5" style="min-width: 300px">
                  <base-input required :error="errs.tax_title" label="Title" type="text" placeholder="Example - Sales tax" v-model="tax_title"></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-5" style="min-width: 150px">
                  <base-input label="Tax number" type="text" placeholder="123456" v-model="tax_number"></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3" style="min-width: 200px">
                  <base-input required label="Value type" :error="errs.value_type">
                    <el-select
                      v-model="value_type"
                      class="select-primary"
                      v-on:change="changeTaxAmount(value_type)"
                      placeholder="Value type"
                      value-key="id"
                    >
                      <el-option
                        v-for="option in valueTypesTaxes"
                        class="select-primary"
                        :label="option.value_id === 4 ? option.name + ' (Recommended)' : option.name"
                        :value="{id: option.id, name: option.name, value_id: option.value_id}"
                        :key="'B' + option.id"
                      >
                        <span>{{ option.name }}</span>
                        <span v-if="option.value_id === 4" class="recommended-badge">Recommended</span>
                      </el-option>
                    </el-select>
                  </base-input>
                </div>
                <div class="col-lg-2">
                  <base-input required :error="errs.tax_amount" :label="tax_amount_label" type="number" placeholder="0.00">
                    <el-input-number :controls="false" v-model="tax_amount" :min="0" :precision="value_type && (value_type.value_id === 2 || value_type.value_id === 4) ? tax_amount_precision : 2"/>
                  </base-input>
                </div>
                <div class="col-lg-2" v-if="value_type && (value_type.value_id === 2 || value_type.value_id === 4)">
                  <base-input required :error="errs.tax_amount_precision" label="Decimal precision (0-5)" placeholder="2" v-model.number="tax_amount_precision">
                    <el-input-number :controls="false" v-model="tax_amount_precision" :min="0" :max="5" :precision="0"/>
                  </base-input>
                </div>
              </div>
              <div class="row mb-2" v-if="value_type">
                <div class="col">
                  <p class="small">
                    <i class="tim-icons el-icon-info"></i>
                    <span v-if="value_type.value_id === 0">
                      Applies a fixed tax amount once per transaction. Not itemized in line-item reporting.
                    </span>
                    <span v-if="value_type.value_id === 3">
                      Applies a fixed tax amount to each line item individually. Reflected in line-item reporting.
                    </span>
                    <span v-if="value_type.value_id === 1">
                      Applies a fixed tax amount per unit of quantity purchased. Reflected in line-item reporting for associated items. In case of bookings, quantity refers to group size.
                    </span>
                    <span v-if="value_type.value_id === 2">
                      Applies a percentage-based tax to the total transaction amount. Not itemized in line-item reporting.
                    </span>
                    <span v-if="value_type.value_id === 4">
                      Applies a percentage-based tax to each line item individually. Reflected in line-item reporting.
                    </span>
                  </p>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4">
                  <p class="text-uppercase card-title">Tax application</p>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <el-switch active-color="#e14eca"
                             v-model="apply_to_all_items"
                             :disabled="value_type && (value_type.value_id === 0 || value_type.value_id === 2)" />
                  <label> &nbsp; Apply tax to all taxable purchases (excludes gift cards)</label>
                </div>
              </div>

              <div class="row mt-2" v-if="!apply_to_all_items">
                <div class="col-lg-5">
                  <base-input label="Taxable items">
                    <el-select
                      v-model="selected_purchasable_items"
                      class="select-primary"
                      multiple
                      clearable
                      placeholder="Taxable items"
                      value-key="uid"
                    >
                      <el-option
                        v-for="(item, index) in purchasable_items_taxes"
                        class="select-primary"
                        :label="item.name"
                        :value="{id: item.id, name: item.name, item_type: item.item_type, uid: item.uid}"
                        :key="'A' + index"
                      ></el-option>
                    </el-select>
                  </base-input>
                  <base-button style="padding: 0px 0px 0px 0px" link type="primary" v-on:click="addAllPurchaseTypes(purchasable_items_taxes, 'game')">
                    <i class="tim-icons icon-simple-add mr-1"></i> Add all games</base-button>
                  <base-button class="ml-3" style="padding: 0px 0px 0px 0px" link type="primary" v-on:click="addAllPurchaseTypes(purchasable_items_taxes, 'item')">
                    <i class="tim-icons icon-simple-add mr-1"></i> Add all items</base-button>
                </div>
              </div>


              <div class="row mt-3">
                <div class="col-lg-4">
                  <p class="text-uppercase card-title">Tax calculation</p>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-5">
                  <base-input required label="Tax application type" :error="errs.pricing_type">
                    <el-select
                      v-model="pricing_type"
                      class="select-primary"
                      name="game"
                      placeholder="Tax application type"
                      value-key="id"
                    >
                      <el-option
                        v-for="option in pricingTypes"
                        class="select-primary"
                        :label="option.name"
                        :value="{id: option.id, name: option.name}"
                        :key="'A' + option.id"
                      ></el-option>
                    </el-select>
                  </base-input>
                </div>
              </div>

              <div class="row" v-if="pricing_type.hasOwnProperty('id') && pricing_type.id === 1">
                <div class="col">
                  <el-switch active-color="#e14eca"
                             v-model="show_tax_line_items"  />
                  <label> &nbsp; Show tax as a line item on customer-facing invoices and checkout</label>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <el-switch active-color="#e14eca"
                             v-model="is_compound_tax"  />
                  <label> &nbsp; This is a compound tax (calculated on top of the subtotal and any other tax totals)</label>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <el-switch active-color="#e14eca"
                             v-model="optional_tax"  />
                  <label> &nbsp; This tax is optional (will not be automatically applied to transactions)</label>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <el-switch active-color="#e14eca"
                             v-model="apply_after_discount"  />
                  <label> &nbsp; Apply tax after promotions and discounts</label>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col">
                  <base-button type="default" v-on:click="cancelTaxCreation()">Cancel</base-button>
                  <base-button v-if="selectedTaxId" v-on:click="editTax()" class="ml-2" type="primary">Update</base-button>
                  <base-button v-else v-on:click="createTax()" class="ml-2" type="primary">Create</base-button>
                </div>
              </div>

            </div>


            <div class="row" v-if="!create_new_tax">
<!--              Desktop-->
              <div class="col d-none d-sm-block">
                <b-table v-if="taxes.length > 0" :items="taxes"
                         :fields="['title', 'tax_application_type', 'value_type', 'amount', 'applicable_to', 'active', 'compound', 'optional', 'applied_after_discount', 'actions']">
                  <template v-slot:cell(title)="row">
                    <p class="text-white">{{ row.item.name }}</p>
                    <small v-if="row.item.tax_number">#{{row.item.tax_number}}</small>
                  </template>
                  <template v-slot:cell(tax_application_type)="row">
                    <badge type="info" v-if="row.item.pricing_type === 1">inclusive</badge>
                    <badge type="default" v-if="row.item.pricing_type === 0">exclusive</badge>
                  </template>
                  <template v-slot:cell(applicable_to)="row">
                    <el-tooltip effect="light"
                                :open-delay="300"
                                placement="bottom-end">
                      <template #content>
                        <div style="max-width: 200px; white-space: normal;">
                          {{ getLinks(row.item.linked_games) }}
                        </div>
                      </template>
                      <badge style="cursor: pointer;" class="ml-2" v-if="!row.item.apply_to_all_items && JSON.parse(row.item.linked_games).length > 0" type="default">games </badge>
                    </el-tooltip>
                    <el-tooltip
                      effect="light"
                      :open-delay="300"
                      placement="bottom-end">
                      <template #content>
                        <div style="max-width: 200px; white-space: normal;">
                          {{ getLinks(row.item.linked_items) }}
                        </div>
                      </template>
                      <badge style="cursor: pointer;" class="ml-2" v-if="!row.item.apply_to_all_items && JSON.parse(row.item.linked_items).length > 0" type="default">merchandise</badge>
                    </el-tooltip>
                    <badge class="ml-2" v-if="row.item.apply_to_all_items" type="default">all purchases</badge>
                    <span v-if="(!row.item.apply_to_all_items && (JSON.parse(row.item.linked_games).length <= 0)
                      && (JSON.parse(row.item.linked_items).length <= 0))">-</span>
                  </template>
                  <template v-slot:cell(value_type)="row">
                    <p class="text-white">{{ getValueType(row.item.value_type) }}</p>
                  </template>
                  <template v-slot:cell(amount)="row">
                    <p class="text-white">{{ getAmount(row.item.value_type, row.item.amount, 'tax', row.item.tax_amount_precision) }}</p>
                  </template>
                  <template v-slot:cell(compound)="row">
                    <i v-if="row.item.is_compound" class="text-success tim-icons icon-check-2"></i>
                    <i v-if="!row.item.is_compound" class="text-danger tim-icons icon-simple-remove"></i>
                  </template>
                  <template v-slot:cell(optional)="row">
                    <i v-if="row.item.optional" class="text-success tim-icons icon-check-2"></i>
                    <i v-if="!row.item.optional" class="text-danger tim-icons icon-simple-remove"></i>
                  </template>
                  <template v-slot:cell(applied_after_discount)="row">
                    <i v-if="row.item.apply_after_discount" class="text-success tim-icons icon-check-2"></i>
                    <i v-if="!row.item.apply_after_discount" class="text-danger tim-icons icon-simple-remove"></i>
                  </template>
                  <template v-slot:cell(active)="row">
                    <i v-if="row.item.is_active" class="text-success tim-icons icon-check-2"></i>
                    <i v-if="!row.item.is_active" class="text-danger tim-icons icon-simple-remove"></i>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <el-dropdown>
                      <base-button
                        link
                        type="primary"
                        size="sm"
                      > <i style="font-size: large" class="tim-icons el-icon-more"></i>
                      </base-button>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <a class="dropdown-item mt-1 mb-2"  href="#" v-on:click="editTaxPrompt(row.item, $event)">
                            <i class="tim-icons text-warning icon-pencil mr-2"></i> Edit tax
                          </a>
                          <a v-if="!row.item.is_active"
                             class="dropdown-item mt-1 mb-2" href="#" v-on:click="toggleActivationPrompt(row.item, $event)">
                            <span style="padding-left: 0px; padding-bottom: 0px; margin-left: -3px; margin-bottom: -3px" class="active-dot mr-2"></span> Activate tax
                          </a>
                          <a v-if="row.item.is_active"
                             class="dropdown-item mt-1 mb-2" href="#" v-on:click="toggleActivationPrompt(row.item, $event)">
                            <span style="padding-left: 0px; padding-bottom: 0px; margin-left: -3px; margin-bottom: -3px" class="inactive-dot mr-2"></span> Deactivate tax
                          </a>
                          <hr>
                          <a v-on:click="deleteTax(row.item.id, $event)" class="dropdown-item mt-1 mb-2" target="_blank">
                            <i class="tim-icons text-danger icon-trash-simple mr-2"></i> Delete tax
                          </a>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </template>
                </b-table>
              </div>

<!--              Mobile-->
              <div class="col d-block d-sm-none">
                <b-table v-if="taxes.length > 0" :items="taxes" :fields="['taxes']">
                  <template v-slot:cell(taxes)="row">
                    <div class="row">
                      <div class="col">
                        <h4 class="card-title">{{ row.item.name }}</h4>
                      </div>
                      <div class="col text-right">
                        <badge type="success" class="ml-2" v-if="row.item.is_active">active</badge>
                        <badge type="danger" class="ml-2" v-if="!row.item.is_active">deactivated</badge>
                        <badge type="warning" class="ml-2" v-if="row.item.is_compound">compound</badge>
                        <badge type="info" class="ml-2" v-if="row.item.optional">optional</badge>
                      </div>
                    </div>

                    <div>Tax application type:
                      <badge type="info" v-if="row.item.pricing_type === 1">inclusive</badge>
                      <badge type="default" v-if="row.item.pricing_type === 0">exclusive</badge>
                    </div>
                    <div>Value type: {{ getValueType(row.item.value_type) }}</div>
                    <div>Amount: {{ getAmount(row.item.value_type, row.item.amount, 'tax', row.item.tax_amount_precision) }}</div>
                    <div
                      class="btn-group btn-group-toggle mt-3"
                      :class="'float-left'"
                      data-toggle="buttons" style="width:100%; max-width: 100%"
                    >
                      <label class="btn btn-sm btn-primary btn-simple">
                        <base-button style="padding-left: 0; padding-right: 0"
                                     @click="deleteTax(row.item.id)"
                                     simple
                                     type="primary"
                                     link
                        > <i class="tim-icons icon-trash-simple"></i>
                        </base-button>
                      </label>
                      <label class="btn btn-sm btn-primary btn-simple">
                        <base-button style="padding-left: 0; padding-right: 0"
                                     @click="editTaxPrompt(row.item)"
                                     simple
                                     type="primary"
                                     link
                        > <i class="tim-icons icon-pencil"></i>
                        </base-button>
                      </label>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>

<!--          Fees-->
          <div v-if="activeTabIndex === 3">
            <div class="row">
              <div class="col">
                <base-button v-if="!create_new_fee" size="sm" v-on:click="clearFeeFields()" type="primary">
                  <i class="tim-icons icon-simple-add mr-2"></i>
                  Create new fee</base-button>
              </div>
            </div>


            <div class="mt-3" v-if="fees.length <= 0 && !create_new_fee">
              <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
                <h4 class="mt-3">No fees have been created.</h4>
              </div>
            </div>

            <div v-if="create_new_fee">
              <div class="row">
                <div class="col-lg-4">
                  <p class="text-uppercase card-title">Fee details</p>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-5">
                  <base-input :error="errs.fee_title" label="Title" type="text" placeholder="Example - Service fee" v-model="fee.title"></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3">
                  <base-input label="Value type" :error="errs.fee_value_type">
                    <el-select
                      v-model="value_type"
                      class="select-primary"
                      v-on:change="changeTaxAmount(value_type)"
                      name="game"
                      placeholder="Value type"
                      value-key="id"
                    >
                      <el-option
                        v-for="option in valueTypesTaxes"
                        class="select-primary"
                        :label="option.value_id === 4 ? option.name + ' (Recommended)' : option.name"
                        :value="{id: option.id, name: option.name, value_id: option.value_id}"
                        :key="'B' + option.id"
                      >
                        <span>{{ option.name }}</span>
                        <span v-if="option.value_id === 4" class="recommended-badge">Recommended</span>
                      </el-option>
                    </el-select>
                  </base-input>
                </div>
                <div class="col-lg-2">
                  <base-input required :error="errs.fee_value" :label="tax_amount_label" type="number" placeholder="0.00">
                    <el-input-number :controls="false" v-model="fee.amount" :min="0" :precision="value_type && (value_type.value_id === 2 || value_type.value_id === 4) ? fee.amount_precision : 2"/>
                  </base-input>
                </div>
                <div class="col-lg-2" v-if="value_type && (value_type.value_id === 2 || value_type.value_id === 4)">
                  <base-input label="Decimal precision (0-5)" placeholder="2" v-model.number="fee.amount_precision">
                    <el-input-number :controls="false" v-model="fee.amount_precision" :min="0" :max="5" :precision="0"/>
                  </base-input>
                </div>
              </div>

              <div class="row mb-2" v-if="value_type">
                <div class="col">
                  <p class="small">
                    <i class="tim-icons el-icon-info"></i>
                    <span v-if="value_type.value_id === 0">
                      Applies a fixed fee amount once per transaction. Not itemized in line-item reporting.
                    </span>
                    <span v-if="value_type.value_id === 3">
                      Applies a fixed fee amount to each line item individually. Reflected in line-item reporting.
                    </span>
                    <span v-if="value_type.value_id === 1">
                      Applies a fixed fee amount per unit of quantity purchased. Reflected in line-item reporting for associated items. In case of bookings, quantity refers to group size.
                    </span>
                    <span v-if="value_type.value_id === 2">
                      Applies a percentage-based fee to the total transaction amount. Not itemized in line-item reporting.
                    </span>
                    <span v-if="value_type.value_id === 4">
                      Applies a percentage-based fee to each line item individually. Reflected in line-item reporting.
                    </span>
                  </p>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4">
                  <p class="text-uppercase card-title">Fee application</p>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <el-switch active-color="#e14eca" :disabled="value_type && (value_type.value_id === 0 || value_type.value_id === 2)"
                             v-model="apply_to_all_items"  />
                  <label> &nbsp; Apply fee to all purchases</label>
                </div>
              </div>

              <div class="row mt-2" v-if="!apply_to_all_items">
                <div class="col-lg-5">
                  <base-input label="Items">
                    <el-select
                      v-model="selected_purchasable_items"
                      class="select-primary"
                      multiple
                      clearable
                      placeholder="Items"
                      value-key="uid"
                    >
                      <el-option
                        v-for="(item, index) in purchasable_items_fees"
                        class="select-primary"
                        :label="item.name"
                        :value="{id: item.id, name: item.name, item_type: item.item_type, uid: item.uid}"
                        :key="'A' + index"
                      ></el-option>
                    </el-select>
                  </base-input>
                  <base-button style="padding: 0px 0px 0px 0px" link type="primary" v-on:click="addAllPurchaseTypes(purchasable_items_fees, 'game')">
                    <i class="tim-icons icon-simple-add mr-1"></i> Add all games</base-button>
                  <base-button class="ml-3" style="padding: 0px 0px 0px 0px" link type="primary" v-on:click="addAllPurchaseTypes(purchasable_items_fees, 'item')">
                    <i class="tim-icons icon-simple-add mr-1"></i> Add all items</base-button>
                  <base-button class="ml-3" style="padding: 0px 0px 0px 0px" link type="primary" v-on:click="addAllPurchaseTypes(purchasable_items_fees, 'gift_card_type')">
                    <i class="tim-icons icon-simple-add mr-1"></i> Add all gift card types</base-button>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-lg-4">
                  <p class="text-uppercase card-title">Fee calculation</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <el-switch active-color="#e14eca"
                             v-model="optional_fee"  />
                  <label> &nbsp; This fee is optional (will not be automatically applied to transactions)</label>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col">
                  <el-switch active-color="#e14eca"
                             v-model="covered_by_promo_codes"  />
                  <label> &nbsp; Apply fee after promotions and discounts</label>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <base-button type="default" v-on:click="cancelFeeCreation()">Cancel</base-button>
                  <base-button v-if="selectedFeeId" class="ml-2" type="primary" @click="editFee()">Update</base-button>
                  <base-button v-else v-on:click="createFee()" class="ml-2" type="primary">Create</base-button>
                </div>
              </div>
            </div>

            <div class="row" v-if="!create_new_fee">
<!--              Desktop-->
              <div class="col d-none d-sm-block">
                <b-table v-if="fees.length > 0" :items="fees"
                         :fields="['title', 'value_type', 'amount', 'applicable_to', 'active', 'optional','applied_after_discount', 'actions']">
                  <template v-slot:cell(title)="row">
                    <p class="text-white">{{ row.item.name }}</p>
                  </template>
                  <template v-slot:cell(value_type)="row">
                    <p class="text-white">{{ getValueType(row.item.value_type) }}</p>
                  </template>
                  <template v-slot:cell(applicable_to)="row">
                    <el-tooltip effect="light"
                                :open-delay="300"
                                placement="bottom-end">
                      <template #content>
                        <div style="max-width: 200px; white-space: normal;">
                          {{ getLinks(row.item.linked_games) }}
                        </div>
                      </template>
                      <badge style="cursor: pointer;" class="ml-2" v-if="!row.item.apply_to_all_items && JSON.parse(row.item.linked_games).length > 0" type="default">games </badge>
                    </el-tooltip>
                    <el-tooltip effect="light"
                                :open-delay="300"
                                placement="bottom-end">
                      <template #content>
                        <div style="max-width: 200px; white-space: normal;">
                          {{ getLinks(row.item.linked_gift_card_types) }}
                        </div>
                      </template>
                      <badge style="cursor: pointer;" class="ml-2" v-if="!row.item.apply_to_all_items && JSON.parse(row.item.linked_gift_card_types).length > 0" type="default">gift cards</badge>
                    </el-tooltip>
                    <el-tooltip
                      effect="light"
                      :open-delay="300"
                      placement="bottom-end">
                      <template #content>
                        <div style="max-width: 200px; white-space: normal;">
                          {{ getLinks(row.item.linked_items) }}
                        </div>
                      </template>
                      <badge style="cursor: pointer;" class="ml-2" v-if="!row.item.apply_to_all_items && JSON.parse(row.item.linked_items).length > 0" type="default">merchandise</badge>
                    </el-tooltip>
                    <badge class="ml-2" v-if="row.item.apply_to_all_items" type="default">all purchases</badge>
                    <span v-if="(!row.item.apply_to_all_items && (JSON.parse(row.item.linked_games).length <= 0)
                      && (JSON.parse(row.item.linked_gift_card_types).length <= 0)
                      && (JSON.parse(row.item.linked_items).length <= 0))">-</span>
                  </template>
                  <template v-slot:cell(amount)="row">
                    <p class="text-white">{{ getAmount(row.item.value_type, row.item.amount, 'fee', row.item.amount_precision) }}</p>
                  </template>
                  <template v-slot:cell(optional)="row">
                    <i v-if="row.item.optional" class="text-success tim-icons icon-check-2"></i>
                    <i v-if="!row.item.optional" class="text-danger tim-icons icon-simple-remove"></i>
                  </template>
                  <template v-slot:cell(applied_after_discount)="row">
                    <i v-if="row.item.covered_by_promo_codes" class="text-success tim-icons icon-check-2"></i>
                    <i v-if="!row.item.covered_by_promo_codes" class="text-danger tim-icons icon-simple-remove"></i>
                  </template>
                  <template v-slot:cell(active)="row">
                    <i v-if="row.item.is_active" class="text-success tim-icons icon-check-2"></i>
                    <i v-if="!row.item.is_active" class="text-danger tim-icons icon-simple-remove"></i>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <el-dropdown>
                      <base-button
                        link
                        type="primary"
                        size="sm"
                      > <i style="font-size: large" class="tim-icons el-icon-more"></i>
                      </base-button>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <a class="dropdown-item mt-1 mb-2"  href="#" v-on:click="editFeePrompt(row.item, $event)">
                            <i class="tim-icons text-warning icon-pencil mr-2"></i> Edit fee
                          </a>
                          <a v-if="!row.item.is_active"
                             class="dropdown-item mt-1 mb-2" href="#" v-on:click="toggleActivationFeePrompt(row.item, $event)">
                            <span style="padding-left: 0px; padding-bottom: 0px; margin-left: -3px; margin-bottom: -3px" class="active-dot mr-2"></span> Activate fee
                          </a>
                          <a v-if="row.item.is_active"
                             class="dropdown-item mt-1 mb-2" href="#" v-on:click="toggleActivationFeePrompt(row.item, $event)">
                            <span style="padding-left: 0px; padding-bottom: 0px; margin-left: -3px; margin-bottom: -3px" class="inactive-dot mr-2"></span> Deactivate fee
                          </a>
                          <hr>
                          <a v-on:click="deleteFee(row.item.id, $event)" class="dropdown-item mt-1 mb-2" target="_blank">
                            <i class="tim-icons text-danger icon-trash-simple mr-2"></i> Delete fee
                          </a>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </template>
                </b-table>
              </div>
<!--              Mobile-->
              <div class="col d-block d-sm-none">
                <b-table v-if="fees.length > 0" :items="fees" :fields="['fees']">
                  <template v-slot:cell(fees)="row">
                    <div class="row">
                      <div class="col">
                        <h4 class="card-title">{{ row.item.name }}</h4>
                      </div>
                      <div class="col text-right">
                        <badge type="success" v-if="row.item.is_active" class="ml-2">active</badge>
                        <badge type="danger" v-if="!row.item.is_active" class="ml-2">deactivated</badge>
                        <badge type="info" v-if="row.item.optional" class="ml-2">optional</badge>
                      </div>
                    </div>
                    <div>Value type: {{ getValueType(row.item.value_type) }}</div>
                    <div>Amount: {{ getAmount(row.item.value_type, row.item.amount, 'fee', row.item.amount_precision) }}</div>
                    <div
                      class="btn-group btn-group-toggle mt-3"
                      :class="'float-left'"
                      data-toggle="buttons" style="width:100%; max-width: 100%"
                    >
                      <label class="btn btn-sm btn-primary btn-simple">
                        <base-button style="padding-left: 0; padding-right: 0"
                                     @click="deleteFee(row.item.id)"
                                     simple
                                     type="primary"
                                     link
                        > <i class="tim-icons icon-trash-simple"></i>
                        </base-button>
                      </label>
                      <label class="btn btn-sm btn-primary btn-simple">
                        <base-button style="padding-left: 0; padding-right: 0"
                                     @click="editFeePrompt(row.item)"
                                     simple
                                     type="primary"
                                     link
                        > <i class="tim-icons icon-pencil"></i>
                        </base-button>
                      </label>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
<!--          General settings-->
          <div v-if="activeTabIndex === 0">
            <div class="row">
              <div class="col">
                <p class="card-title text-uppercase">Payments</p>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <el-switch active-color="#e14eca"
                           v-model="payment_settings.allow_pay_on_arrival" />
                <label class="text-white"> &nbsp; Allow pay on arrival</label>
              </div>
            </div>
            <div class="row" v-if="payment_settings.allow_pay_on_arrival">
              <div class="col">
                <el-switch active-color="#e14eca"
                           v-model="payment_settings.enable_pay_on_arrival_text" />
                <label class="text-white"> &nbsp; Enable custom "Pay on arrival" text
                  <el-popover trigger="hover"
                              placement="right">

                    <div>
                      <div class="popover-body">The text customers will see on your booking site.</div>
                    </div>
                    <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                  </el-popover>
                </label>
              </div>
            </div>
            <div class="row" v-if="payment_settings.enable_pay_on_arrival_text">
              <div class="col-lg-4">
                <label class="text-white mt-1">Pay on arrival text</label>
                <base-input :error="errs.pay_on_arrival_text" v-model="payment_settings.pay_on_arrival_text"></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <el-switch active-color="#e14eca"
                           v-model="payment_settings.allow_gift_card_purchase_on_gift_card" />
                <label class="text-white"> &nbsp; Allow gift card purchases using Gift Card payment method</label>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4">
                <label class="text-white">Request to book payment
                  <el-popover trigger="hover"
                              placement="right">

                    <div>
                      <div class="popover-body">How payment is handled when a customer submits <br/>
                        a booking request on requestable slots. <br/>
                        Charge at request captures payment immediately <br/>
                        and refunds automatically if the request is denied. <br/>
                        Request payment after approval collects no payment at checkout; <br/>
                        a payment request email is sent once staff approve.</div>
                    </div>
                    <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                  </el-popover>
                </label>
                <base-input>
                  <el-select
                    v-model="payment_settings.request_to_book_payment_mode"
                    class="select-primary"
                  >
                    <el-option class="select-primary" label="Charge at request" value="charge_now"></el-option>
                    <el-option class="select-primary" label="Request payment after approval" value="on_approval"></el-option>
                  </el-select>
                </base-input>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col">
                <p class="card-title text-uppercase">Invoices</p>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-3">
                <label class="text-white">Address source
                  <el-popover trigger="hover"
                              placement="right">

                    <div>
                      <div class="popover-body">The address you would like to be used in invoices. <br/>
                        Choose between your main company address or the <br/>address of location of the booking.</div>
                    </div>
                    <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                  </el-popover>
                </label>
                <base-input>
                  <el-select
                    v-model="payment_settings.invoices_address_source"
                    class="select-primary"
                    name="payment_layout"
                    placeholder="Address source"
                  >
                    <el-option
                      v-for="(ias, i) in invoices_address_sources"
                      class="select-primary"
                      :label="capitalizeFirstLetter(ias)"
                      :value="ias"
                      :key="'ias' + i"
                    ></el-option>
                  </el-select>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4">
                <el-switch active-color="#e14eca"
                           v-model="payment_settings.invoice_show_custom_fields" />
                <label class="text-white"> &nbsp; Include custom fields
                  <el-popover trigger="hover"
                              placement="right">

                    <div>
                      <div class="popover-body">If the customer filled out custom fields during the payment process, <br/>responses will be included in the invoice.</div>
                    </div>
                    <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                  </el-popover>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4">
                <el-switch active-color="#e14eca"
                           v-model="payment_settings.invoice_list_payments" />
                <label class="text-white"> &nbsp; List payments
                  <el-popover trigger="hover"
                              placement="right">

                    <div>
                      <div class="popover-body">If enabled, will include granular payment details on invoices.</div>
                    </div>
                    <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                  </el-popover>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4">
                <el-switch active-color="#e14eca"
                           v-model="payment_settings.invoice_show_ticket_categories" />
                <label class="text-white"> &nbsp; Show ticket categories
                  <el-popover trigger="hover"
                              placement="right">

                    <div>
                      <div class="popover-body">Lists the number of participants in each ticket category <br/>for every booking on the invoice.</div>
                    </div>
                    <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                  </el-popover>
                </label>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col">
                <p class="card-title text-uppercase">Tips</p>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-3">
                <el-switch active-color="#e14eca"
                           v-model="payment_settings.allow_tipping" />
                <label class="text-white"> &nbsp; Allow tipping</label>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-lg-3" v-if="payment_settings.allow_tipping">
                <base-input label="Tip field label" v-model="payment_settings.tip_label">
                </base-input>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-lg-3" v-if="payment_settings.allow_tipping">
                <base-input label="Tip line item label" v-model="payment_settings.tip_line_item_label">
                </base-input>
              </div>
            </div>
            <div class="row" v-if="payment_settings.allow_tipping">
              <div class="col">
                <el-switch active-color="#e14eca"
                           v-model="payment_settings.allow_custom_tipping_options" />
                <label class="text-white"> &nbsp; Allow arbitrary tipping values</label>
              </div>
            </div>
            <div class="row mt-2" v-if="payment_settings.allow_tipping && payment_settings.allow_custom_tipping_options">
              <div class="col-lg-3" >
                <base-input label="Value type">
                  <el-select
                    v-model="payment_settings.custom_tipping_value_type"
                    class="select-primary"
                    name="tipping_value_type"
                    value-key="id"
                  >
                    <el-option
                      v-for="(v, index) in valueTypesTipping"
                      class="select-primary"
                      :label="v.name"
                      :value="{id: v.id, name: v.name}"
                      :key="'V' + index"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>
            </div>

            <div class="row" v-if="payment_settings.allow_tipping">
              <div class="col">
                <el-switch active-color="#e14eca"
                           v-model="payment_settings.allow_preset_tipping_options" />
                <label class="text-white"> &nbsp; Show preset tipping options</label>
              </div>
            </div>

            <div class="row mt-2" v-if="payment_settings.allow_tipping && payment_settings.allow_preset_tipping_options">
              <div class="col">
                <base-button size="sm" v-on:click="addTipPresetValue()" type="primary">
                  <i class="tim-icons icon-simple-add mr-2"> </i> Add tipping option</base-button>
              </div>
            </div>
            <div class="row mt-2" v-if="payment_settings.allow_tipping && payment_settings.allow_preset_tipping_options && tip_preset_values.length > 0">
              <div class="col-lg-6">
                <div style="border: 1px solid #ffffff;
                      border-radius: 7px !important; padding-top: 15px; padding-left: 15px; padding-right: 15px;">
                  <table class='table' v-if="payment_methods.length > 0">
                    <thead>
                    <tr>
                      <th scope='col'></th>
                      <th scope='col'>Label</th>
                      <th scope='col'>Value</th>
                      <th scope='col'>Actions</th>
                    </tr>
                    </thead>
                    <tbody tag='tbody' v-model='tip_preset_values' is='draggable'>
                    <tr  v-for='(item, index) in tip_preset_values' :key="'TPV' + index">
                      <td scope='row'>
                        <i style="cursor: move" class="tim-icons el-icon-rank"></i>
                      </td>
                      <td scope='row'>
                        <div class="row" >
                          <div class="col">
                            <p class="text-white">{{item.name}}</p>
                          </div>
                        </div>
                      </td>
                      <td scope='row'>
                        <div class="row" >
                          <div class="col">
                            {{getAmount(item.value_type.value_id, item.amount, 'tip')}}
                          </div>
                        </div>
                      </td>
                      <td scope='row'>
                        <div>
                          <el-dropdown>
                            <base-button
                              link
                              type="primary"
                              size="sm"
                            > <i style="font-size: large" class="tim-icons el-icon-more"></i>
                            </base-button>
                            <template #dropdown>
                              <el-dropdown-menu>
                                <a class="dropdown-item" @click="editTipOption(item, index)" href="#">
                                  <i class="tim-icons text-warning icon-pencil mr-2"></i> Edit tip option
                                </a>
                                <hr/>
                                <a class="dropdown-item" @click="deleteTipOption(item, index)" href="#">
                                  <i class="tim-icons text-danger icon-trash-simple mr-2"></i> Delete tip option
                                </a>
                              </el-dropdown-menu>
                            </template>
                          </el-dropdown>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <modal :show.sync="modals.add_tip_option"
                   body-classes="p-0"
                   modal-classes="modal-dialog-centered">
              <card type="secondary"
                    header-classes="bg-white pb-5"
                    body-classes="px-lg-5 py-lg-5"
                    class="border-0 mb-0">

                <h4 v-if="!selectedTipOption.editing">Create a tip option</h4>
                <h4 v-if="selectedTipOption.editing">Edit tip option</h4>

                <div class="row" >
                  <div class="col">
                    <base-input :error="errs.tip_option_name" label="Label (optional)" type="text" placeholder="Value 1" v-model="selectedTipOption.name"></base-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <base-input label="Value type">
                      <el-select
                        v-model="selectedTipOption.value_type"
                        class="select-primary"
                        name="game"
                        placeholder="Pricing type"
                        value-key="id"
                      >
                        <el-option
                          v-for="(option, index) in valueTypesTipping"
                          class="select-primary"
                          :label="option.name"
                          :value="{id: option.id, name: option.name}"
                          :key="'VT' + index"
                        ></el-option>
                      </el-select>
                    </base-input>
                  </div>
                  <div class="col" v-if="selectedTipOption.hasOwnProperty('value_type')">
                    <label v-if="selectedTipOption.value_type.id === 0">Value (%)</label>
                    <label v-if="selectedTipOption.value_type.id === 1">Value ({{currency_symbol}}) </label>
                    <base-input :error="errs.tip_amount" placeholder="0.00" v-model.number="selectedTipOption.amount"></base-input>
                  </div>
                </div>
                <div class="row justify-content-center mt-3">
                  <div class="col text-center">
                    <base-button type="secondary" @click="cancelTipCreation()">Cancel</base-button>
                    <base-button v-if="!selectedTipOption.editing" class="ml-3" type="primary" @click="createTip()">Save</base-button>
                    <base-button v-if="selectedTipOption.editing" class="ml-3" type="primary" @click="saveTip()">Save</base-button>
                  </div>
                </div>
              </card>
            </modal>

            <div class="row mt-4">
              <div class="col">
                <p class="card-title text-uppercase">Payment requests</p>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <el-switch active-color="#e14eca"
                           v-model="payment_settings.payment_request_allow_custom_amounts" />
                <label class="text-white"> &nbsp; Allow custom payment amounts</label>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <el-switch active-color="#e14eca"
                           v-model="payment_settings.show_promo_code_field" />
                <label class="text-white"> &nbsp; Show promo code field</label>
              </div>
            </div>
            <div class="row" v-if="payment_settings.show_promo_code_field">
              <div class="col">
                <el-switch active-color="#e14eca"
                           v-model="payment_settings.show_custom_promo_code_error_message"  />
                <label class="text-white"> &nbsp; Show custom error message for invalid promos</label>
              </div>
            </div>
            <div class="row mt-1" v-if="payment_settings.show_custom_promo_code_error_message">
              <div class="col-lg-4">
                <label class="text-white">Invalid promo code error message</label>
                <base-input placeholder="Promo code invalid" v-model="payment_settings.promo_code_error_message">
                </base-input>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <el-switch active-color="#e14eca"
                           v-model="payment_settings.payment_request_has_timeout" />
                <label class="text-white"> &nbsp; Enable payment request expiration
                  <el-popover trigger="hover"
                              placement="right">

                    <div>
                      <div class="popover-body">This setting defines the threshold after which transactions and all <br>related bookings will be cancelled if not paid.</div>
                    </div>
                    <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                  </el-popover>
                </label>
              </div>
            </div>
            <div v-if="payment_settings.payment_request_has_timeout">
              <label>Payment request timeout</label>
              <div class="row">
                <div class="col-lg-3">
                  <div class="d-flex align-items-center">
                    <base-input style="width: 100px; margin-right: 10px;" v-model.number="payment_settings.payment_request_timeout_value"></base-input>
                    <base-input style="flex: 1;">
                      <el-select
                        label="Select period"
                        v-model="payment_settings.payment_request_timeout_period"
                        class="select-primary"
                        value-key="id"
                      >
                        <el-option
                          v-for="(rp, index) in request_periods"
                          class="select-primary"
                          :label="rp.label"
                          :value="{id: rp.id, label: rp.label}"
                          :key="'RPX' + index"
                        ></el-option>
                      </el-select>
                    </base-input>
                  </div>

                </div>
              </div>
              <label>Expires when the following percentage of the total has not been paid (%)</label>
              <div class="row">
                <div class="col-lg-4">
                  <base-input style="width: 100px" :error="errs.payment_request_threshold" v-model.number="payment_settings.payment_request_threshold"></base-input>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-button type="primary" @click="savePaymentRequestSettings()">Save settings</base-button>
              </div>
            </div>
          </div>

          <!--          Payment methods-->
          <div v-if="activeTabIndex === 1">
            <div class="row">
              <div class="col-lg-6">
                <base-button size="sm" type="primary" v-on:click="createCustomPaymentPrompt()">
                  <i class="tim-icons icon-simple-add mr-2"></i> Add custom payment method</base-button>
              </div>
            </div>

            <div class="row mt-2 mb-3">
              <div class="col">
                <!--                <label>Supported payment methods</label>-->
                <div style="border: 1px solid #ffffff;
                      border-radius: 7px !important; padding-top: 15px; padding-left: 15px; padding-right: 15px;">
                  <table class='table' v-if="payment_methods.length > 0">
                    <thead>
                    <tr>
                      <th scope='col'></th>
                      <th scope='col'>Supported payment methods</th>
                      <th scope='col'>Available on internal payments</th>
                      <th scope='col'>Available on booking site</th>
                      <th scope='col'>Actions</th>
                    </tr>
                    </thead>
                    <tbody tag='tbody' v-model='payment_methods' is='draggable'>
                    <tr v-on:dragend="updatePaymentMethodOrder()" v-for='(item, index) in payment_methods' :key="'G' + index">
                      <td scope='row'>
                        <i style="cursor: move" class="tim-icons el-icon-rank"></i>
                      </td>
                      <td scope='row'>
                        <div class="row" >
                          <div class="col">
                            <p class="text-white">{{item.name}}
                              <badge v-if="item.is_default" class="ml-2">default</badge>
                            </p>
                          </div>
                        </div>
                      </td>
                      <!--                      <td scope='row'>-->
                      <!--                        <div class="row" >-->
                      <!--                          <div class="col">-->
                      <!--                            <badge type="success" v-if="item.status">active</badge>-->
                      <!--                            <badge type="danger" v-if="!item.status">deactivated</badge>-->
                      <!--                          </div>-->
                      <!--                        </div>-->
                      <!--                      </td>-->
                      <td scope='row'>
                        <div class="row" >
                          <div class="col">
                            <i class="tim-icons icon-check-2 text-success" v-if="item.enabled_internally"></i>
                            <i class="tim-icons icon-simple-remove text-danger" v-if="!item.enabled_internally"></i>
                          </div>
                        </div>
                      </td>
                      <td scope='row'>
                        <div class="row" >
                          <div class="col">
                            <i class="tim-icons icon-check-2 text-success" v-if="item.enabled_externally"></i>
                            <i class="tim-icons icon-simple-remove text-danger" v-if="!item.enabled_externally"></i>
                          </div>
                        </div>
                      </td>
                      <td scope='row'>
                        <div>
                          <el-dropdown>
                            <base-button
                              link
                              type="primary"
                              size="sm"
                            > <i style="font-size: large" class="tim-icons el-icon-more"></i>
                            </base-button>
                            <template #dropdown>
                              <el-dropdown-menu>
                                <a v-if="item.is_default === 0"
                                   class="dropdown-item mt-1 mb-2"  href="#" v-on:click.prevent="editPaymentMethod(item)">
                                  <i class="tim-icons text-warning icon-pencil mr-2"></i> Edit payment method
                                </a>
                                <a v-if="item.enabled_internally === 0"
                                   class="dropdown-item mt-1 mb-2"  href="#" v-on:click.prevent="togglePaymentMethodActivation(item, 'activate_internal', 'activated on internal payments')">
                                  <span style="padding-left: 0px; padding-bottom: 0px; margin-left: -3px; margin-bottom: -3px" class="active-dot mr-2"></span> Activate on internal payments
                                </a>
                                <a v-if="item.enabled_internally === 1"
                                   class="dropdown-item mt-1 mb-2"  href="#" v-on:click.prevent="togglePaymentMethodActivation(item, 'deactivate_internal', 'deactivated on internal payments')">
                                  <span style="padding-left: 0px; padding-bottom: 0px; margin-left: -3px; margin-bottom: -3px" class="inactive-dot mr-2"></span> Deactivate on internal payments
                                </a>
                                <a v-if="item.enabled_externally === 0 && allowExternally(item)"
                                   class="dropdown-item mt-1 mb-2"  href="#" v-on:click="togglePaymentMethodActivation(item, 'activate_external', 'activated on booking site')">
                                  <span style="padding-left: 0px; padding-bottom: 0px; margin-left: -3px; margin-bottom: -3px" class="active-dot mr-2"></span> Activate on booking site
                                </a>
                                <a v-if="item.enabled_externally === 1"
                                   class="dropdown-item mt-1 mb-2"  href="#" v-on:click.prevent="togglePaymentMethodActivation(item, 'deactivate_external', 'deactivated on booking site')">
                                  <span style="padding-left: 0px; padding-bottom: 0px; margin-left: -3px; margin-bottom: -3px" class="inactive-dot mr-2"></span> Deactivate on booking site
                                </a>
                                <hr v-if="item.is_default === 0">
                                <a v-on:click.prevent="deletePaymentMethod(item)" v-if="item.is_default === 0" class="dropdown-item mt-1 mb-2" target="_blank">
                                  <i class="tim-icons text-danger icon-trash-simple mr-2"></i> Delete payment method
                                </a>
                              </el-dropdown-menu>
                            </template>
                          </el-dropdown>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-3">
                <base-input label="Payment method layout">
                  <el-select
                    v-model="payment_settings.payment_layout_type"
                    class="select-primary"
                    name="payment_layout"
                    placeholder="Payment method layout"
                  >
                    <el-option
                      v-for="(plt, i) in payment_layout_types"
                      class="select-primary"
                      :label="capitalizeFirstLetter(plt)"
                      :value="plt"
                      :key="'PLT' + i"
                    ></el-option>
                  </el-select>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-button type="primary" @click="savePaymentRequestSettings()">Save settings</base-button>
              </div>
            </div>
          </div>

<!--          Payment gateways-->
          <div v-if="activeTabIndex === 4">
            <!-- Remaining legacy gateways (Yappy) use the ORIGINAL
                 2-column row pattern — left column has the label +
                 description, right column has the gateway logo card +
                 Change/Setup button.
                 Stripe, Square, Authorize.net, and Paystack get the
                 dedicated 2-column layout further down: gateway identity
                 on the left, pill sub-nav on the right. -->
            <div class="row mb-5 mt-5" v-if="!payment_gateway || (payment_gateway.id !== 3 && payment_gateway.id !== 2 && payment_gateway.id !== 1 && payment_gateway.id !== 4)">
              <div class="col-3 d-sm-block d-none">
                <p class="text-primary" style="font-size: medium">Payment gateway</p>
                <p v-if="payment_gateway && payment_gateway.id === 1">Refer to Authorize.net's <a href="https://support.authorize.net/knowledgebase/Knowledgearticle/?code=000001271" target="_blank">documentation</a>
                  for instructions on where to find your API credentials.</p>
                <p v-if="payment_gateway && payment_gateway.id === 2">Refer to Square's <a href="https://developer.squareup.com/docs/build-basics/access-tokens" target="_blank">documentation</a>
                  for instructions on where to find your API credentials.</p>
                <p v-if="payment_gateway && payment_gateway.id === 4">Refer to Paystack's <a href="https://support.paystack.com/hc/en-us/articles/360011508199-How-do-I-generate-new-API-keys" target="_blank">documentation</a>
                  for instructions on where to find your API credentials.</p>
                <p v-if="payment_gateway && payment_gateway.id === 5">Refer to Yappy's <a href="https://www.bgeneral.com/desarrolladores/boton-de-pago-yappy/activacion-del-boton-de-pago-yappy/" target="_blank">documentation</a>
                  for instructions on where to find your API credentials.</p>
              </div>
              <div class="col d-sm-none d-block">
                <label>Payment gateway</label>
              </div>
              <div class="col-lg-9">
                <div class="row" v-if="payment_gateway">
                  <div class="col-lg-2">
                    <card class="card-white">
                      <div class="row justify-content-center">
                        <img style="object-fit: scale-down" height="40" :src="payment_gateway.img">
                      </div>
                    </card>
                  </div>
                </div>
                <div class="row" v-if="payment_gateway">
                  <div class="col">
                    <base-button type="primary" size="sm" v-on:click="changePaymentGateway()">Change payment gateway</base-button>
                  </div>
                </div>
                <div class="row" v-else>
                  <div class="col">
                    <base-button type="primary" size="sm" v-on:click="setUpPaymentGateway()">
                      <i class="tim-icons icon-simple-add mr-1"></i> Set up payment gateway</base-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- ═══ Authorize.net configuration: left-rail identity + right-column
                 credential panels, mirroring the Stripe/Square layout. Reuses the
                 stripe-rail / stripe-creds-block classes and the generic
                 test_credentials / live_credentials state + updateCredentials
                 methods; no AuthNet-specific CSS. ═══ -->
            <div v-if="payment_gateway && payment_gateway.id === 1" class="stripe-layout row">
              <!-- LEFT RAIL: gateway identity -->
              <div class="col-lg-3 col-md-4 stripe-layout__rail">
                <div class="stripe-rail">
                  <p class="stripe-rail__eyebrow">Active gateway</p>
                  <div class="stripe-rail__logo">
                    <img :src="payment_gateway.img" :alt="payment_gateway.name" />
                    <span
                      class="stripe-rail__logo-badge"
                      :class="`stripe-rail__logo-badge--${railStatus.tone}`"
                    >
                      {{ railStatus.label }}
                    </span>
                  </div>
                  <p class="stripe-rail__name">{{ payment_gateway.name }}</p>

                  <div class="text-left" v-if="authnetTdStatus === 'off' || authnetTdStatus === 'unknown'">
                    <info-hint variant="primary">
                      <template v-if="authnetTdStatus === 'off'">
                        Enable the Transaction Details API in the Authorize.net account so
                        interrupted payments can be verified automatically. On the classic
                        Merchant Interface it is under <strong>Account</strong>, then
                        <strong>Settings</strong>, then <strong>Security Settings</strong>,
                        then <strong>Transaction Details API</strong>. If the account's
                        interface has no such setting, Authorize.net support can enable it.
                      </template>
                      <template v-else>
                        We could not confirm whether the Transaction Details API is enabled
                        on the Authorize.net account.
                      </template>
                      Saving the credentials here again re-checks it.
                    </info-hint>
                  </div>

                  <button
                    type="button"
                    class="stripe-rail__change"
                    @click="changePaymentGateway()"
                  >
                    <i class="tim-icons icon-refresh-01"></i>
                    Change gateway
                  </button>
                </div>
              </div>

              <!-- RIGHT COLUMN: credential panels + guidance -->
              <div class="col-lg-9 col-md-8 stripe-layout__main">
                <collapsible-section
                  title="API credentials"
                  icon="tim-icons icon-key-25"
                  :badge="live_credentials.api_name ? 'Live ready' : 'Live not set'"
                  :default-open="true"
                  class="stripe-section"
                >
                  <info-hint variant="primary">
                    Authorize.net provides an <strong>API Login ID</strong> and
                    <strong>Transaction Key</strong> per environment: test for
                    sandbox payments and live for real transactions. Live
                    credentials are required to take real payments. See
                    <a href="https://support.authorize.net/knowledgebase/Knowledgearticle/?code=000001271" target="_blank">Authorize.net's documentation</a>
                    for where to find them.
                  </info-hint>

                  <!-- Test credentials -->
                  <div class="stripe-creds-block">
                    <div class="stripe-creds-block__head">
                      <h5 class="stripe-creds-block__title">Test credentials</h5>
                      <badge type="success" v-if="test_credentials.is_active">active</badge>
                      <badge type="danger" v-else>inactive</badge>
                    </div>
                    <div v-if="!test_credentials.api_name">
                      <div v-if="!edit_test_creds" class="stripe-empty">
                        <div class="stripe-empty__icon"><i class="tim-icons icon-bulb-63"></i></div>
                        <p class="stripe-empty__title">Test credentials not set</p>
                        <p class="stripe-empty__hint">
                          Optional but recommended. Lets you run end-to-end booking + checkout flows in Authorize.net's sandbox with fake cards before going live.
                        </p>
                        <base-button v-on:click="editTestCreds()" type="primary" size="sm">
                          <i class="tim-icons icon-simple-add mr-1"></i> Add test credentials
                        </base-button>
                      </div>
                      <div v-else>
                        <div class="row" :key="'anA' + j">
                          <div class="col-lg-8">
                            <label>{{api_name}} <span class="text-danger">*</span></label>
                            <base-input v-on:change="j++" :error="err.test_credentials.api_name" v-model="test_credentials.api_name_edit"></base-input>
                          </div>
                        </div>
                        <div class="row" :key="'anB' + j">
                          <div class="col-lg-8">
                            <label>{{api_key}} <span class="text-danger">*</span></label>
                            <base-input v-on:change="j++" :error="err.test_credentials.api_key" :placeholder="test_credentials.has_api_key ? 'Enter the secret key again to save' : ''" v-model="test_credentials.api_key_edit"></base-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-8">
                            <base-button class="mr-2" v-on:click="edit_test_creds = false" type="default" size="sm">Cancel</base-button>
                            <base-button v-on:click="updateCredentials('test', 2)" type="primary" size="sm">Save</base-button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="row">
                        <div class="col-lg-8">
                          <label>{{api_name}} <span class="text-danger">*</span></label>
                          <p v-if="!edit_test_creds">{{test_credentials.api_name}}</p>
                          <base-input v-else :error="err.test_credentials.api_name" v-model="test_credentials.api_name_edit"></base-input>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-8">
                          <label>{{api_key}} <span class="text-danger">*</span></label>
                          <p v-if="!edit_test_creds">••••••••••••••••••••••••••••••</p>
                          <base-input v-else :error="err.test_credentials.api_key" :placeholder="test_credentials.has_api_key ? 'Enter the secret key again to save' : ''" v-model="test_credentials.api_key_edit"></base-input>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-8">
                          <span v-if="edit_test_creds">
                            <base-button class="mr-2" v-on:click="edit_test_creds = false" type="default" size="sm">Cancel</base-button>
                            <base-button v-on:click="updateCredentials('test', 2)" type="primary" size="sm">Save</base-button>
                          </span>
                          <span v-else>
                            <base-button v-on:click="editTestCreds()" type="primary" size="sm">
                              <i class="tim-icons icon-pencil mr-1"></i> Edit
                            </base-button>
                            <base-button class="ml-2" v-if="!test_credentials.is_active" v-on:click="updateCredentials('test', 1)" link type="primary" size="sm">Activate</base-button>
                            <base-button class="ml-2" v-if="test_credentials.is_active" v-on:click="updateCredentials('test', 0)" link type="primary" size="sm">Deactivate</base-button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Live credentials -->
                  <div class="stripe-creds-block mt-4">
                    <div class="stripe-creds-block__head">
                      <h5 class="stripe-creds-block__title">Live credentials</h5>
                      <badge type="success" v-if="live_credentials.is_active">active</badge>
                      <badge type="danger" v-else>inactive</badge>
                    </div>
                    <div v-if="!live_credentials.api_name">
                      <div v-if="!edit_live_creds" class="stripe-empty stripe-empty--required">
                        <div class="stripe-empty__icon"><i class="tim-icons icon-key-25"></i></div>
                        <p class="stripe-empty__title">Live credentials not set</p>
                        <p class="stripe-empty__hint">
                          Required to process real payments. Find the live API Login ID and Transaction Key in the Authorize.net Merchant Interface under Account, then Settings, then API Credentials and Keys.
                        </p>
                        <base-button v-on:click="editLiveCreds()" type="primary" size="sm">
                          <i class="tim-icons icon-simple-add mr-1"></i> Add live credentials
                        </base-button>
                      </div>
                      <div v-else>
                        <div class="row" :key="'anE' + j">
                          <div class="col-lg-8">
                            <label>{{api_name}} <span class="text-danger">*</span></label>
                            <base-input v-on:change="j++" :error="err.live_credentials.api_name" v-model="live_credentials.api_name_edit"></base-input>
                          </div>
                        </div>
                        <div class="row" :key="'anF' + j">
                          <div class="col-lg-8">
                            <label>{{api_key}} <span class="text-danger">*</span></label>
                            <base-input v-on:change="j++" :error="err.live_credentials.api_key" :placeholder="live_credentials.has_api_key ? 'Enter the secret key again to save' : ''" v-model="live_credentials.api_key_edit"></base-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-8">
                            <base-button class="mr-2" v-on:click="edit_live_creds = false" type="default" size="sm">Cancel</base-button>
                            <base-button v-on:click="updateCredentials('live', 2)" type="primary" size="sm">Save</base-button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="row">
                        <div class="col-lg-8">
                          <label>{{api_name}} <span class="text-danger">*</span></label>
                          <p v-if="!edit_live_creds">{{live_credentials.api_name}}</p>
                          <base-input v-else :error="err.live_credentials.api_name" v-model="live_credentials.api_name_edit"></base-input>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-8">
                          <label>{{api_key}} <span class="text-danger">*</span></label>
                          <p v-if="!edit_live_creds">••••••••••••••••••••••••••••••</p>
                          <base-input v-else :error="err.live_credentials.api_key" :placeholder="live_credentials.has_api_key ? 'Enter the secret key again to save' : ''" v-model="live_credentials.api_key_edit"></base-input>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-8">
                          <span v-if="edit_live_creds">
                            <base-button class="mr-2" v-on:click="edit_live_creds = false" type="default" size="sm">Cancel</base-button>
                            <base-button v-on:click="updateCredentials('live', 2)" type="primary" size="sm">Save</base-button>
                          </span>
                          <span v-else>
                            <base-button v-on:click="editLiveCreds()" type="primary" size="sm">
                              <i class="tim-icons icon-pencil mr-1"></i> Edit
                            </base-button>
                            <base-button class="ml-2" v-if="!live_credentials.is_active" v-on:click="updateCredentials('live', 1)" link type="primary" size="sm">Activate</base-button>
                            <base-button class="ml-2" v-if="live_credentials.is_active" v-on:click="updateCredentials('live', 0)" link type="primary" size="sm">Deactivate</base-button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </collapsible-section>

                <collapsible-section
                  title="Fraud filter guidance"
                  icon="tim-icons icon-alert-circle-exc"
                  :default-open="false"
                  class="stripe-section"
                >
                  <info-hint variant="primary">
                    Authorize.net's fraud filters can decline valid cards. In the Authorize.net
                    Merchant Interface under <strong>Account</strong>, then <strong>Settings</strong>,
                    the address verification and card code filters decide when a mismatch declines
                    a charge. Strict settings decline customers whose billing zip or security code
                    can't be verified, and each rejected attempt can leave a temporary hold on the
                    customer's card. Recommended: decline only on genuine mismatches, not on
                    unprocessed or unavailable results. See
                    <a href="https://support.authorize.net/knowledgebase/Knowledgearticle/?code=000001778" target="_blank">Authorize.net's filter documentation</a>.
                  </info-hint>
                </collapsible-section>
              </div>
            </div>

            <!-- ═══ Stripe configuration: left-rail identity + right-column
                 pill sub-nav. Only renders when Stripe is the active gateway.
                 Non-Stripe gateways use the legacy 2-column credentials block
                 further down. ═══ -->
            <div v-if="payment_gateway && payment_gateway.id === 3" class="stripe-layout row">
              <!-- LEFT RAIL: gateway identity -->
              <div class="col-lg-3 col-md-4 stripe-layout__rail">
                <div class="stripe-rail">
                  <p class="stripe-rail__eyebrow">Active gateway</p>
                  <div class="stripe-rail__logo">
                    <img :src="payment_gateway.img" :alt="payment_gateway.name" />
                    <span
                      class="stripe-rail__logo-badge"
                      :class="`stripe-rail__logo-badge--${railStatus.tone}`"
                    >
                      {{ railStatus.label }}
                    </span>
                  </div>
                  <p class="stripe-rail__name">{{ payment_gateway.name }}</p>

                  <div class="text-left">
                    <info-hint variant="primary">
                      Handles online checkout (booking site, payment
                      requests) and in-person Tap to Pay + smart-reader
                      (S700, S710) payments. Work through the pills to
                      wire up credentials, webhook, policies, and hardware.
                    </info-hint>
                  </div>

                  <button
                    type="button"
                    class="stripe-rail__change"
                    @click="changePaymentGateway()"
                  >
                    <i class="tim-icons icon-refresh-01"></i>
                    Change gateway
                  </button>
                </div>
              </div>

              <!-- RIGHT COLUMN: pill nav + active pill panel. Each pill
                   carries its own status indicator (✓ for ok, ! for
                   incomplete, count for hardware) so there's no separate
                   status row above. -->
              <div class="col-lg-9 col-md-8 stripe-layout__main">
                <!-- Rail placeholder until the connection state is known: the pill set depends on it. -->
                <nav v-if="!stripeConnectLoaded" class="stripe-pills" aria-hidden="true">
                  <span v-for="n in 3" :key="`pill-skel-${n}`" class="skel skel--chip"></span>
                </nav>
                <nav v-else class="stripe-pills">
                  <button
                    v-for="p in stripePills"
                    :key="p.id"
                    type="button"
                    class="stripe-pill"
                    :class="{
                      'stripe-pill--active': activeStripePill === p.id,
                      [`stripe-pill--${stripePillStatus[p.id]}`]: true,
                    }"
                    @click="setStripePill(p.id)"
                  >
                    <i :class="p.icon" class="stripe-pill__icon"></i>
                    <span class="stripe-pill__label">{{ p.label }}</span>
                    <span
                      v-if="p.id === 'hardware' || stripePillStatus[p.id] !== 'neutral'"
                      class="stripe-pill__status"
                    >
                      <template v-if="p.id === 'hardware'">
                        <span class="stripe-pill__count">{{ readers.length }}</span>
                      </template>
                      <template v-else-if="stripePillStatus[p.id] === 'ok'">
                        <i class="tim-icons icon-check-2"></i>
                      </template>
                      <template v-else-if="stripePillStatus[p.id] === 'incomplete'">
                        <i class="tim-icons icon-alert-circle-exc"></i>
                      </template>
                    </span>
                  </button>
                </nav>

                <!-- Active pill panel ──────────────────────────────── -->
                <div v-if="stripeConnectLoaded" class="stripe-panel">

            <collapsible-section
              v-if="payment_gateway.id === 3 && activeStripePill === 'connect'"
              title="Stripe connection"
              icon="tim-icons icon-link-72"
              :badge="stripeConnectBadge"
              :default-open="true"
              class="stripe-section stripe-section--in-pill"
            >
                <!-- Not connected: one status strip with the primary action; the platform-control
                     consent is the confirm dialog that opens on click (connectStripe). -->
                <div v-if="!stripeConnected">
                  <div class="sq-connected__meta">
                    <div class="sq-connected__row sq-connected__row--text">
                      <span class="sq-connected__label">Payouts</span>
                      <span class="sq-connected__value sq-connected__value--text">Unchanged, straight to your own Stripe account.</span>
                    </div>
                    <div class="sq-connected__row sq-connected__row--text">
                      <span class="sq-connected__label">Setup</span>
                      <span class="sq-connected__value sq-connected__value--text">Nothing to paste or rotate. Webhooks are handled for you.</span>
                    </div>
                    <div class="sq-connected__row sq-connected__row--text">
                      <span class="sq-connected__label">Readers</span>
                      <span class="sq-connected__value sq-connected__value--text">The point of sale app is installed and kept up to date for you.</span>
                    </div>
                    <div v-if="stripeConnect.state === 'disconnected'" class="sq-connected__row sq-connected__row--text">
                      <span class="sq-connected__label">Previous account</span>
                      <span class="sq-connected__value">{{ stripeConnect.account_id }}</span>
                    </div>
                  </div>
                  <p class="text-white">You will sign in to Stripe, pick the account, and come straight back here. About a minute.</p>
                  <base-button type="primary" size="sm" class="mb-3" :disabled="stripeConnecting" @click="connectStripe('oauth')">
                    <i v-if="stripeConnecting" class="el-icon-loading mr-1"></i>
                    <i v-else class="tim-icons icon-link-72 mr-1"></i>
                    Connect Stripe account
                  </base-button>
                  <div class="neutral-action-row">
                    <div class="neutral-action-info">
                      <span class="neutral-action-label">No Stripe account yet?</span>
                      <span class="neutral-action-hint">Off The Couch creates one for this venue and Stripe walks you through setup.</span>
                    </div>
                    <base-button size="sm" class="neutral-action-btn" :disabled="stripeConnecting" @click="connectStripe('create')">Create account</base-button>
                  </div>
                </div>

                <div v-else-if="stripeConnect.state === 'onboarding'">
                  <info-hint variant="warning" icon="icon-alert-circle-exc">
                    Stripe still needs details before {{ stripeConnect.account_id }} can take payments.
                    <template #action>
                      <base-button type="primary" size="sm" :disabled="stripeConnecting" @click="connectStripe('create')">
                        <i v-if="stripeConnecting" class="el-icon-loading mr-1"></i>
                        Continue onboarding
                      </base-button>
                    </template>
                  </info-hint>
                  <div class="sq-connected__meta">
                    <div class="sq-connected__row">
                      <span class="sq-connected__label">Charges</span>
                      <span class="sq-connected__value">Not yet enabled</span>
                    </div>
                    <div class="sq-connected__row">
                      <span class="sq-connected__label">Platform control</span>
                      <span class="sq-connected__value">{{ stripeConnect.platform_controlled === 1 ? 'Enabled' : 'Pending review by Stripe' }}</span>
                    </div>
                  </div>
                  <div class="neutral-action-row">
                    <div class="neutral-action-info">
                      <span class="neutral-action-label">Disconnect Stripe</span>
                      <span class="neutral-action-hint">Ends the connection for this venue.</span>
                    </div>
                    <base-button size="sm" class="neutral-action-btn" @click="disconnectStripe()">Disconnect</base-button>
                  </div>
                </div>

                <div v-else>
                  <info-hint v-if="stripeTestModeOn" variant="warning" icon="icon-alert-circle-exc">
                    Test mode is on. Customers and staff cannot make real payments on this venue, card readers come from your Stripe test location and take test taps only, and payments show in your Stripe dashboard under Test mode. Use card 4242 4242 4242 4242 with any future date and any CVC.
                  </info-hint>
                  <div v-if="stripeTestModeAvailable" class="mb-3">
                    <el-switch active-color="#e14eca"
                               :value="stripeTestModeOn"
                               :disabled="stripeTestModeSaving"
                               @change="setStripeTestMode" />
                    <label class="text-white"> &nbsp; Test mode
                      <el-popover trigger="hover"
                                  placement="right">

                        <div>
                          <div class="popover-body">Runs payments on this venue in Stripe test mode through the same connected account. Turn it off to take real payments again.</div>
                        </div>
                        <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                      </el-popover>
                    </label>
                  </div>
                  <div class="sq-connected__meta">
                    <div class="sq-connected__row">
                      <span class="sq-connected__label">Account</span>
                      <span class="sq-connected__value">{{ stripeConnect.account_id }}</span>
                    </div>
                    <div class="sq-connected__row">
                      <span class="sq-connected__label">Charges</span>
                      <span class="sq-connected__value">{{ stripeConnect.charges_enabled === 1 ? 'Enabled' : 'Not yet enabled' }}</span>
                    </div>
                    <div class="sq-connected__row">
                      <span class="sq-connected__label">Platform control</span>
                      <span class="sq-connected__value">{{ stripeConnect.platform_controlled === 1 ? 'Enabled' : 'Pending review by Stripe' }}</span>
                    </div>
                    <div v-if="stripeConnect.connected_at" class="sq-connected__row">
                      <span class="sq-connected__label">Connected</span>
                      <span class="sq-connected__value">{{ getDate(stripeConnect.connected_at) }}</span>
                    </div>
                  </div>
                  <div v-if="!stripeTestModeOn" class="neutral-action-row">
                    <div class="neutral-action-info">
                      <span class="neutral-action-label">Disconnect Stripe</span>
                      <span class="neutral-action-hint">{{ stripeConnect.has_api_key ? 'Payments switch back to the API keys saved on this page.' : 'Card payments stop on this venue until you reconnect or add API keys.' }}</span>
                    </div>
                    <base-button size="sm" class="neutral-action-btn" @click="disconnectStripe()">Disconnect</base-button>
                  </div>
                  <div v-else class="neutral-action-row">
                    <div class="neutral-action-info">
                      <span class="neutral-action-label">Disconnect Stripe</span>
                      <span class="neutral-action-hint">Turn off test mode first.</span>
                    </div>
                  </div>
                </div>
            </collapsible-section>

            <collapsible-section
              v-if="payment_gateway.id === 3 && activeStripePill === 'credentials' && showStripeCredentialsPill && !stripeConnected"
              title="API credentials"
              icon="tim-icons icon-key-25"
              :badge="live_credentials.api_name ? 'Live ready' : 'Live not set'"
              :default-open="true"
              class="stripe-section stripe-section--in-pill"
            >
              <info-hint variant="primary">
                Stripe provides two key pairs: <strong>test</strong> for
                sandbox payments and <strong>live</strong> for real
                transactions. Live credentials are required to take real
                payments. Test credentials are optional but recommended so
                you can validate the integration before going live. Find
                both in
                <a href="https://docs.stripe.com/keys" target="_blank">Stripe's API keys</a>.
              </info-hint>

              <!-- Test credentials: hidden while connected through Stripe Connect in test mode (OTC test group only) -->
              <template v-if="!stripeConnectedTest">
              <!-- Test credentials -->
              <div class="stripe-creds-block">
                <div class="stripe-creds-block__head">
                  <h5 class="stripe-creds-block__title">Test credentials</h5>
                  <badge type="success" v-if="test_credentials.is_active">active</badge>
                  <badge type="danger" v-else>inactive</badge>
                </div>
                <div v-if="!test_credentials.api_name">
                  <div v-if="!edit_test_creds" class="stripe-empty">
                    <div class="stripe-empty__icon"><i class="tim-icons icon-bulb-63"></i></div>
                    <p class="stripe-empty__title">Test credentials not set</p>
                    <p class="stripe-empty__hint">
                      Optional but recommended. Lets you run end-to-end booking + checkout flows in Stripe's sandbox with fake cards before going live.
                    </p>
                    <base-button v-on:click="editTestCreds()" type="primary" size="sm">
                      <i class="tim-icons icon-simple-add mr-1"></i> Add test credentials
                    </base-button>
                  </div>
                  <div v-else>
                    <div class="row" :key="'sA' + j">
                      <div class="col-lg-8">
                        <label>{{api_name}} <span class="text-danger">*</span></label>
                        <base-input v-on:change="j++" :error="err.test_credentials.api_name" v-model="test_credentials.api_name_edit"></base-input>
                      </div>
                    </div>
                    <div class="row" :key="'sB' + j">
                      <div class="col-lg-8">
                        <label>{{api_key}} <span class="text-danger">*</span></label>
                        <base-input v-on:change="j++" :error="err.test_credentials.api_key" :placeholder="test_credentials.has_api_key ? 'Enter the secret key again to save' : ''" v-model="test_credentials.api_key_edit"></base-input>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-8">
                        <base-button class="mr-2" v-on:click="edit_test_creds = false" type="default" size="sm">Cancel</base-button>
                        <base-button v-on:click="updateCredentials('test', 2)" type="primary" size="sm">Save</base-button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="row">
                    <div class="col-lg-8">
                      <label>{{api_name}} <span class="text-danger">*</span></label>
                      <p v-if="!edit_test_creds">{{test_credentials.api_name}}</p>
                      <base-input v-else :error="err.test_credentials.api_name" v-model="test_credentials.api_name_edit"></base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-8">
                      <label>{{api_key}} <span class="text-danger">*</span></label>
                      <p v-if="!edit_test_creds">••••••••••••••••••••••••••••••</p>
                      <base-input v-else :error="err.test_credentials.api_key" :placeholder="test_credentials.has_api_key ? 'Enter the secret key again to save' : ''" v-model="test_credentials.api_key_edit"></base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-8">
                      <span v-if="edit_test_creds">
                        <base-button class="mr-2" v-on:click="edit_test_creds = false" type="default" size="sm">Cancel</base-button>
                        <base-button v-on:click="updateCredentials('test', 2)" type="primary" size="sm">Save</base-button>
                      </span>
                      <span v-else>
                        <base-button v-on:click="editTestCreds()" type="primary" size="sm">
                          <i class="tim-icons icon-pencil mr-1"></i> Edit
                        </base-button>
                        <base-button class="ml-2" v-if="!test_credentials.is_active" v-on:click="updateCredentials('test', 1)" link type="primary" size="sm">Activate</base-button>
                        <base-button class="ml-2" v-if="test_credentials.is_active" v-on:click="updateCredentials('test', 0)" link type="primary" size="sm">Deactivate</base-button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              </template>

              <!-- Live credentials: hidden while connected through Stripe Connect in live mode -->
              <template v-if="!stripeConnectedLive">
              <!-- Live credentials -->
              <div class="stripe-creds-block mt-4">
                <div class="stripe-creds-block__head">
                  <h5 class="stripe-creds-block__title">Live credentials</h5>
                  <badge type="success" v-if="live_credentials.is_active">active</badge>
                  <badge type="danger" v-else>inactive</badge>
                </div>
                <div v-if="!live_credentials.api_name">
                  <div v-if="!edit_live_creds" class="stripe-empty stripe-empty--required">
                    <div class="stripe-empty__icon"><i class="tim-icons icon-key-25"></i></div>
                    <p class="stripe-empty__title">Live credentials not set</p>
                    <p class="stripe-empty__hint">
                      Required to process real payments. Find your live publishable + secret keys in
                      <a href="https://dashboard.stripe.com/apikeys" target="_blank">Stripe's API keys</a>.
                    </p>
                    <base-button v-on:click="editLiveCreds()" type="primary" size="sm">
                      <i class="tim-icons icon-simple-add mr-1"></i> Add live credentials
                    </base-button>
                  </div>
                  <div v-else>
                    <div class="row" :key="'sE' + j">
                      <div class="col-lg-8">
                        <label>{{api_name}} <span class="text-danger">*</span></label>
                        <base-input v-on:change="j++" :error="err.live_credentials.api_name" v-model="live_credentials.api_name_edit"></base-input>
                      </div>
                    </div>
                    <div class="row" :key="'sF' + j">
                      <div class="col-lg-8">
                        <label>{{api_key}} <span class="text-danger">*</span></label>
                        <base-input v-on:change="j++" :error="err.live_credentials.api_key" :placeholder="live_credentials.has_api_key ? 'Enter the secret key again to save' : ''" v-model="live_credentials.api_key_edit"></base-input>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-8">
                        <base-button class="mr-2" v-on:click="edit_live_creds = false" type="default" size="sm">Cancel</base-button>
                        <base-button v-on:click="updateCredentials('live', 2)" type="primary" size="sm">Save</base-button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="row">
                    <div class="col-lg-8">
                      <label>{{api_name}} <span class="text-danger">*</span></label>
                      <p v-if="!edit_live_creds">{{live_credentials.api_name}}</p>
                      <base-input v-else :error="err.live_credentials.api_name" v-model="live_credentials.api_name_edit"></base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-8">
                      <label>{{api_key}} <span class="text-danger">*</span></label>
                      <p v-if="!edit_live_creds">••••••••••••••••••••••••••••••</p>
                      <base-input v-else :error="err.live_credentials.api_key" :placeholder="live_credentials.has_api_key ? 'Enter the secret key again to save' : ''" v-model="live_credentials.api_key_edit"></base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-8">
                      <span v-if="edit_live_creds">
                        <base-button class="mr-2" v-on:click="edit_live_creds = false" type="default" size="sm">Cancel</base-button>
                        <base-button v-on:click="updateCredentials('live', 2)" type="primary" size="sm">Save</base-button>
                      </span>
                      <span v-else>
                        <base-button v-on:click="editLiveCreds()" type="primary" size="sm">
                          <i class="tim-icons icon-pencil mr-1"></i> Edit
                        </base-button>
                        <base-button class="ml-2" v-if="!live_credentials.is_active" v-on:click="updateCredentials('live', 1)" link type="primary" size="sm">Activate</base-button>
                        <base-button class="ml-2" v-if="live_credentials.is_active" v-on:click="updateCredentials('live', 0)" link type="primary" size="sm">Deactivate</base-button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              </template>
              <div v-else class="stripe-creds-block mt-4">
                <div class="stripe-creds-block__head">
                  <h5 class="stripe-creds-block__title">Live credentials</h5>
                </div>
                <info-hint variant="neutral">
                  This venue is connected through Stripe Connect. Live API keys are not used while connected.
                </info-hint>
              </div>
            </collapsible-section>

            <collapsible-section
              v-if="payment_gateway.id === 3 && activeStripePill === 'webhook' && !stripeConnected"
              title="Webhook"
              icon="tim-icons icon-cloud-download-93"
              :badge="webhook_secret ? 'Configured' : 'Not set'"
              :default-open="true"
              class="stripe-section stripe-section--in-pill"
            >
              <info-hint variant="primary">
                Stripe sends payment events to Off The Couch through a webhook.
                Off The Couch creates the webhook in your Stripe account when
                you save your secret key. Use the manual steps below only if
                your key cannot create webhooks or you prefer to manage the
                endpoint yourself.
              </info-hint>

              <div v-if="activeStripeWebhook && activeStripeWebhook.endpoint_id" class="webhook-block">
                <h5 class="webhook-block__title">Managed endpoint</h5>
                <p class="webhook-block__sub">
                  Off The Couch created this endpoint in your {{ activeStripeWebhookMode }} Stripe account.
                  <badge type="success" v-if="activeStripeWebhook.status === 'enabled'">enabled</badge>
                  <badge type="danger" v-else-if="activeStripeWebhook.status === 'disabled'">disabled</badge>
                  <badge type="default" v-else>status unknown</badge>
                </p>
                <info-hint v-if="activeStripeWebhook.status === 'disabled'" variant="warning" icon="icon-alert-circle-exc">
                  Stripe turned this endpoint off after repeated delivery failures.
                  Save your secret key again on the Credentials tab to create a
                  fresh endpoint, or re-enable it in Stripe's webhook settings.
                </info-hint>
              </div>

              <!-- Endpoint URL -->
              <div class="webhook-block">
                <h5 class="webhook-block__title">Manual setup: endpoint URL</h5>
                <p class="webhook-block__sub">
                  Add this URL to your Stripe account and have it listen to all
                  <code>payment_intent</code> events.
                </p>
                <div class="webhook-url">
                  <code class="webhook-url__value">https://api.offthecouch.io/stripe-webhook</code>
                  <button
                    type="button"
                    class="webhook-url__copy"
                    title="Copy URL"
                    aria-label="Copy URL"
                    v-on:click="copy('https://api.offthecouch.io/stripe-webhook')"
                  >
                    <i class="tim-icons el-icon-copy-document"></i>
                  </button>
                </div>
              </div>

              <!-- Signing secret -->
              <div class="webhook-block mt-4">
                <h5 class="webhook-block__title">Manual setup: signing secret</h5>
                <p class="webhook-block__sub">
                  After creating the endpoint, copy its signing secret from
                  <a href="https://dashboard.stripe.com/webhooks" target="_blank">Stripe's webhook settings</a>
                  and paste it here. Enables signature verification.
                </p>
                <div class="row">
                  <div class="col-lg-8">
                    <div v-if="!webhook_secret && !edit_webhook_secret" class="stripe-empty">
                      <div class="stripe-empty__icon"><i class="tim-icons icon-lock-circle"></i></div>
                      <p class="stripe-empty__title">Signing secret not set</p>
                      <p class="stripe-empty__hint">
                        Webhooks still work without it, but Stripe-side
                        signature verification is disabled. Strongly
                        recommended for production.
                      </p>
                      <base-button v-on:click="editWebhookSecret()" type="primary" size="sm">
                        <i class="tim-icons icon-simple-add mr-1"></i> Add signing secret
                      </base-button>
                    </div>

                    <div v-else-if="webhook_secret && !edit_webhook_secret">
                      <label>Signing secret</label>
                      <p>••••••••••••••••••••••••••••••</p>
                      <small class="text-success">
                        <i class="tim-icons icon-check-2"></i> Signature verification enabled
                      </small>
                      <div class="mt-2">
                        <base-button v-on:click="editWebhookSecret()" type="primary" size="sm">
                          <i class="tim-icons icon-pencil mr-1"></i> Edit
                        </base-button>
                        <base-button v-on:click="removeWebhookSecret()" link type="primary" size="sm" class="ml-2">
                          Remove
                        </base-button>
                      </div>
                    </div>

                    <div v-else-if="edit_webhook_secret">
                      <label>Webhook endpoint secret</label>
                      <base-input
                        :error="errs.webhook_secret"
                        v-model="webhook_secret_edit"
                        type="password"
                        placeholder="whsec_...">
                      </base-input>
                      <info-hint variant="primary">
                        Find this in
                        <a href="https://dashboard.stripe.com/webhooks" target="_blank">Stripe Dashboard</a>
                        under <strong>Workbench &rarr; Webhooks</strong>,
                        select your endpoint, then click to reveal the
                        signing secret (starts with <code>whsec_</code>).
                        Leave empty to disable signature verification, which
                        is not recommended for production.
                      </info-hint>
                      <div class="mt-3">
                        <base-button class="mr-2" v-on:click="cancelWebhookSecretEdit()" type="default" size="sm">
                          Cancel
                        </base-button>
                        <base-button v-on:click="saveWebhookSecret()" type="primary" size="sm">
                          Save
                        </base-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </collapsible-section>

            <collapsible-section
              v-if="payment_gateway.id === 3 && activeStripePill === 'policies'"
              title="Customer management"
              icon="tim-icons icon-single-02"
              :default-open="true"
              class="stripe-section stripe-section--in-pill"
            >
              <info-hint variant="primary">
                Control how Stripe customers, saved cards, and card-on-file requirements
                are handled for this venue.
              </info-hint>
              <div class="row">
                <div class="col">
                  <el-switch active-color="#e14eca"
                             :disabled="stripeSavingField === 'create_customer'"
                             v-on:change="saveStripeSettings('customer', 'create_customer')"
                             v-model="stripe_settings.create_customer"  />
                  <label class="text-white opacity-7"> &nbsp; Automatically create a customer in Stripe and link customers to payments</label>
                  <i v-if="stripeSavingField === 'create_customer'" class="el-icon-loading ml-2 text-white"></i>
                </div>
              </div>
              <div class="row mt-2" v-if="stripe_settings.create_customer">
                <div class="col">
                  <el-switch active-color="#e14eca"
                             :disabled="stripeSavingField === 'store_credit_card'"
                             v-on:change="saveStripeSettings('payment_method', 'store_credit_card')"
                             v-model="stripe_settings.store_credit_card"  />
                  <label class="text-white opacity-7"> &nbsp; Enable saved payment methods (allow customers to store credit cards for future use)</label>
                  <i v-if="stripeSavingField === 'store_credit_card'" class="el-icon-loading ml-2 text-white"></i>
                </div>
              </div>
              <div class="row mt-2" v-if="stripe_settings.store_credit_card">
                <div class="col">
                  <el-switch active-color="#e14eca"
                             :disabled="stripeSavingField === 'require_card_for_deposit'"
                             v-on:change="saveStripeSettings('payment_method', 'require_card_for_deposit')"
                             v-model="stripe_settings.require_card_for_deposit"  />
                  <label class="text-white opacity-7"> &nbsp; Require saved payment method for deposit payments</label>
                  <el-tooltip effect="light" placement="top" :open-delay="300">
                    <div slot="content" style="max-width: 300px">
                      <b>Optional deposit:</b> customers who decline will pay the full amount.<br>
                      <b>Required deposit:</b> customers must save their payment method to complete the booking.
                    </div>
                    <i class="el-icon-info ml-1" style="color: #1890ff; cursor: pointer"></i>
                  </el-tooltip>
                  <i v-if="stripeSavingField === 'require_card_for_deposit'" class="el-icon-loading ml-2 text-white"></i>
                </div>
              </div>
              <div class="row mt-2" v-if="stripe_settings.store_credit_card">
                <div class="col">
                  <el-switch active-color="#e14eca"
                             :disabled="stripeSavingField === 'require_card_for_full_payment'"
                             v-on:change="saveStripeSettings('payment_method', 'require_card_for_full_payment')"
                             v-model="stripe_settings.require_card_for_full_payment"  />
                  <label class="text-white opacity-7"> &nbsp; Require saved payment method for full payments</label>
                  <el-tooltip effect="light" placement="top" :open-delay="300">
                    <div slot="content" style="max-width: 320px">
                      Forces customers who pay in full upfront (no deposit) to save their card on file. Useful for covering no-shows, damages, or incidentals.
                    </div>
                    <i class="el-icon-info ml-1" style="color: #1890ff; cursor: pointer"></i>
                  </el-tooltip>
                  <i v-if="stripeSavingField === 'require_card_for_full_payment'" class="el-icon-loading ml-2 text-white"></i>
                </div>
              </div>
            </collapsible-section>

            <collapsible-section
              v-if="payment_gateway.id === 3 && activeStripePill === 'policies'"
              title="Statement description"
              icon="tim-icons icon-pencil"
              :default-open="true"
              class="stripe-section stripe-section--in-pill"
            >
              <info-hint variant="primary">
                Text that appears in your Stripe dashboard and on the customer's
                statement. Supports dynamic variables like
                <code>[Customer First Name]</code>.
              </info-hint>
              <div class="row">
                <div class="col-lg-8">
                  <label>Description</label>
                  <base-input
                    v-model="stripe_settings.custom_description"
                    placeholder="e.g., Booking for [Customer First Name] [Customer Last Name]"
                    maxlength="500">
                  </base-input>
                  <small class="text-white opacity-7 d-block" style="margin-top: -8px">Max 500 characters.</small>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-8">
                  <base-button size="sm" type="primary" v-on:click="saveStripeSettings('description')">
                    Save description
                  </base-button>
                </div>
              </div>
              <p class="mt-3 card-title text-primary">Supported dynamic variables
                <i class="tim-icons icon-minimal-down ml-1" v-on:click="show_dynamic_variables = !show_dynamic_variables" style="cursor: pointer"></i>
              </p>
              <div v-if="show_dynamic_variables">
                <div>
                  <code>[Customer First Name]
                    <el-tooltip content="Copy" effect="light" :open-delay="300" placement="top">
                      <base-button @click.native="copy('[Customer First Name]')" class="like btn-link text-white" size="sm" icon>
                        <i class="tim-icons el-icon-copy-document"></i>
                      </base-button>
                    </el-tooltip>
                  </code>
                </div>
                <div>
                  <code>[Customer Last Name]
                    <el-tooltip content="Copy" effect="light" :open-delay="300" placement="top">
                      <base-button @click.native="copy('[Customer Last Name]')" class="like btn-link text-white" size="sm" icon>
                        <i class="tim-icons el-icon-copy-document"></i>
                      </base-button>
                    </el-tooltip>
                  </code>
                </div>
                <div>
                  <code>[Customer Email]
                    <el-tooltip content="Copy" effect="light" :open-delay="300" placement="top">
                      <base-button @click.native="copy('[Customer Email]')" class="like btn-link text-white" size="sm" icon>
                        <i class="tim-icons el-icon-copy-document"></i>
                      </base-button>
                    </el-tooltip>
                  </code>
                </div>
                <div>
                  <code>[Transaction ID]
                    <el-tooltip content="Copy" effect="light" :open-delay="300" placement="top">
                      <base-button @click.native="copy('[Transaction ID]')" class="like btn-link text-white" size="sm" icon>
                        <i class="tim-icons el-icon-copy-document"></i>
                      </base-button>
                    </el-tooltip>
                  </code>
                </div>
              </div>
            </collapsible-section>

            <!-- ═══ Card readers (Stripe Terminal smart readers, S700/S710) ═══ -->
            <collapsible-section
              v-if="payment_gateway.id === 3 && activeStripePill === 'hardware'"
              title="Card readers"
              icon="tim-icons icon-mobile"
              :badge="readers.length ? String(readers.length) : ''"
              :default-open="true"
              class="stripe-section stripe-section--in-pill"
            >
              <info-hint v-if="!connectReaderForm.open" variant="primary">
                Connect a Stripe Reader S700, S710, or compatible smart reader to take
                in-person payments at this venue.
              </info-hint>

              <div
                v-if="!readersLoading && (stripeTerminalLocationId || stripeLocations.length) && !connectReaderForm.open"
                class="stripe-location-row"
              >
                <label class="text-white stripe-location-row__label">
                  Stripe Terminal location
                  <el-popover trigger="hover" placement="top" width="320">
                    <p class="mb-0">Readers listed below are the ones registered in this Stripe Terminal location. If your readers were registered from your own Stripe dashboard, pick the location they are in.</p>
                    <i slot="reference" class="el-icon-info stripe-location-row__info"></i>
                  </el-popover>
                </label>
                <div class="stripe-location-row__controls">
                  <el-select
                    :value="stripeTerminalLocationId"
                    class="select-primary stripe-location-row__select"
                    placeholder="Choose a location"
                    :disabled="locationSaving || !stripeLocations.length"
                    @change="setStripeTerminalLocation"
                  >
                    <el-option
                      v-for="loc in stripeLocations"
                      :key="loc.id"
                      class="select-primary"
                      :label="stripeLocationLabel(loc)"
                      :value="loc.id"
                    >
                      <span>{{ loc.display_name }}<template v-if="loc.city"> · {{ loc.city }}</template></span>
                      <span class="stripe-location-row__count">{{ loc.reader_count }} {{ loc.reader_count === 1 ? 'reader' : 'readers' }}</span>
                    </el-option>
                  </el-select>
                  <div
                    v-if="stripeTerminalLocationId"
                    class="stripe-location-chip stripe-location-chip--inline"
                    :title="`Stripe Terminal Location ID, cross-reference in Stripe Dashboard`"
                  >
                    <span class="stripe-location-chip__label">Location ID</span>
                    <code class="stripe-location-chip__value">{{ stripeTerminalLocationId }}</code>
                    <button
                      type="button"
                      class="stripe-location-chip__copy"
                      aria-label="Copy Location ID"
                      title="Copy"
                      @click="copyStripeTerminalLocationId"
                    >
                      <i class="tim-icons icon-single-copy-04"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div>
                <ul v-if="readersLoading" class="readers-list readers-list--skel" aria-busy="true" aria-label="Loading readers">
                  <li v-for="n in 2" :key="`reader-skel-${n}`" class="reader-row reader-row--skel">
                    <div class="reader-row__body">
                      <span class="skel" style="display:block; width: 45%; height: 14px; margin-bottom: 8px;"></span>
                      <span class="skel" style="display:block; width: 70%; height: 10px;"></span>
                    </div>
                    <div class="reader-row__actions">
                      <span class="skel skel--btn"></span>
                    </div>
                  </li>
                </ul>

                <div v-else-if="readers.length === 0 && !connectReaderForm.open" class="stripe-empty">
                  <div class="stripe-empty__icon"><i class="tim-icons icon-mobile"></i></div>
                  <p class="stripe-empty__title">No readers connected</p>
                  <p class="stripe-empty__hint">
                    Connect a Stripe Reader S700, S710, or compatible smart reader
                    to start taking in-person payments at this venue.
                  </p>
                  <base-button v-on:click="openConnectReaderForm" type="primary" size="sm" :disabled="readersLoading">
                    <i class="tim-icons icon-simple-add mr-1"></i> Connect a reader
                  </base-button>
                </div>

                <ul v-else-if="!connectReaderForm.open" class="readers-list">
                  <li v-for="r in readers" :key="`reader-${r.id}`" class="reader-row">
                    <div class="reader-row__body">
                      <div
                        v-if="editingReaderId !== r.id"
                        class="reader-row__name-display"
                        role="button"
                        tabindex="0"
                        @click="startEditReaderLabel(r)"
                        @keydown.enter="startEditReaderLabel(r)"
                      >
                        <span class="reader-row__name">{{ r.label || 'Reader' }}</span>
                        <i class="tim-icons icon-pencil reader-row__pencil"></i>
                      </div>
                      <div v-else class="reader-row__name-edit">
                        <input
                          :ref="`readerLabelInput-${r.id}`"
                          v-model="editingReaderLabel"
                          class="reader-row__name-input"
                          maxlength="80"
                          placeholder="Reader label"
                          @blur="saveReaderLabel(r)"
                          @keydown.enter.prevent="$event.target.blur()"
                          @keydown.esc="cancelEditReaderLabel"
                        />
                        <button
                          type="button"
                          class="reader-row__name-icon reader-row__name-icon--save"
                          aria-label="Save label"
                          title="Save"
                          @mousedown.prevent
                          @click="saveReaderLabel(r)"
                        >
                          <i class="tim-icons icon-check-2"></i>
                        </button>
                        <button
                          type="button"
                          class="reader-row__name-icon"
                          aria-label="Cancel"
                          title="Cancel"
                          @mousedown.prevent
                          @click="cancelEditReaderLabel"
                        >
                          <i class="tim-icons icon-simple-remove"></i>
                        </button>
                      </div>
                      <p class="reader-row__meta">
                        <span
                          class="reader-row__status"
                          :class="`reader-row__status--${r.status || 'offline'}`"
                        >
                          {{ readerStatusLabel(r.status) }}
                        </span>
                        <span class="reader-row__dot">·</span>
                        <span>{{ readerDeviceTypeLabel(r.device_type) }}</span>
                        <span class="reader-row__dot">·</span>
                        <code class="reader-row__id">{{ r.id }}</code>
                      </p>
                    </div>
                    <div class="reader-row__actions">
                      <base-button link size="sm" type="primary" @click="confirmRemoveReader(r)">
                        Remove
                      </base-button>
                    </div>
                  </li>
                </ul>

                <!-- "Connect a reader" trigger only shown when readers exist
                     (the empty state has its own embedded CTA). -->
                <div v-if="!connectReaderForm.open && readers.length > 0" class="readers-add-row">
                  <base-button type="primary" size="sm" @click="openConnectReaderForm" :disabled="readersLoading">
                    <i class="tim-icons icon-simple-add mr-1"></i>
                    Connect a reader
                  </base-button>
                </div>

                <!-- Where readers are used: Send to POS lists registered
                     readers directly. A reader shows Stripe's own payment
                     screen; page branding, tipping and custom fields need
                     the OTC POS app on a device paired to a POS page. -->
                <info-hint
                  v-if="!connectReaderForm.open && readers.length > 0"
                  variant="neutral"
                >
                  Readers registered here are venue-wide. Send a payment to one
                  from any transaction, booking, or gift card purchase with
                  <strong>Send to POS</strong>. A reader shows Stripe's payment
                  screen; to use your page branding, tipping screen and custom
                  fields, pair a device running the OTC POS app on a
                  <strong>Point of sale</strong> page instead.
                </info-hint>

                <div v-if="connectReaderForm.open" class="reader-pair-form">
                  <info-hint variant="primary">
                    On the reader, open <strong>Settings</strong> &rarr;
                    <strong>Generate pairing code</strong>, then paste the code below.
                  </info-hint>

                  <div class="row">
                    <div class="col-lg-6">
                      <label class="text-white">Pairing code</label>
                      <base-input
                        v-model="connectReaderForm.code"
                        :error="connectReaderForm.error"
                        placeholder="e.g. papaya-director-outside"
                        maxlength="100"
                        autocapitalize="off"
                        autocorrect="off"
                      ></base-input>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-6">
                      <label class="text-white">
                        Label
                        <span class="text-white opacity-7" style="font-weight: normal;">(optional)</span>
                      </label>
                      <base-input
                        v-model="connectReaderForm.label"
                        placeholder="e.g. Counter S710, Bar reader"
                        maxlength="80"
                      ></base-input>
                    </div>
                  </div>

                  <div class="reader-pair-form__actions">
                    <base-button class="mr-2" type="default" size="sm" @click="cancelConnectReaderForm">
                      Cancel
                    </base-button>
                    <base-button
                      type="primary"
                      size="sm"
                      :disabled="!connectReaderForm.code.trim() || connectReaderForm.submitting"
                      @click="submitConnectReader"
                    >
                      <i v-if="connectReaderForm.submitting" class="el-icon-loading mr-2"></i>
                      Connect reader
                    </base-button>
                  </div>
                </div>
              </div>
            </collapsible-section>

                </div><!-- /.stripe-panel -->
              </div><!-- /.col right -->
            </div><!-- /.stripe-layout -->

            <!-- ═══ SQUARE LAYOUT (id===2): rail + pill sub-nav, mirrors the
                 Stripe layout. The In-person pill is the new OAuth connect; the
                 Online keys + Customer pills reveal the existing Square forms
                 below (gated by activeSquarePill). Reuses the .stripe-* SCSS. ═══ -->
            <div v-if="payment_gateway && payment_gateway.id === 2" class="stripe-layout row">
              <!-- LEFT RAIL -->
              <div class="col-lg-3 col-md-4 stripe-layout__rail">
                <div class="stripe-rail">
                  <p class="stripe-rail__eyebrow">Active gateway</p>
                  <div class="stripe-rail__logo">
                    <img :src="payment_gateway.img" :alt="payment_gateway.name" />
                    <span
                      class="stripe-rail__logo-badge"
                      :class="`stripe-rail__logo-badge--${squareRailStatus.tone}`"
                    >
                      {{ squareRailStatus.label }}
                    </span>
                  </div>
                  <p class="stripe-rail__name">{{ payment_gateway.name }}</p>

                  <div class="text-left">
                    <info-hint variant="primary">
                      Handles online checkout (booking site, payment requests)
                      and in-person Tap to Pay on an Android phone via Square.
                      Connect your Square account for in-person, or add online
                      API keys through the pills.
                    </info-hint>
                  </div>

                  <button
                    type="button"
                    class="stripe-rail__change"
                    @click="changePaymentGateway()"
                  >
                    <i class="tim-icons icon-refresh-01"></i>
                    Change gateway
                  </button>
                </div>
              </div>

              <!-- RIGHT COLUMN: pill nav + active pill panel -->
              <div class="col-lg-9 col-md-8 stripe-layout__main">
                <nav class="stripe-pills">
                  <button
                    v-for="p in squarePills"
                    :key="p.id"
                    type="button"
                    class="stripe-pill"
                    :class="{
                      'stripe-pill--active': activeSquarePill === p.id,
                      [`stripe-pill--${squarePillStatus[p.id]}`]: true,
                    }"
                    @click="setSquarePill(p.id)"
                  >
                    <i :class="p.icon" class="stripe-pill__icon"></i>
                    <span class="stripe-pill__label">{{ p.label }}</span>
                    <span
                      v-if="squarePillStatus[p.id] !== 'neutral'"
                      class="stripe-pill__status"
                    >
                      <i v-if="squarePillStatus[p.id] === 'ok'" class="tim-icons icon-check-2"></i>
                      <i v-else-if="squarePillStatus[p.id] === 'incomplete'" class="tim-icons icon-alert-circle-exc"></i>
                    </span>
                  </button>
                </nav>

                <!-- Active pill panel ──────────────────────────────── -->
                <div class="stripe-panel">
                  <!-- ONLINE KEYS (Square access tokens) — folded into the panel, mirrors Stripe's Credentials. -->
                  <collapsible-section
                    v-if="activeSquarePill === 'credentials'"
                    title="API credentials"
                    icon="tim-icons icon-key-25"
                    :badge="live_credentials.api_name ? 'Live ready' : 'Live not set'"
                    :default-open="true"
                    class="stripe-section stripe-section--in-pill"
                  >
                    <info-hint variant="primary">
                      Square <strong>access tokens</strong> for online payments
                      (booking site + payment requests). Test tokens run in
                      Square's sandbox; live tokens process real payments. Find
                      them in your
                      <a href="https://developer.squareup.com/apps" target="_blank">Square dashboard</a>.
                      In-person Tap to Pay is connected separately under the
                      In-person pill.
                    </info-hint>

                    <!-- Test credentials -->
                    <div class="stripe-creds-block">
                      <div class="stripe-creds-block__head">
                        <h5 class="stripe-creds-block__title">Test credentials</h5>
                        <badge type="success" v-if="test_credentials.is_active">active</badge>
                        <badge type="danger" v-else>inactive</badge>
                      </div>
                      <div v-if="!test_credentials.api_name">
                        <div v-if="!edit_test_creds" class="stripe-empty">
                          <div class="stripe-empty__icon"><i class="tim-icons icon-bulb-63"></i></div>
                          <p class="stripe-empty__title">Test credentials not set</p>
                          <p class="stripe-empty__hint">
                            Optional but recommended. Validate booking + checkout flows in Square's sandbox before going live.
                          </p>
                          <base-button v-on:click="editTestCreds()" type="primary" size="sm">
                            <i class="tim-icons icon-simple-add mr-1"></i> Add test credentials
                          </base-button>
                        </div>
                        <div v-else>
                          <div class="row" :key="'sqsA' + j"><div class="col-lg-8"><label>{{api_name}} <span class="text-danger">*</span></label><base-input v-on:change="j++" :error="err.test_credentials.api_name" v-model="test_credentials.api_name_edit"></base-input></div></div>
                          <div class="row" :key="'sqsB' + j"><div class="col-lg-8"><label>{{api_key}} <span class="text-danger">*</span></label><base-input v-on:change="j++" :error="err.test_credentials.api_key" :placeholder="test_credentials.has_api_key ? 'Enter the secret key again to save' : ''" v-model="test_credentials.api_key_edit"></base-input></div></div>
                          <div class="row" :key="'sqsLoc' + j"><div class="col-lg-8"><label>{{api_location}} <span class="text-danger">*</span></label><base-input v-on:change="j++" :error="err.test_credentials.api_location" v-model="test_credentials.api_location_edit"></base-input></div></div>
                          <div class="row"><div class="col-lg-8"><base-button class="mr-2" v-on:click="edit_test_creds = false" type="default" size="sm">Cancel</base-button><base-button v-on:click="updateCredentials('test', 2)" type="primary" size="sm">Save</base-button></div></div>
                        </div>
                      </div>
                      <div v-else>
                        <div class="row"><div class="col-lg-8"><label>{{api_name}} <span class="text-danger">*</span></label><p v-if="!edit_test_creds">{{test_credentials.api_name}}</p><base-input v-else :error="err.test_credentials.api_name" v-model="test_credentials.api_name_edit"></base-input></div></div>
                        <div class="row"><div class="col-lg-8"><label>{{api_key}} <span class="text-danger">*</span></label><p v-if="!edit_test_creds">••••••••••••••••••••••••••••••</p><base-input v-else :error="err.test_credentials.api_key" :placeholder="test_credentials.has_api_key ? 'Enter the secret key again to save' : ''" v-model="test_credentials.api_key_edit"></base-input></div></div>
                        <div class="row"><div class="col-lg-8"><label>{{api_location}} <span class="text-danger">*</span></label><p v-if="!edit_test_creds">{{test_credentials.api_location}}</p><base-input v-else :error="err.test_credentials.api_location" v-model="test_credentials.api_location_edit"></base-input></div></div>
                        <div class="row"><div class="col-lg-8">
                          <span v-if="edit_test_creds"><base-button class="mr-2" v-on:click="edit_test_creds = false" type="default" size="sm">Cancel</base-button><base-button v-on:click="updateCredentials('test', 2)" type="primary" size="sm">Save</base-button></span>
                          <span v-else><base-button v-on:click="editTestCreds()" type="primary" size="sm"><i class="tim-icons icon-pencil mr-1"></i> Edit</base-button><base-button class="ml-2" v-if="!test_credentials.is_active" v-on:click="updateCredentials('test', 1)" link type="primary" size="sm">Activate</base-button><base-button class="ml-2" v-if="test_credentials.is_active" v-on:click="updateCredentials('test', 0)" link type="primary" size="sm">Deactivate</base-button></span>
                        </div></div>
                      </div>
                    </div>

                    <!-- Live credentials -->
                    <div class="stripe-creds-block mt-4">
                      <div class="stripe-creds-block__head">
                        <h5 class="stripe-creds-block__title">Live credentials</h5>
                        <badge type="success" v-if="live_credentials.is_active">active</badge>
                        <badge type="danger" v-else>inactive</badge>
                      </div>
                      <div v-if="!live_credentials.api_name">
                        <div v-if="!edit_live_creds" class="stripe-empty stripe-empty--required">
                          <div class="stripe-empty__icon"><i class="tim-icons icon-key-25"></i></div>
                          <p class="stripe-empty__title">Live credentials not set</p>
                          <p class="stripe-empty__hint">
                            Required to process real online payments. Find your live access token + location id in your
                            <a href="https://developer.squareup.com/apps" target="_blank">Square dashboard</a>.
                          </p>
                          <base-button v-on:click="editLiveCreds()" type="primary" size="sm">
                            <i class="tim-icons icon-simple-add mr-1"></i> Add live credentials
                          </base-button>
                        </div>
                        <div v-else>
                          <div class="row" :key="'sqlE' + j"><div class="col-lg-8"><label>{{api_name}} <span class="text-danger">*</span></label><base-input v-on:change="j++" :error="err.live_credentials.api_name" v-model="live_credentials.api_name_edit"></base-input></div></div>
                          <div class="row" :key="'sqlF' + j"><div class="col-lg-8"><label>{{api_key}} <span class="text-danger">*</span></label><base-input v-on:change="j++" :error="err.live_credentials.api_key" :placeholder="live_credentials.has_api_key ? 'Enter the secret key again to save' : ''" v-model="live_credentials.api_key_edit"></base-input></div></div>
                          <div class="row" :key="'sqlLoc' + j"><div class="col-lg-8"><label>{{api_location}} <span class="text-danger">*</span></label><base-input v-on:change="j++" :error="err.live_credentials.api_location" v-model="live_credentials.api_location_edit"></base-input></div></div>
                          <div class="row"><div class="col-lg-8"><base-button class="mr-2" v-on:click="edit_live_creds = false" type="default" size="sm">Cancel</base-button><base-button v-on:click="updateCredentials('live', 2)" type="primary" size="sm">Save</base-button></div></div>
                        </div>
                      </div>
                      <div v-else>
                        <div class="row"><div class="col-lg-8"><label>{{api_name}} <span class="text-danger">*</span></label><p v-if="!edit_live_creds">{{live_credentials.api_name}}</p><base-input v-else :error="err.live_credentials.api_name" v-model="live_credentials.api_name_edit"></base-input></div></div>
                        <div class="row"><div class="col-lg-8"><label>{{api_key}} <span class="text-danger">*</span></label><p v-if="!edit_live_creds">••••••••••••••••••••••••••••••</p><base-input v-else :error="err.live_credentials.api_key" :placeholder="live_credentials.has_api_key ? 'Enter the secret key again to save' : ''" v-model="live_credentials.api_key_edit"></base-input></div></div>
                        <div class="row"><div class="col-lg-8"><label>{{api_location}} <span class="text-danger">*</span></label><p v-if="!edit_live_creds">{{live_credentials.api_location}}</p><base-input v-else :error="err.live_credentials.api_location" v-model="live_credentials.api_location_edit"></base-input></div></div>
                        <div class="row"><div class="col-lg-8">
                          <span v-if="edit_live_creds"><base-button class="mr-2" v-on:click="edit_live_creds = false" type="default" size="sm">Cancel</base-button><base-button v-on:click="updateCredentials('live', 2)" type="primary" size="sm">Save</base-button></span>
                          <span v-else><base-button v-on:click="editLiveCreds()" type="primary" size="sm"><i class="tim-icons icon-pencil mr-1"></i> Edit</base-button><base-button class="ml-2" v-if="!live_credentials.is_active" v-on:click="updateCredentials('live', 1)" link type="primary" size="sm">Activate</base-button><base-button class="ml-2" v-if="live_credentials.is_active" v-on:click="updateCredentials('live', 0)" link type="primary" size="sm">Deactivate</base-button></span>
                        </div></div>
                      </div>
                    </div>
                  </collapsible-section>

                  <!-- IN-PERSON (OAuth connect) — the new piece -->
                  <collapsible-section
                    v-if="activeSquarePill === 'connect'"
                    title="In-person (Tap to Pay)"
                    icon="tim-icons icon-mobile"
                    :badge="squareOauth.connected ? 'Connected' : 'Not connected'"
                    :default-open="true"
                    class="stripe-section stripe-section--in-pill"
                  >
                    <info-hint v-if="!squareOauth.connected" variant="primary">
                      Connect your Square account so staff can take in-person
                      <strong>Tap to Pay</strong> payments on an Android phone
                      running the OTC POS app. This uses Square's secure OAuth,
                      so we never see your Square password, and it's separate
                      from your online API keys.
                    </info-hint>

                    <div v-if="!squareOauth.connected" class="stripe-empty">
                      <div class="stripe-empty__icon"><i class="tim-icons icon-mobile"></i></div>
                      <p class="stripe-empty__title">Square not connected</p>
                      <p class="stripe-empty__hint">
                        Authorize in-person Tap to Pay for this venue.
                      </p>
                      <segmented-toggle
                        v-model="squareConnectEnv"
                        variant="pills"
                        class="mb-2"
                        :options="[
                          { value: 'production', label: 'Live' },
                          { value: 'sandbox', label: 'Sandbox' }
                        ]"
                      />
                      <p v-if="squareConnectEnv === 'sandbox'" class="stripe-empty__hint">
                        Sandbox is for OTC testing with a Square developer test
                        account. Venues connecting a real Square account should
                        use live.
                      </p>
                      <base-button
                        type="primary"
                        size="sm"
                        :disabled="squareConnecting"
                        @click="connectSquare(squareConnectEnv)"
                      >
                        <i v-if="squareConnecting" class="el-icon-loading mr-1"></i>
                        <i v-else class="tim-icons icon-simple-add mr-1"></i>
                        {{ squareConnecting ? 'Starting…' : 'Connect Square' }}
                      </base-button>
                    </div>

                    <div v-else>
                      <info-hint variant="success">
                        <strong>Connected to Square.</strong> Staff can take in-person Tap to Pay on this venue from the OTC POS app.
                      </info-hint>
                      <div class="sq-connected__meta">
                        <div v-if="squareOauth.merchant_id" class="sq-connected__row">
                          <span class="sq-connected__label">Merchant</span>
                          <span class="sq-connected__value">{{ squareOauth.merchant_id }}</span>
                        </div>
                        <div v-if="squareOauth.location_id" class="sq-connected__row">
                          <span class="sq-connected__label">Location</span>
                          <span class="sq-connected__value">{{ squareOauth.location_id }}</span>
                        </div>
                        <div class="sq-connected__row">
                          <span class="sq-connected__label">Environment</span>
                          <span class="sq-connected__value">{{ squareOauth.is_live ? 'Production' : 'Sandbox' }}</span>
                        </div>
                      </div>
                      <div class="neutral-action-row">
                        <div class="neutral-action-info">
                          <span class="neutral-action-label">Disconnect Square</span>
                          <span class="neutral-action-hint">Staff can no longer take in-person payments until you reconnect.</span>
                        </div>
                        <base-button size="sm" class="neutral-action-btn" @click="disconnectSquare()">Disconnect</base-button>
                      </div>
                    </div>
                  </collapsible-section>

                  <!-- CUSTOMER (square_settings) — folded into the panel, mirrors Stripe's Policies. -->
                  <collapsible-section
                    v-if="activeSquarePill === 'customer'"
                    title="Customer management"
                    icon="tim-icons icon-single-02"
                    :default-open="true"
                    class="stripe-section stripe-section--in-pill"
                  >
                    <info-hint variant="primary">
                      Configure how Square handles customer data and saved
                      payment methods for this venue's transactions.
                    </info-hint>
                    <div class="row">
                      <div class="col">
                        <el-switch active-color="#e14eca"
                                   :disabled="squareSavingField === 'create_customer'"
                                   v-on:change="saveSquareCustomFields('customer', 'create_customer')"
                                   v-model="square_settings.create_customer" />
                        <label class="text-white opacity-7"> &nbsp; Automatically create a customer in Square and link customers to payments</label>
                        <i v-if="squareSavingField === 'create_customer'" class="el-icon-loading ml-2 text-white"></i>
                      </div>
                    </div>
                    <div class="row mt-2" v-if="square_settings.create_customer">
                      <div class="col">
                        <el-switch active-color="#e14eca"
                                   :disabled="squareSavingField === 'store_credit_card'"
                                   v-on:change="saveSquareCustomFields('payment_method', 'store_credit_card')"
                                   v-model="square_settings.store_credit_card" />
                        <label class="text-white opacity-7"> &nbsp; Enable saved payment methods (allow customers to store credit cards for future use)</label>
                        <i v-if="squareSavingField === 'store_credit_card'" class="el-icon-loading ml-2 text-white"></i>
                      </div>
                    </div>
                    <div class="row mt-2" v-if="square_settings.store_credit_card">
                      <div class="col">
                        <el-switch active-color="#e14eca"
                                   :disabled="squareSavingField === 'require_card_for_deposit'"
                                   v-on:change="saveSquareCustomFields('payment_method', 'require_card_for_deposit')"
                                   v-model="square_settings.require_card_for_deposit" />
                        <label class="text-white opacity-7"> &nbsp; Require saved payment method for deposit payments</label>
                        <el-tooltip effect="light" placement="top" :open-delay="300">
                          <div slot="content" style="max-width: 300px">
                            Optional deposit: customers who decline will pay the full amount.<br>
                            Required deposit: customers must save their payment method to complete the booking.
                          </div>
                          <i class="el-icon-info ml-1" style="color: #1890ff; cursor: pointer"></i>
                        </el-tooltip>
                        <i v-if="squareSavingField === 'require_card_for_deposit'" class="el-icon-loading ml-2 text-white"></i>
                      </div>
                    </div>
                    <div class="row mt-2" v-if="square_settings.store_credit_card">
                      <div class="col">
                        <el-switch active-color="#e14eca"
                                   :disabled="squareSavingField === 'require_card_for_full_payment'"
                                   v-on:change="saveSquareCustomFields('payment_method', 'require_card_for_full_payment')"
                                   v-model="square_settings.require_card_for_full_payment" />
                        <label class="text-white opacity-7"> &nbsp; Require saved payment method for full payments</label>
                        <el-tooltip effect="light" placement="top" :open-delay="300">
                          <div slot="content" style="max-width: 320px">
                            Forces customers who pay in full upfront (no deposit) to save their card on file. Useful for covering no-shows, damages, or incidentals.
                          </div>
                          <i class="el-icon-info ml-1" style="color: #1890ff; cursor: pointer"></i>
                        </el-tooltip>
                        <i v-if="squareSavingField === 'require_card_for_full_payment'" class="el-icon-loading ml-2 text-white"></i>
                      </div>
                    </div>
                  </collapsible-section>

                  <collapsible-section
                    v-if="activeSquarePill === 'customer'"
                    title="Custom note"
                    icon="tim-icons icon-pencil"
                    :default-open="true"
                    class="stripe-section stripe-section--in-pill"
                  >
                    <info-hint variant="primary">
                      Define the text that appears in the note field on your
                      Square dashboard. Supports dynamic variables like
                      <code>[Customer First Name]</code>.
                    </info-hint>
                    <div class="row">
                      <div class="col-lg-8">
                        <label>Note (max 500 characters)</label>
                        <base-input
                          v-model="square_settings.note"
                          placeholder="e.g., Booking for [Customer First Name] [Customer Last Name]"
                          maxlength="500">
                        </base-input>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col">
                        <base-button size="sm" type="primary" v-on:click="saveSquareCustomFields()">Save note</base-button>
                      </div>
                    </div>
                    <p class="mt-3 card-title text-primary" style="cursor: pointer" @click="show_dynamic_variables = !show_dynamic_variables">
                      Supported dynamic variables
                      <i class="tim-icons icon-minimal-down ml-1"></i>
                    </p>
                    <div v-if="show_dynamic_variables">
                      <div><code>[Customer First Name]
                        <el-tooltip content="Copy" effect="light" :open-delay="300" placement="top">
                          <base-button @click.native="copy('[Customer First Name]')" class="like btn-link text-white" size="sm" icon>
                            <i class="tim-icons icon-single-copy-04"></i>
                          </base-button>
                        </el-tooltip>
                      </code></div>
                      <div><code>[Customer Last Name]
                        <el-tooltip content="Copy" effect="light" :open-delay="300" placement="top">
                          <base-button @click.native="copy('[Customer Last Name]')" class="like btn-link text-white" size="sm" icon>
                            <i class="tim-icons icon-single-copy-04"></i>
                          </base-button>
                        </el-tooltip>
                      </code></div>
                      <div><code>[Customer Phone]
                        <el-tooltip content="Copy" effect="light" :open-delay="300" placement="top">
                          <base-button @click.native="copy('[Customer Phone]')" class="like btn-link text-white" size="sm" icon>
                            <i class="tim-icons icon-single-copy-04"></i>
                          </base-button>
                        </el-tooltip>
                      </code></div>
                    </div>
                  </collapsible-section>
                </div>
              </div>
            </div>

            <!-- ═══ Paystack configuration: left-rail identity + pill sub-nav,
                 mirroring the Stripe/Square layout. Reuses the stripe-rail /
                 stripe-pills / stripe-creds-block / webhook-block classes and
                 the generic test_credentials / live_credentials state +
                 updateCredentials methods; no Paystack-specific CSS.
                 Paystack has no separate webhook signing secret: webhooks are
                 signed with the secret key already stored in credentials, so
                 the webhook pill is registration instructions + a verification
                 status card, not a secret input. ═══ -->
            <div v-if="payment_gateway && payment_gateway.id === 4" class="stripe-layout row">
              <!-- LEFT RAIL: gateway identity -->
              <div class="col-lg-3 col-md-4 stripe-layout__rail">
                <div class="stripe-rail">
                  <p class="stripe-rail__eyebrow">Active gateway</p>
                  <div class="stripe-rail__logo">
                    <img :src="payment_gateway.img" :alt="payment_gateway.name" />
                    <span
                      class="stripe-rail__logo-badge"
                      :class="`stripe-rail__logo-badge--${paystackRailStatus.tone}`"
                    >
                      {{ paystackRailStatus.label }}
                    </span>
                  </div>
                  <p class="stripe-rail__name">{{ payment_gateway.name }}</p>

                  <div class="text-left">
                    <info-hint variant="primary">
                      Handles online checkout (booking site, payment
                      requests) and console card payments. Work through
                      the pills to wire up credentials and the webhook.
                    </info-hint>
                  </div>

                  <button
                    type="button"
                    class="stripe-rail__change"
                    @click="changePaymentGateway()"
                  >
                    <i class="tim-icons icon-refresh-01"></i>
                    Change gateway
                  </button>
                </div>
              </div>

              <!-- RIGHT COLUMN: pill nav + active pill panel -->
              <div class="col-lg-9 col-md-8 stripe-layout__main">
                <nav class="stripe-pills">
                  <button
                    v-for="p in paystackPills"
                    :key="p.id"
                    type="button"
                    class="stripe-pill"
                    :class="{
                      'stripe-pill--active': activePaystackPill === p.id,
                      [`stripe-pill--${paystackPillStatus[p.id]}`]: true,
                    }"
                    @click="activePaystackPill = p.id"
                  >
                    <i :class="p.icon" class="stripe-pill__icon"></i>
                    <span class="stripe-pill__label">{{ p.label }}</span>
                    <span
                      v-if="paystackPillStatus[p.id] !== 'neutral'"
                      class="stripe-pill__status"
                    >
                      <template v-if="paystackPillStatus[p.id] === 'ok'">
                        <i class="tim-icons icon-check-2"></i>
                      </template>
                      <template v-else-if="paystackPillStatus[p.id] === 'incomplete'">
                        <i class="tim-icons icon-alert-circle-exc"></i>
                      </template>
                    </span>
                  </button>
                </nav>

                <!-- Active pill panel -->
                <div class="stripe-panel">

                  <collapsible-section
                    v-if="activePaystackPill === 'credentials'"
                    title="API credentials"
                    icon="tim-icons icon-key-25"
                    :badge="live_credentials.api_name ? 'Live ready' : 'Live not set'"
                    :default-open="true"
                    class="stripe-section stripe-section--in-pill"
                  >
                    <info-hint variant="primary">
                      Paystack provides two key pairs: <strong>test</strong> for
                      sandbox payments and <strong>live</strong> for real
                      transactions. Live credentials are required to take real
                      payments. Test credentials are optional but recommended so
                      you can validate the integration before going live. Find
                      both in your Paystack dashboard under Settings, then API
                      Keys &amp; Webhook. See
                      <a href="https://support.paystack.com/hc/en-us/articles/360011508199-How-do-I-generate-new-API-keys" target="_blank">Paystack's guide</a>.
                    </info-hint>

                    <!-- Test credentials -->
                    <div class="stripe-creds-block">
                      <div class="stripe-creds-block__head">
                        <h5 class="stripe-creds-block__title">Test credentials</h5>
                        <badge type="success" v-if="test_credentials.is_active">active</badge>
                        <badge type="danger" v-else>inactive</badge>
                      </div>
                      <div v-if="!test_credentials.api_name">
                        <div v-if="!edit_test_creds" class="stripe-empty">
                          <div class="stripe-empty__icon"><i class="tim-icons icon-bulb-63"></i></div>
                          <p class="stripe-empty__title">Test credentials not set</p>
                          <p class="stripe-empty__hint">
                            Optional but recommended. Lets you run end-to-end checkout flows with Paystack's test cards before going live.
                          </p>
                          <base-button v-on:click="editTestCreds()" type="primary" size="sm">
                            <i class="tim-icons icon-simple-add mr-1"></i> Add test credentials
                          </base-button>
                        </div>
                        <div v-else>
                          <div class="row" :key="'pkA' + j">
                            <div class="col-lg-8">
                              <label>{{api_name}} <span class="text-danger">*</span></label>
                              <base-input v-on:change="j++" :error="err.test_credentials.api_name" v-model="test_credentials.api_name_edit"></base-input>
                            </div>
                          </div>
                          <div class="row" :key="'pkB' + j">
                            <div class="col-lg-8">
                              <label>{{api_key}} <span class="text-danger">*</span></label>
                              <base-input v-on:change="j++" :error="err.test_credentials.api_key" :placeholder="test_credentials.has_api_key ? 'Enter the secret key again to save' : ''" v-model="test_credentials.api_key_edit"></base-input>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-8">
                              <base-button class="mr-2" v-on:click="edit_test_creds = false" type="default" size="sm">Cancel</base-button>
                              <base-button v-on:click="updateCredentials('test', 2)" type="primary" size="sm">Save</base-button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div class="row">
                          <div class="col-lg-8">
                            <label>{{api_name}} <span class="text-danger">*</span></label>
                            <p v-if="!edit_test_creds">{{test_credentials.api_name}}</p>
                            <base-input v-else :error="err.test_credentials.api_name" v-model="test_credentials.api_name_edit"></base-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-8">
                            <label>{{api_key}} <span class="text-danger">*</span></label>
                            <p v-if="!edit_test_creds">••••••••••••••••••••••••••••••</p>
                            <base-input v-else :error="err.test_credentials.api_key" :placeholder="test_credentials.has_api_key ? 'Enter the secret key again to save' : ''" v-model="test_credentials.api_key_edit"></base-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-8">
                            <span v-if="edit_test_creds">
                              <base-button class="mr-2" v-on:click="edit_test_creds = false" type="default" size="sm">Cancel</base-button>
                              <base-button v-on:click="updateCredentials('test', 2)" type="primary" size="sm">Save</base-button>
                            </span>
                            <span v-else>
                              <base-button v-on:click="editTestCreds()" type="primary" size="sm">
                                <i class="tim-icons icon-pencil mr-1"></i> Edit
                              </base-button>
                              <base-button class="ml-2" v-if="!test_credentials.is_active" v-on:click="updateCredentials('test', 1)" link type="primary" size="sm">Activate</base-button>
                              <base-button class="ml-2" v-if="test_credentials.is_active" v-on:click="updateCredentials('test', 0)" link type="primary" size="sm">Deactivate</base-button>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Live credentials -->
                    <div class="stripe-creds-block mt-4">
                      <div class="stripe-creds-block__head">
                        <h5 class="stripe-creds-block__title">Live credentials</h5>
                        <badge type="success" v-if="live_credentials.is_active">active</badge>
                        <badge type="danger" v-else>inactive</badge>
                      </div>
                      <div v-if="!live_credentials.api_name">
                        <div v-if="!edit_live_creds" class="stripe-empty stripe-empty--required">
                          <div class="stripe-empty__icon"><i class="tim-icons icon-key-25"></i></div>
                          <p class="stripe-empty__title">Live credentials not set</p>
                          <p class="stripe-empty__hint">
                            Required to process real payments. Find your live public + secret keys in your Paystack dashboard under Settings, then API Keys &amp; Webhook.
                          </p>
                          <base-button v-on:click="editLiveCreds()" type="primary" size="sm">
                            <i class="tim-icons icon-simple-add mr-1"></i> Add live credentials
                          </base-button>
                        </div>
                        <div v-else>
                          <div class="row" :key="'pkE' + j">
                            <div class="col-lg-8">
                              <label>{{api_name}} <span class="text-danger">*</span></label>
                              <base-input v-on:change="j++" :error="err.live_credentials.api_name" v-model="live_credentials.api_name_edit"></base-input>
                            </div>
                          </div>
                          <div class="row" :key="'pkF' + j">
                            <div class="col-lg-8">
                              <label>{{api_key}} <span class="text-danger">*</span></label>
                              <base-input v-on:change="j++" :error="err.live_credentials.api_key" :placeholder="live_credentials.has_api_key ? 'Enter the secret key again to save' : ''" v-model="live_credentials.api_key_edit"></base-input>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-8">
                              <base-button class="mr-2" v-on:click="edit_live_creds = false" type="default" size="sm">Cancel</base-button>
                              <base-button v-on:click="updateCredentials('live', 2)" type="primary" size="sm">Save</base-button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div class="row">
                          <div class="col-lg-8">
                            <label>{{api_name}} <span class="text-danger">*</span></label>
                            <p v-if="!edit_live_creds">{{live_credentials.api_name}}</p>
                            <base-input v-else :error="err.live_credentials.api_name" v-model="live_credentials.api_name_edit"></base-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-8">
                            <label>{{api_key}} <span class="text-danger">*</span></label>
                            <p v-if="!edit_live_creds">••••••••••••••••••••••••••••••</p>
                            <base-input v-else :error="err.live_credentials.api_key" :placeholder="live_credentials.has_api_key ? 'Enter the secret key again to save' : ''" v-model="live_credentials.api_key_edit"></base-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-8">
                            <span v-if="edit_live_creds">
                              <base-button class="mr-2" v-on:click="edit_live_creds = false" type="default" size="sm">Cancel</base-button>
                              <base-button v-on:click="updateCredentials('live', 2)" type="primary" size="sm">Save</base-button>
                            </span>
                            <span v-else>
                              <base-button v-on:click="editLiveCreds()" type="primary" size="sm">
                                <i class="tim-icons icon-pencil mr-1"></i> Edit
                              </base-button>
                              <base-button class="ml-2" v-if="!live_credentials.is_active" v-on:click="updateCredentials('live', 1)" link type="primary" size="sm">Activate</base-button>
                              <base-button class="ml-2" v-if="live_credentials.is_active" v-on:click="updateCredentials('live', 0)" link type="primary" size="sm">Deactivate</base-button>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </collapsible-section>

                  <collapsible-section
                    v-if="activePaystackPill === 'webhook'"
                    title="Webhook"
                    icon="tim-icons icon-cloud-download-93"
                    :default-open="true"
                    class="stripe-section stripe-section--in-pill"
                  >
                    <info-hint variant="primary">
                      Paystack notifies OTC server to server the moment a
                      payment succeeds, so a booking is confirmed even if the
                      customer's browser drops mid-checkout. One-step setup:
                      paste the URL below into the Webhook URL field in your
                      Paystack dashboard under Settings, then API Keys &amp;
                      Webhook (fill it for both test and live mode). See
                      <a href="https://paystack.com/docs/payments/webhooks/" target="_blank">Paystack's guide</a>
                      for the full walkthrough.
                    </info-hint>

                    <!-- Endpoint URL -->
                    <div class="webhook-block">
                      <h5 class="webhook-block__title">Endpoint URL</h5>
                      <p class="webhook-block__sub">
                        Add this URL to your Paystack account as the webhook URL.
                      </p>
                      <div class="webhook-url">
                        <code class="webhook-url__value">https://api.offthecouch.io/paystack-webhook</code>
                        <button
                          type="button"
                          class="webhook-url__copy"
                          title="Copy URL"
                          v-on:click="copy('https://api.offthecouch.io/paystack-webhook')"
                        >
                          <i class="tim-icons icon-single-copy-04"></i>
                        </button>
                      </div>
                    </div>

                    <info-hint variant="neutral" icon="icon-lock-circle" class="mt-4">
                      Paystack has no separate webhook signing secret: each
                      webhook carries an HMAC SHA512 signature of the payload
                      made with your secret key, which OTC verifies
                      automatically once your API credentials are saved. Calls
                      are also only accepted from Paystack's published IP
                      addresses.
                    </info-hint>
                  </collapsible-section>

                </div>
              </div>
            </div>

<!--            <div class="row mb-5" v-if="payment_gateway.id === 4">-->
<!--              <div class="col-3 d-sm-block d-none">-->
<!--                <p class="text-primary" style="font-size: medium">Webhook  <badge class="ml-4" type="danger">important</badge>-->
<!--                </p>-->
<!--                <p v-if="payment_gateway.id === 4">Add the following webhook to your Paystack account.-->
<!--                  For more details, please follow this <a href="https://paystack.com/docs/payments/webhooks/" target="_blank">guide</a>.</p>-->
<!--              </div>-->
<!--              <div class="col d-sm-none d-block">-->
<!--                <label>Webhook  <badge class="ml-4" type="danger">important</badge>-->
<!--                </label>-->
<!--              </div>-->
<!--              <div class="col-lg-9">-->
<!--                <div class="row mt-3">-->
<!--                  <div class="col-lg-6">-->
<!--                    <base-alert type="white" class="text-muted">-->
<!--                      <div class="row">-->
<!--                        <div class="col-10">-->
<!--                          <code v-if="payment_gateway.id === 4"> https://api.offthecouch.io/paystack-webhook</code>-->
<!--                        </div>-->
<!--                        <div class="col text-right">-->
<!--                          <base-button class="like btn-link" style="padding: 0; margin: -10px"-->
<!--                                       type="default"-->
<!--                                       size="sm"-->
<!--                                       icon-->
<!--                                       v-on:click="copy('https://api.offthecouch.io/paystack-webhook')">-->
<!--                            <i class="tim-icons el-icon-copy-document"></i>-->
<!--                          </base-button>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </base-alert>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="row mt-3 mb-5" v-if="payment_gateway.id === 3">-->
<!--              <div class="col-3 d-sm-block d-none">-->
<!--                <p class="text-primary" style="font-size: medium">Custom description text-->
<!--                </p>-->
<!--                <p>Define the text that will appear on the description field on your Stripe dashboard.-->
<!--                </p>-->
<!--              </div>-->
<!--              <div class="col-lg-9">-->
<!--                <div class="row">-->
<!--                  <div class="col-lg-6">-->
<!--                    <label>Description-->
<!--                      <span class="text-danger">*</span>-->
<!--                    </label>-->
<!--                    <base-input v-model="credentials.custom_description"></base-input>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="row">-->
<!--                  <div class="col-lg-6">-->
<!--                    <base-button v-on:click="updateCredentials('live', 2)" simple type="success" size="sm">Save description</base-button>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

            <div v-if="false" class="mb-5">
              <div class="row">
                <div class="col-3 d-sm-block d-none">
                  <p class="text-primary" style="font-size: medium">Customer management
                  </p>
                  <p>Configure how Square handles customer data and payment methods for your transactions.
                  </p>
                </div>
                <div class="col d-sm-none d-block">
                  <label>Customer management</label>
                </div>
                <div class="col-lg-9">
                  <div class="row">
                    <div class="col">
                      <el-switch active-color="#e14eca"
                                 :disabled="squareSavingField === 'create_customer'"
                                 v-on:change="saveSquareCustomFields('customer', 'create_customer')"
                                 v-model="square_settings.create_customer"  />
                      <label class="text-white opacity-7"> &nbsp; Automatically create a customer in Square and link customers to payments</label>
                      <i v-if="squareSavingField === 'create_customer'" class="el-icon-loading ml-2 text-white"></i>
                    </div>
                  </div>
                  <div class="row mt-2" v-if="square_settings.create_customer">
                    <div class="col">
                      <el-switch active-color="#e14eca"
                                 :disabled="squareSavingField === 'store_credit_card'"
                                 v-on:change="saveSquareCustomFields('payment_method', 'store_credit_card')"
                                 v-model="square_settings.store_credit_card"  />
                      <label class="text-white opacity-7"> &nbsp; Enable saved payment methods (allow customers to store credit cards for future use)</label>
                      <i v-if="squareSavingField === 'store_credit_card'" class="el-icon-loading ml-2 text-white"></i>
                    </div>
                  </div>
                  <div class="row mt-2" v-if="square_settings.store_credit_card">
                    <div class="col">
                      <el-switch active-color="#e14eca"
                                 :disabled="squareSavingField === 'require_card_for_deposit'"
                                 v-on:change="saveSquareCustomFields('payment_method', 'require_card_for_deposit')"
                                 v-model="square_settings.require_card_for_deposit"  />
                      <label class="text-white opacity-7"> &nbsp; Require saved payment method for deposit payments</label>
                      <el-tooltip effect="light" placement="top" :open-delay="300">
                        <div slot="content" style="max-width: 300px">
                          Optional deposit: customers who decline will pay the full amount.<br>
                          Required deposit: customers must save their payment method to complete the booking.
                        </div>
                        <i class="el-icon-info ml-1" style="color: #1890ff; cursor: pointer"></i>
                      </el-tooltip>
                      <i v-if="squareSavingField === 'require_card_for_deposit'" class="el-icon-loading ml-2 text-white"></i>
                    </div>
                  </div>
                  <div class="row mt-2" v-if="square_settings.store_credit_card">
                    <div class="col">
                      <el-switch active-color="#e14eca"
                                 :disabled="squareSavingField === 'require_card_for_full_payment'"
                                 v-on:change="saveSquareCustomFields('payment_method', 'require_card_for_full_payment')"
                                 v-model="square_settings.require_card_for_full_payment"  />
                      <label class="text-white opacity-7"> &nbsp; Require saved payment method for full payments</label>
                      <el-tooltip effect="light" placement="top" :open-delay="300">
                        <div slot="content" style="max-width: 320px">
                          Forces customers who pay in full upfront (no deposit) to save their card on file. Useful for covering no-shows, damages, or incidentals.
                        </div>
                        <i class="el-icon-info ml-1" style="color: #1890ff; cursor: pointer"></i>
                      </el-tooltip>
                      <i v-if="squareSavingField === 'require_card_for_full_payment'" class="el-icon-loading ml-2 text-white"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="false" class="mb-5">
              <div class="row">
                <div class="col-3 d-sm-block d-none">
                  <p class="text-primary" style="font-size: medium">Custom note
                  </p>
                  <p>Define the text that will appear on the note field on your Square dashboard.
                  </p>
                </div>
                <div class="col d-sm-none d-block">
                  <label>Custom note</label>
                </div>
                <div class="col-lg-9">
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        placeholder="e.g., Booking for [Customer First Name] [Customer Last Name]"
                        v-model="square_settings.note" label="Note (max 500 characters)"></base-input>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-6">
                      <base-button size="sm" type="primary" v-on:click="saveSquareCustomFields()">
                        Save note
                      </base-button>
                    </div>
                  </div>
                  <p class="mt-3 card-title text-primary">Supported dynamic variables
                    <i class="tim-icons icon-minimal-down ml-1" v-on:click="show_dynamic_variables = !show_dynamic_variables" style="cursor: pointer"></i>
                  </p>
                  <div v-if="show_dynamic_variables">
                    <div>
                      <code>[Customer First Name]
                        <el-tooltip content="Copy" effect="light" :open-delay="300" placement="top">
                          <base-button @click.native="copy('[Customer First Name]')" class="like btn-link text-white" size="sm" icon>
                            <i class="tim-icons icon-single-copy-04"></i>
                          </base-button>
                        </el-tooltip>
                      </code>
                    </div>
                    <div>
                      <code>[Customer Last Name]
                        <el-tooltip content="Copy" effect="light" :open-delay="300" placement="top">
                          <base-button @click.native="copy('[Customer Last Name]')" class="like btn-link text-white" size="sm" icon>
                            <i class="tim-icons icon-single-copy-04"></i>
                          </base-button>
                        </el-tooltip>
                      </code>
                    </div>
                    <div>
                      <code>[Customer Phone]
                        <el-tooltip content="Copy" effect="light" :open-delay="300" placement="top">
                          <base-button @click.native="copy('[Customer Phone]')" class="like btn-link text-white" size="sm" icon>
                            <i class="tim-icons icon-single-copy-04"></i>
                          </base-button>
                        </el-tooltip>
                      </code>
                    </div>
                    <div>
                      <code>[Customer Email]
                        <el-tooltip content="Copy" effect="light" :open-delay="300" placement="top">
                          <base-button @click.native="copy('[Customer Email]')" class="like btn-link text-white" size="sm" icon>
                            <i class="tim-icons icon-single-copy-04"></i>
                          </base-button>
                        </el-tooltip>
                      </code>
                    </div>
                    <div>
                      <code>[Transaction ID]
                        <el-tooltip content="Copy" effect="light" :open-delay="300" placement="top">
                          <base-button @click.native="copy('[Transaction ID]')" class="like btn-link text-white" size="sm" icon>
                            <i class="tim-icons icon-single-copy-04"></i>
                          </base-button>
                        </el-tooltip>
                      </code>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Stripe/Square/Authorize.net/Paystack render credentials in
                 collapsible-sections higher up in the page. Remaining legacy
                 gateways (Yappy) keep the 2-column layout. -->
            <div class="row" v-if="payment_gateway.id !== 3 && payment_gateway.id !== 2 && payment_gateway.id !== 1 && payment_gateway.id !== 4">
              <div class="col-3 d-sm-block d-none">
                <p class="text-primary" style="font-size: medium">Test credentials
                  <badge class="ml-4" type="success" v-if="test_credentials.is_active">active</badge>
                  <badge class="ml-4" type="danger" v-else>inactive</badge>
                </p>
                <p>Use these credentials to execute payments in a sandbox environment. We recommend you test payments before going live.</p>
              </div>
              <div class="col d-sm-none d-block">
                <h4 class="card-list">Test credentials
                  <badge class="ml-4" type="success" v-if="test_credentials.is_active">active</badge>
                  <badge class="ml-4" type="danger" v-else>inactive</badge>
                </h4>
              </div>
              <div class="col-lg-9">
                <div v-if="!test_credentials.api_name">
                  <div class="row" v-if="!edit_test_creds">
                    <div class="col-lg-6">
                      <div class="font-icon-detail">
                    <span style="font-size: 3em">
                      <i class="fas fa-exclamation-triangle"></i>
                    </span>
                        <h4 class="mt-3">No credentials have been added.</h4>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="!edit_test_creds && payment_gateway" :key="'C' + j">
                    <div class="col-lg-6">
                      <base-button v-on:click="editTestCreds()" type="primary" size="sm">
                        <i class="tim-icons icon-simple-add mr-1"></i> Add credentials</base-button>
                    </div>
                  </div>
                  <div class="row" v-if="edit_test_creds" :key="'A' + j">
                    <div class="col-lg-6">
                      <label>{{api_name}}
                        <span class="text-danger">*</span>
                      </label>
                      <base-input v-on:change="j++" :error="err.test_credentials.api_name" v-model="test_credentials.api_name_edit"></base-input>
                    </div>
                  </div>
                  <div class="row" v-if="edit_test_creds" :key="'B' + j">
                    <div class="col-lg-6">
                      <label>{{api_key}}
                        <span class="text-danger">*</span>
                      </label>
                      <base-input v-on:change="j++" :error="err.test_credentials.api_key" :placeholder="test_credentials.has_api_key ? 'Enter the secret key again to save' : ''" v-model="test_credentials.api_key_edit"></base-input>
                    </div>
                  </div>
                  <div class="row" v-if="payment_gateway.id === 2 && edit_test_creds">
                    <div class="col-lg-6">
                      <label>{{api_location}}
                        <span class="text-danger">*</span>
                      </label>
                      <base-input v-on:change="j++" :error="err.test_credentials.api_location" v-model="test_credentials.api_location_edit"></base-input>
                    </div>
                  </div>
                  <div class="row" v-if="edit_test_creds">
                    <div class="col-lg-6">
                      <span >
                        <base-button class="mr-2" v-on:click="edit_test_creds = false" type="default" size="sm">Cancel</base-button>
                        <base-button  v-on:click="updateCredentials('test', 2)" type="primary" size="sm">Save</base-button>
                      </span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="row">
                    <div class="col-lg-6">
                      <label>{{api_name}}
                        <span class="text-danger">*</span>
                      </label>
                      <p v-if="!edit_test_creds">{{test_credentials.api_name}} </p>
                      <base-input v-else :error="err.test_credentials.api_name" v-model="test_credentials.api_name_edit"></base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <label>{{api_key}}
                        <span class="text-danger">*</span>
                      </label>
                      <p v-if="!edit_test_creds">••••••••••••••••••••••••••••••</p>
                      <base-input v-else :error="err.test_credentials.api_key" :placeholder="test_credentials.has_api_key ? 'Enter the secret key again to save' : ''" v-model="test_credentials.api_key_edit"></base-input>
                    </div>
                  </div>
                  <div class="row" v-if="payment_gateway.id === 2">
                    <div class="col-lg-6">
                      <label>{{api_location}}
                        <span class="text-danger">*</span>
                      </label>
                      <p v-if="!edit_test_creds">{{test_credentials.api_location}} </p>
                      <base-input v-else :error="err.test_credentials.api_location" v-model="test_credentials.api_location_edit"></base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                    <span v-if="edit_test_creds">
                      <base-button class="mr-2" v-on:click="edit_test_creds = false" type="default" size="sm">Cancel</base-button>
                      <base-button  v-on:click="updateCredentials('test', 2)" type="primary" size="sm">Save</base-button>
                    </span>
                      <span v-if="!edit_test_creds">
                       <base-button v-on:click="editTestCreds()" type="primary" size="sm">
                          <i class="tim-icons icon-pencil mr-1"></i> Edit</base-button>
                      <base-button class="ml-2" v-if="!test_credentials.is_active" v-on:click="updateCredentials('test', 1)" link type="primary" size="sm">Activate</base-button>
                      <base-button class="ml-2" v-if="test_credentials.is_active" v-on:click="updateCredentials('test', 0)" link type="primary" size="sm">Deactivate</base-button>
                    </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-5 mb-3" v-if="payment_gateway.id !== 3 && payment_gateway.id !== 2 && payment_gateway.id !== 1 && payment_gateway.id !== 4">
              <div class="col-3 d-sm-block d-none">
                <p class="text-primary" style="font-size: medium">Live credentials
                  <badge class="ml-4" type="success" v-if="live_credentials.is_active">active</badge>
                  <badge class="ml-4" type="danger" v-else>inactive</badge>
                </p>
                <p>Use these credentials to execute live payments.
                  Please ensure that you've tested your gateway before accepting real payments from your customers.
                </p>
              </div>
              <div class="col d-sm-none d-block">
                <h4 class="card-list">Live credentials
                  <badge class="ml-4" type="success" v-if="live_credentials.is_active">active</badge>
                  <badge class="ml-4" type="danger" v-else>inactive</badge>
                </h4>
              </div>
              <div class="col-lg-9">
                <div v-if="!live_credentials.api_name">
                  <div class="row" v-if="!edit_live_creds">
                    <div class="col-lg-6">
                      <div class="font-icon-detail">
                    <span style="font-size: 3em">
                      <i class="fas fa-exclamation-triangle"></i>
                    </span>
                        <h4 class="mt-3">No credentials have been added.</h4>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="!edit_live_creds && payment_gateway">
                    <div class="col-lg-6">
                      <base-button v-on:click="editLiveCreds()" type="primary" size="sm">
                        <i class="tim-icons icon-simple-add mr-1"></i> Add credentials</base-button>
                    </div>
                  </div>
                  <div class="row" v-if="edit_live_creds" :key="'E' + j">
                    <div class="col-lg-6">
                      <label>{{api_name}}
                        <span class="text-danger">*</span>
                      </label>
                      <base-input v-on:change="j++" :error="err.live_credentials.api_name" v-model="live_credentials.api_name_edit"></base-input>
                    </div>
                  </div>
                  <div class="row" v-if="edit_live_creds" :key="'F' + j">
                    <div class="col-lg-6">
                      <label>{{api_key}}
                        <span class="text-danger">*</span>
                      </label>
                      <base-input v-on:change="j++" :error="err.live_credentials.api_key" :placeholder="live_credentials.has_api_key ? 'Enter the secret key again to save' : ''" v-model="live_credentials.api_key_edit"></base-input>
                    </div>
                  </div>
                  <div class="row" v-if="payment_gateway.id === 2 && edit_live_creds" :key="'D' + j">
                    <div class="col-lg-6">
                      <label>{{api_location}}
                        <span class="text-danger">*</span>
                      </label>
                      <base-input v-on:change="j++" :error="err.live_credentials.api_location" v-model="live_credentials.api_location_edit"></base-input>
                    </div>
                  </div>
                  <div class="row" v-if="edit_live_creds">
                    <div class="col-lg-6">
                      <span >
                        <base-button class="mr-2" v-on:click="edit_live_creds = false" type="default" size="sm">Cancel</base-button>
                        <base-button  v-on:click="updateCredentials('live', 2)" type="primary" size="sm">Save</base-button>
                      </span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="row">
                    <div class="col-lg-6">
                      <label>{{api_name}}
                        <span class="text-danger">*</span>
                      </label>
                      <p v-if="!edit_live_creds">{{live_credentials.api_name}} </p>
                      <base-input v-else :error="err.live_credentials.api_name" v-model="live_credentials.api_name_edit"></base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <label>{{api_key}}
                        <span class="text-danger">*</span>
                      </label>
                      <p v-if="!edit_live_creds">••••••••••••••••••••••••••••••</p>
                      <base-input v-else :error="err.live_credentials.api_key" :placeholder="live_credentials.has_api_key ? 'Enter the secret key again to save' : ''" v-model="live_credentials.api_key_edit"></base-input>
                    </div>
                  </div>
                  <div class="row" v-if="payment_gateway.id === 2">
                    <div class="col-lg-6">
                      <label>{{api_location}}
                        <span class="text-danger">*</span>
                      </label>
                      <p v-if="!edit_live_creds">{{live_credentials.api_location}} </p>
                      <base-input v-else :error="err.live_credentials.api_location" v-model="live_credentials.api_location_edit"></base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <span v-if="edit_live_creds">
                        <base-button class="mr-2" v-on:click="edit_live_creds = false" type="default" size="sm">Cancel</base-button>
                        <base-button  v-on:click="updateCredentials('live', 2)" type="primary" size="sm">Save</base-button>
                      </span>
                      <span v-if="!edit_live_creds">
                         <base-button v-on:click="editLiveCreds()" type="primary" size="sm">
                            <i class="tim-icons icon-pencil mr-1"></i> Edit</base-button>
                        <base-button class="ml-2" v-if="!live_credentials.is_active" v-on:click="updateCredentials('live', 1)" link type="primary" size="sm">Activate</base-button>
                        <base-button class="ml-2" v-if="live_credentials.is_active" v-on:click="updateCredentials('live', 0)" link type="primary" size="sm">Deactivate</base-button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="modals.custom_payment"
           body-classes="p-0"
           modal-classes="modal-dialog-centered modal-lg">
      <card type="secondary" :key="j + 'CPMM'"
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0 mb-0">
        <h4 v-if="payment_method.action === 'editing'" class="card-title">Edit custom payment</h4>
        <h4 v-else class="card-title">Create custom payment</h4>
        <div class="row">
          <div class="col-lg-12">
            <label>Payment method name
              <el-popover trigger="hover"
                          placement="right">

                <div>
                  <div class="popover-body">This is the name of the payment method as it will appear on the booking site.</div>
                </div>
                <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
              </el-popover>
            </label>
            <base-input :error="payment_method.name_error" placeholder="e.g. Bank Transfer" v-model="payment_method.name"></base-input>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <label>Payment method content
              <el-popover trigger="hover"
                          placement="right">

                <div>
                  <div class="popover-body">This content will appear to your customer when they select this <br> payment method on the booking site.</div>
                </div>
                <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
              </el-popover>
            </label>
            <rich-text-editor
              v-if="modals.custom_payment"
              v-model="payment_method.content"
              :height="200"
              toolbar="basic"
              placeholder="Enter payment instructions..."
            />
          </div>
        </div>

        <div class="row mt-2">
          <div class="col">
            <el-switch active-color="#e14eca"
                       v-model="payment_method.enabled_internally" />
            <label class="text-white"> &nbsp; Activate on internal payments</label>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <el-switch active-color="#e14eca"
                       v-model="payment_method.enabled_externally" />
            <label class="text-white"> &nbsp; Activate on booking site</label>
          </div>
        </div>
        <div class="row" v-if="payment_method.enabled_externally">
          <div class="col">
            <el-switch active-color="#e14eca"
                       v-model="payment_method.mark_booking_site_unpaid" />
            <label class="text-white"> &nbsp; Mark booking site payments as unpaid
              <el-popover trigger="hover"
                          placement="right">

                <div>
                  <div class="popover-body">When enabled, payments made through the booking site using this method <br> will be marked as unpaid until you manually confirm receipt of payment.</div>
                </div>
                <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
              </el-popover>
            </label>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col text-center">
            <base-button type="default" v-on:click="modals.custom_payment = false">Cancel</base-button>
            <base-button type="primary" v-if="payment_method.hasOwnProperty('id') && payment_method.id" v-on:click="updatePaymentMethod()" class="ml-2">Save</base-button>
            <base-button type="primary" v-else v-on:click="createPaymentMethod()" class="ml-2">Save</base-button>
          </div>
        </div>
      </card>
    </modal>

  </div>
</template>


<script>
import {API_LOCATION} from "@/api-config";
import {Auth} from "aws-amplify";
import BaseAlert from "@/components/BaseAlert";
import axios from "axios";
import Badge from "@/components/Badge";
import TabRail from "@/components/TabRail.vue";
import { BaseSwitch } from '@/components';
import {TimePicker, Form, FormItem, Upload, Dialog, Dropdown, DropdownItem, DropdownMenu, Switch} from "element-ui";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import BreadcrumbItem from "@/components/Breadcrumb/BreadcrumbItem";
import CollapsibleSection from "@/pages/Bookings/BookinSiteSettings/components/shared/CollapsibleSection";
import {BTable, BPagination} from "bootstrap-vue";
import {formattedDate, localTime, time} from "@/plugins/dateFormatter";
import {formatGroupDate, formatGroupTime} from "@/plugins/dates";
import _ from "lodash";
import currencies from "@/assets/currencies.json";
import draggable from "vuedraggable";
import { ImageUpload } from '@/components';
import RichTextEditor from '@/components/RichTextEditor'

export default {
  name: "PaymentGateways",
  components: {BaseAlert, Badge, BaseSwitch, CollapsibleSection, TabRail,
    [TimePicker.name]: TimePicker,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Upload.name]: Upload,
    [Dialog.name]: Dialog,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Switch.name]: Switch,
    ImageUpload,
    draggable,
    RichTextEditor,
    Breadcrumb, BreadcrumbItem, BTable, BPagination},

  data() {
    return {
      invoices_address_sources: ['company', 'group'],
      payment_layout_types: ['dropdown', 'buttons'],
      confirmDialog: { show: false, title: '', message: '', confirmText: 'Confirm', confirmVariant: 'primary', variant: 'warning', resolve: null },
      webhook_secret: '',
      webhook_secret_edit: '',
      edit_webhook_secret: false,
      stripe_webhook: { live: null, test: null },
      credentialsAlert: { show: false, title: '', message: '', variant: 'success' },
      edit_signature: false,
      square_hardware_types: [],
      square_settings: { note: '', create_customer: false, webhook_signature: '', store_credit_card: false, require_card_for_deposit: false, require_card_for_full_payment: false},
      squareSavingField: '',
      stripe_settings: { custom_description: '', create_customer: false, store_credit_card: false, require_card_for_deposit: false, require_card_for_full_payment: false},
      stripeSavingField: '',
      show_dynamic_variables: false,
      edit_test_creds: false,
      edit_live_creds: false,
      payment_method: {id: 0, name: 'asdasd', status: 1, content: 'asdsd'},
      payment_methods: [{id: 0, name: 'Card', status: 1, content: ''}, {id: 1, name: 'Gift card', status: 1, content: ''}],
      request_periods: [{id: 0, label: 'minute(s)'}, {id: 1, label: 'hour(s)'}, {id: 2, label: 'day(s)'}, {id: 3, label: 'week(s)'}, {id: 4, label: 'month(s)'}],
      periods: [{id: 0,label: 'day(s)'}, {id: 1, label: 'week(s)'}, {id: 2, label: 'month(s)'}, {id: 3,label: 'year(s)'}],
      tip_preset_values: [],
      purchasable_items_taxes: [],
      purchasable_items_fees: [],
      selected_purchasable_items: [],
      group: '',
      currencies: currencies.currencies,
      currency: JSON.parse(localStorage.getItem('group')).currency,
      currency_symbol: '$',
      picker_time_format: 'hh:mm A',
      loading: false,
      empty: false,
      api_name: '',
      api_key: '',
      api_location: '',
      payment_gateways: '',
      payment_settings: '',
      payment_gateway: '',
      credentials: '',
      gateway_configured: true,
      games: [],
      valueTypesTipping: [
        {
          name: 'Percentage of subtotal',
          id: 0
        },
        {
          name: 'Flat value',
          id: 1
        }
      ],
      err: {
        live_credentials: {
          api_name: '',
          api_key: '',
          api_location: '',
        },
        test_credentials: {
          api_name: '',
          api_key: '',
          api_location: '',
        }
      },
      test_credentials: {
        api_name: '',
        api_key: '',
        has_api_key: false,
        api_location: '',
        is_active: 0,
        td_api_enabled: null,
        api_name_edit: '',
        api_key_edit: '',
        api_location_edit: '',
      },
      live_credentials: {
        api_name: '',
        api_key: '',
        has_api_key: false,
        api_location: '',
        is_active: 0,
        td_api_enabled: null,
        api_name_edit: '',
        api_key_edit: '',
        api_location_edit: '',
      },
      activeTabIndex: 0,
      j: 0,
      time_format: JSON.parse(localStorage.getItem('group')).time_format,
      date_format: JSON.parse(localStorage.getItem('group')).date_format,
      date_format_cal: '',
      create_new_tax: false,
      create_new_fee: false,
      taxes: [],
      fees: [],
      pricing_type: '',
      value_type: '',
      tax_title: '',
      tax_number: '',
      tax_amount: '',
      tax_amount_precision: 2,
      tax_amount_label: 'Percentage amount (%)',
      is_compound_tax: false,
      optional_tax: false,
      optional_fee: false,
      covered_by_promo_codes: false,
      apply_after_discount: true,
      show_tax_line_items: false,
      apply_to_all_items: true,
      pricingTypes: [
        {
          id: 0,
          name: 'Exclusive – Tax is added on top of item prices'
        },{
          id: 1,
          name: 'Inclusive – Tax is included in item prices'
        }
      ],
      valueTypesTaxes: [],
      errs: {
        payment_request_timeout_value: '',
        payment_request_threshold: '',
        tos_url: '',
        redirect_url: '',
        tax_title: '',
        pricing_type: '',
        value_type: '',
        tax_amount: '',
        tax_amount_precision: '',
        fee_title: '',
        fee_value_type: '',
        fee_value: '',
        webhook_signature: '',
        hardware_type: '',
        pay_on_arrival_text: '',
        webhook_secret: ''
      },
      selectedTaxId: '',
      selectedFeeId: '',
      fee: {
        title: '',
        value_type: '',
        amount: '',
        amount_precision: 2,
      },
      modals: {
        custom_payment: false,
        add_tip_option: false,
      },
      // Stripe Terminal smart readers (S700/S710/etc.) registered to this
      // venue's Location. List comes from companies-list-pos-readers which
      // wraps Stripe's terminal.readers.list scoped to our auto-created
      // stripe_settings.stripe_terminal_location_id. No local cache —
      // Stripe is the source of truth.
      readers: [],
      readersLoading: false,
      // Every Terminal Location in the venue's Stripe account, with reader
      // counts, from the same /stripe-readers GET. Drives the location picker.
      stripeLocations: [],
      locationSaving: false,
      // Stripe Terminal Location ID (tml_xxx) — auto-created by
      // companies-register-pos-reader from the group's address on first
      // reader registration. Surfaced read-only in the Hardware pill so
      // admins can cross-reference Stripe Dashboard.
      stripeTerminalLocationId: null,
      editingReaderId: null,
      editingReaderLabel: '',
      connectReaderForm: {
        open: false,
        code: '',
        label: '',
        error: '',
        submitting: false,
      },
      // Stripe gateway pill sub-nav. One of: 'credentials' | 'webhook' |
      // 'policies' | 'hardware'. Hydrated to the first incomplete pill
      // on entry (see initStripePill).
      activeStripePill: 'connect',
      // Square gateway pill sub-nav (mirrors the Stripe layout).
      activeSquarePill: 'connect',
      activePaystackPill: 'credentials',
      // Square OAuth (in-person Tap to Pay) connection state. Hydrated from the
      // ?square_connected= return param and (later) a GET status fetch.
      squareOauth: { connected: false, merchant_id: null, location_id: null, is_live: 0 },
      squareConnecting: false,
      // Environment for a NEW Square connection. Live is the default — real
      // venues connect their production Square account; sandbox is for OTC
      // testing with a Square developer test account (a production login on
      // the sandbox authorize page renders a blank screen).
      squareConnectEnv: 'production',
      // Stripe Connect connection state for the live Stripe row. Hydrated by
      // fetchStripeConnection (GET .../stripe-connection) and the
      // ?stripe_connected= return param (handleStripeReturn).
      // test_mode 1 means the is_live = 0 row is active for the same account (PUT stripe-connection).
      stripeConnect: { state: 'none', is_live: 1, test_mode: 0, account_id: null, connected_at: null, platform_controlled: null, charges_enabled: null, has_api_key: false },
      stripeConnecting: false,
      stripeTestModeSaving: false,
      stripeConnectAcknowledged: false,
      // False until the first stripe-connection GET settles. The pill rail and panel wait for it
      // so the Credentials and Webhook pills never flash in and out while the state loads.
      stripeConnectLoaded: false,
      selectedTipOption: '',
      square_device_codes: [],
    }
  },
  computed: {
    // ─── Stripe pill sub-nav ──────────────────────────────────────────
    // The Credentials pill (pasted API keys) only exists for venues that already
    // have keys. Everyone else connects through Stripe Connect.
    showStripeCredentialsPill() {
      return !!(this.live_credentials.api_name || this.live_credentials.has_api_key
        || this.test_credentials.api_name || this.test_credentials.has_api_key);
    },
    stripePills() {
      return [
        { id: 'connect',     label: 'Connection',  icon: 'tim-icons icon-link-72' },
        // Keys and the per-venue webhook do nothing while connected (platform key + Connect
        // webhook take over); both pills return on disconnect. Keys stay stored meanwhile.
        ...(this.showStripeCredentialsPill && !this.stripeConnected ? [{ id: 'credentials', label: 'Credentials', icon: 'tim-icons icon-key-25' }] : []),
        ...(!this.stripeConnected ? [{ id: 'webhook',     label: 'Webhook',     icon: 'tim-icons icon-cloud-download-93' }] : []),
        { id: 'policies',    label: 'Policies',    icon: 'tim-icons icon-single-02' },
        { id: 'hardware',    label: 'Hardware',    icon: 'tim-icons icon-mobile' },
      ];
    },
    // The Stripe row the webhook lambda reads: active row, else live, else test.
    activeStripeWebhook() {
      const w = this.stripe_webhook
      if (w.live && w.live.is_active) return w.live
      if (w.test && w.test.is_active) return w.test
      return w.live || w.test || null
    },
    activeStripeWebhookMode() {
      const w = this.stripe_webhook
      if (w.live && w.live.is_active) return 'live'
      if (w.test && w.test.is_active) return 'test'
      return w.live ? 'live' : 'test'
    },
    // Per-pill completion state, drives the dot indicator on each pill.
    // A Stripe Connect connection (any stage) replaces pasted live keys.
    stripeConnected() {
      return ['connected', 'onboarding', 'controlled'].includes(this.stripeConnect.state);
    },
    stripeConnectBadge() {
      if (this.stripeConnect.state === 'onboarding') return 'Onboarding';
      if (this.stripeTestModeOn) return 'Test mode';
      return this.stripeConnected ? 'Connected' : 'Not connected';
    },
    stripeTestModeOn() {
      return this.stripeConnected && this.stripeConnect.test_mode === 1;
    },
    // The switch exists only on a live-mode connection that can take charges.
    stripeTestModeAvailable() {
      return ['connected', 'controlled'].includes(this.stripeConnect.state) && this.stripeConnect.is_live !== 0 && this.stripeConnect.charges_enabled === 1;
    },
    // Which pasted key pair the connection replaces. Venues connect in live mode; the OTC test
    // group connects in test mode (is_live 0 from the GET), so its test keys are the ones hidden.
    stripeConnectedLive() {
      return this.stripeConnected && this.stripeConnect.is_live !== 0;
    },
    stripeConnectedTest() {
      return this.stripeConnected && this.stripeConnect.is_live === 0;
    },
    stripePillStatus() {
      return {
        connect:     this.stripeConnected ? 'ok' : 'incomplete',
        credentials: this.live_credentials.api_name ? 'ok' : 'incomplete',
        webhook:     this.webhook_secret ? 'ok' : 'incomplete',
        policies:    'neutral', // toggles — no binary "configured/not" reading
        hardware:    this.readers.length > 0 ? 'ok' : 'neutral',
      };
    },
    // Overall connection state shown in the left rail. Loose definition:
    // Connected = live keys set. Webhook signing secret is technically
    // optional (the system works without it; it just disables Stripe-side
    // signature verification on incoming webhooks). Webhook state has its
    // own pill-level status indicator, so the rail roll-up only tracks
    // the truly-required piece.
    railStatus() {
      if (this.stripeConnected || this.live_credentials.api_name) return { tone: 'ok', label: 'Connected' };
      return { tone: 'off', label: 'Not configured' };
    },
    // ─── Authorize.net Transaction Details API status ───────────────────
    // Drives the verification hint in the gateway identity row. Reads the
    // credential set that is actually in use (live first). Returns null when
    // no Authorize.net credentials exist yet (hint hidden).
    authnetTdStatus() {
      if (!this.payment_gateway || this.payment_gateway.id !== 1) return null;
      // Status follows the ACTIVE credential set (the one charges actually use),
      // not merely whichever set has values: a stale inactive live row must not
      // mask the verified state of the active test row, and vice versa.
      const creds = this.live_credentials.is_active ? this.live_credentials
        : (this.test_credentials.is_active ? this.test_credentials
        : (this.live_credentials.api_name ? this.live_credentials
        : (this.test_credentials.api_name ? this.test_credentials : null)));
      if (!creds) return null;
      if (creds.td_api_enabled === 1) return 'on';
      if (creds.td_api_enabled === 0) return 'off';
      return 'unknown';
    },
    // ─── Square pill sub-nav (mirrors the Stripe layout) ───────────────
    squarePills() {
      return [
        { id: 'credentials', label: 'Online keys', icon: 'tim-icons icon-key-25' },
        { id: 'connect',     label: 'In-person',   icon: 'tim-icons icon-mobile' },
        { id: 'customer',    label: 'Customer',    icon: 'tim-icons icon-single-02' },
      ];
    },
    squarePillStatus() {
      return {
        credentials: this.live_credentials.api_name ? 'ok' : 'incomplete',
        connect:     this.squareOauth.connected ? 'ok' : 'incomplete',
        customer:    'neutral',
      };
    },
    // Connected = live online keys set OR an in-person OAuth connection exists.
    squareRailStatus() {
      if (this.live_credentials.api_name || this.squareOauth.connected) return { tone: 'ok', label: 'Connected' };
      return { tone: 'off', label: 'Not configured' };
    },
    // ─── Paystack pill sub-nav (mirrors the Stripe layout) ─────────────
    paystackPills() {
      return [
        { id: 'credentials', label: 'Credentials', icon: 'tim-icons icon-key-25' },
        { id: 'webhook',     label: 'Webhook',     icon: 'tim-icons icon-cloud-download-93' },
      ];
    },
    paystackPillStatus() {
      return {
        credentials: this.live_credentials.api_name ? 'ok' : 'incomplete',
        // Whether the merchant pasted the URL into their Paystack dashboard
        // is not observable from here, so the webhook pill never claims a
        // configured/not state. Verification readiness (secret key on file)
        // is shown inside the panel instead.
        webhook: 'neutral',
      };
    },
    paystackRailStatus() {
      if (this.live_credentials.api_name) return { tone: 'ok', label: 'Connected' };
      return { tone: 'off', label: 'Not configured' };
    },
    isMobile() {
      const userAgent = navigator.userAgent;
      const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      return mobileRegex.test(userAgent);
    },
    companyId() {
      return localStorage.getItem('companyId')
    },
    companyGroupId() {
      return JSON.parse(localStorage.getItem('group')).id
    },
    categories() {
      return [
        { name: 'General settings', shortName: 'General' },
        { name: 'Payment methods', shortName: 'Methods' },
        { name: 'Taxes', shortName: 'Taxes' },
        { name: 'Fees', shortName: 'Fees' },
        { name: 'Payment gateways', shortName: 'Gateways' }
      ];
    }
  },
  methods: {
    capitalizeFirstLetter(string){
      if (!string) {
        return string;
      }
      string = string.replace(/_/g, ' ');
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    editWebhookSecret() {
      this.webhook_secret_edit = ''
      this.edit_webhook_secret = true
      this.errs.webhook_secret = ''
    },
    cancelWebhookSecretEdit() {
      this.edit_webhook_secret = false
      this.webhook_secret_edit = ''
      this.errs.webhook_secret = ''
    },

    async removeWebhookSecret() {
      const confirmed = await this.askConfirm({
        title: 'Remove webhook secret?',
        message: 'This will disable webhook signature verification. Webhooks will still be processed but without security validation.',
        confirmText: 'Remove',
        confirmVariant: 'danger',
        variant: 'danger'
      })

      if (confirmed) {
        await this.updateWebhookSecret('')
      }
    },

    async saveWebhookSecret() {
      // Validate webhook secret format
      const secret = (this.webhook_secret_edit || '').trim()
      if (secret && !/^whsec_[A-Za-z0-9]{32,}$/.test(secret)) {
        this.errs.webhook_secret = 'A signing secret starts with whsec_ followed by at least 32 letters and digits. Copy it from the endpoint at the Off The Couch URL in Stripe.'
        return
      }
      this.webhook_secret_edit = secret

      await this.updateWebhookSecret(this.webhook_secret_edit)
    },

    async updateWebhookSecret(secret) {
      this.loading = true

      try {
        const token = await this.getAuthToken()
        const config = { headers: { Authorization: token } }
        const companyId = localStorage.getItem('companyId')
        const settingsId = this.$route.query.id

        // You'll need to create this endpoint in your backend
        const url = `${API_LOCATION}companies/${companyId}/payment-settings/${settingsId}/webhook-secret`

        const data = {
          webhook_secret: secret,
          payment_gateway_id: this.payment_gateway.id
        }

        await axios.put(url, data, config)

        this.webhook_secret = secret ? '••••••••••••••••••••••••••••••' : ''
        this.edit_webhook_secret = false
        this.webhook_secret_edit = ''
        this.errs.webhook_secret = ''

        if (secret) {
          this.notifySuccess('Webhook secret has been saved. Signature verification is now enabled.')
        } else {
          this.notifySuccess('Webhook secret has been removed. Signature verification is disabled.')
        }

        // Optionally refresh payment settings
        await this.getPaymentSettings()

      } catch (error) {
        console.error('Error updating webhook secret:', error)

        if (error.response?.status === 401) {
          this.$router.push('/forbidden')
        } else {
          this.notifyError('Failed to update webhook secret')
        }
      } finally {
        this.loading = false
      }
    },
    setUpPaymentGateway(){
      this.gateway_configured = false
    },
    allowExternally(item){
      if(item.is_default && (item.name === 'Cash' || item.name === 'Customer credit' || item.name === 'POS payment')){
        return false
      }
      return true
    },
    getLinks(linkString){
      let arr = JSON.parse(linkString)
      return arr.map(item => item.name).join(', ');
    },
    addAllPurchaseTypes(collection, type) {
      const existingIds = new Set(this.selected_purchasable_items.map(item => item.id));
      const newItems = collection.filter(item => item.item_type === type && !existingIds.has(item.id));
      this.selected_purchasable_items = this.selected_purchasable_items.concat(newItems);
    },
    validateHardwareFields(){
      let errors = 0
      if(!this.square_settings.hardware_type){
        this.errs.hardware_type = 'You must select a hardware type'
        errors++
      } else {
        this.errs.hardware_type = ''
      }

      if((!this.square_settings.has_signature && this.square_settings.webhook_signature === '') ||
        (this.square_settings.has_signature && this.square_settings.webhook_signature === '' && this.edit_signature)){
        this.errs.webhook_signature = 'You must add the Signature key'
        errors++
      } else {
        this.errs.webhook_signature = ''
      }

      return errors > 0 ? false : true
    },
    async saveSquareCustomFields(source, field){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let settingsId = this.$route.query.id
      let url = API_LOCATION + 'companies/' + companyId + '/payment-settings/' + settingsId
        +  '/square-settings'

      // If disabling create_customer, also disable store_credit_card and both require_card flags
      let alsoDisableStoreCreditCard = false
      if(source === 'customer' && !this.square_settings.create_customer){
        this.square_settings.store_credit_card = false
        this.square_settings.require_card_for_deposit = false
        this.square_settings.require_card_for_full_payment = false
        alsoDisableStoreCreditCard = true
      }

      // If disabling store_credit_card, also disable both require_card flags
      if(source === 'payment_method' && !this.square_settings.store_credit_card){
        this.square_settings.require_card_for_deposit = false
        this.square_settings.require_card_for_full_payment = false
      }

      let data = { ...this.square_settings }
      if(source === 'customer'){
        data.customer = 1
        if(alsoDisableStoreCreditCard){
          data.payment_method = 1
        }
      }
      if(source === 'payment_method'){
        data.payment_method = 1
      }

      if(source === 'hardware'){
        if(!this.validateHardwareFields()){
          return
        }
        data.hardware_type_id = data.hardware_type.id
        data.hardware = 1
        data.update_webhook_key = (this.square_settings.has_signature && this.edit_signature) || !this.square_settings.has_signature ? 1 : 0
      }

      this.squareSavingField = field || ''
      axios.put(url, data, config)
        .then((res) => {
          this.$notify({ type: 'success', message: 'Square settings have been updated', timeout: 3000 })
          this.squareSavingField = ''
        })
        .catch((err) => {
          this.squareSavingField = ''
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })
    },
    // ─── Stripe pill sub-nav ──────────────────────────────────────────
    initStripePillForFirstIncomplete() {
      // On entering the Stripe gateway tab, land on the Connection pill: it is the
      // first step for a new venue and the home state for a connected one. A venue
      // on pasted keys stays there too (connecting replaces the keys and the venue
      // webhook), so the Credentials and Webhook pills are reached by clicking.
      this.activeStripePill = 'connect';
    },

    setStripePill(id) {
      this.activeStripePill = id;
      // Fetch readers lazily — only when the user opens the Hardware
      // pill (avoids a Stripe API round-trip on every page load when
      // most admins won't visit Hardware).
      if (id === 'hardware') {
        void this.fetchReaders();
      }
    },
    setSquarePill(id) {
      this.activeSquarePill = id;
    },
    // Kick off the Square OAuth connect: ask the backend for the authorize URL
    // (POST .../payment-settings/{settingsId}/square-connection) and send the
    // admin to Square's consent screen. Square returns to the console at
    // SQUARE_OAUTH_CONSOLE_RETURN_URL?square_connected=... (see handleSquareReturn).
    // Environment comes from the Live/Sandbox segmented toggle next to the
    // connect button (squareConnectEnv, default 'production'). The backend
    // (square-oauth-start/-callback) branches on it end to end: authorize
    // host, client id/secret env vars, and the is_live flag on the stored row.
    async connectSquare(environment = 'sandbox') {
      if (this.squareConnecting) return;
      this.squareConnecting = true;
      try {
        const token = await this.getAuthToken();
        const companyId = localStorage.getItem('companyId');
        const settingsId = this.$route.query.id || (this.payment_settings && this.payment_settings.id);
        const url = `${API_LOCATION}companies/${companyId}/payment-settings/${settingsId}/square-connection`;
        const res = await axios.post(url, { environment }, { headers: { Authorization: token } });
        const authorizeUrl = res.data && res.data.authorize_url;
        if (authorizeUrl) {
          // Keep the button in its "Starting…" spinner state through the
          // navigation: assigning location.href doesn't block, so resetting
          // here (the old finally) flipped the button back to "Connect
          // Square" for the seconds the browser takes to reach Square's
          // page, which reads as a dead click. Safety timer recovers the
          // button if navigation never happens (e.g. back-nav restores this
          // page from the bfcache with the flag still set).
          window.location.href = authorizeUrl;
          setTimeout(() => { this.squareConnecting = false; }, 8000);
          return;
        }
        this.$notify({ type: 'danger', message: 'Could not start the Square connection.' });
        this.squareConnecting = false;
      } catch (err) {
        const body = err.response && err.response.data;
        const parsed = typeof body === 'string' ? body : (body && body.error);
        this.$notify({ type: 'danger', message: parsed || 'Could not start the Square connection.' });
        this.squareConnecting = false;
      }
    },
    // Read the ?square_connected= status the callback redirected back with,
    // surface a toast, and strip it off the URL (keeping ?id) so a refresh
    // doesn't re-fire.
    handleSquareReturn() {
      const params = new URLSearchParams(window.location.search);
      const status = params.get('square_connected');
      if (!status) return;
      if (status === 'success') {
        this.$notify({ type: 'success', message: 'Square account connected.' });
        this.squareOauth.connected = true;
        this.fetchSquareStatus(); // hydrate merchant/location from the stored row
      } else if (status === 'denied') {
        this.$notify({ type: 'warning', message: 'Square connection was cancelled.' });
      } else {
        this.$notify({ type: 'danger', message: `Square connection failed (${params.get('reason') || 'error'}).` });
      }
      // Strip only the OAuth-return params; keep id, tab, and anything else.
      params.delete('square_connected');
      params.delete('reason');
      const qs = params.toString();
      window.history.replaceState({}, document.title, window.location.pathname + (qs ? `?${qs}` : ''));
    },
    // Read the persisted Square OAuth connection (GET .../square-connection) so
    // the In-person panel shows Connected + merchant/location across reloads,
    // not just from the post-connect redirect flag.
    async fetchSquareStatus() {
      try {
        const token = await this.getAuthToken();
        const companyId = localStorage.getItem('companyId');
        const settingsId = this.$route.query.id || (this.payment_settings && this.payment_settings.id);
        if (!settingsId) return;
        const url = `${API_LOCATION}companies/${companyId}/payment-settings/${settingsId}/square-connection`;
        const res = await axios.get(url, { headers: { Authorization: token } });
        const data = res.data || {};
        if (data.connected && data.connection) {
          this.squareOauth = {
            connected: true,
            merchant_id: data.connection.merchant_id,
            location_id: data.connection.location_id,
            is_live: data.connection.is_live,
          };
        } else {
          this.squareOauth = { connected: false, merchant_id: null, location_id: null, is_live: 0 };
        }
      } catch (err) {
        // Non-fatal — leave the panel as-is.
        console.debug('[square] status fetch failed', err);
      }
    },
    async disconnectSquare() {
      const confirmed = await this.askConfirm({
        title: 'Disconnect Square?',
        message: "Staff won't be able to take in-person payments on this venue until you reconnect.",
        confirmText: 'Disconnect',
        confirmVariant: 'danger',
        variant: 'danger'
      });
      if (!confirmed) return;
      try {
        const token = await this.getAuthToken();
        const companyId = localStorage.getItem('companyId');
        const settingsId = this.$route.query.id || (this.payment_settings && this.payment_settings.id);
        const url = `${API_LOCATION}companies/${companyId}/payment-settings/${settingsId}/square-connection`;
        await axios.delete(url, { headers: { Authorization: token } });
        this.squareOauth = { connected: false, merchant_id: null, location_id: null, is_live: 0 };
        this.$notify({ type: 'success', message: 'Square account disconnected.' });
      } catch (err) {
        const body = err.response && err.response.data;
        const parsed = typeof body === 'string' ? body : (body && body.error);
        this.$notify({ type: 'danger', message: parsed || 'Could not disconnect Square.' });
      }
    },

    // ─── Stripe Connect (connect an existing Stripe account, or create one) ──
    // POST .../stripe-connection { mode, acknowledged } returns { url }: Stripe's
    // OAuth consent screen (mode 'oauth') or a Stripe-hosted onboarding link
    // (mode 'create'). Stripe returns to this page with ?stripe_connected=...
    // (see handleStripeReturn). The acknowledgement checkbox is the venue's
    // consent to platform control; the backend rejects the call without it.
    async connectStripe(mode) {
      if (this.stripeConnecting) return;
      // Platform-control consent, read once at the moment of connecting. Skipped while an
      // onboarding account already exists (Continue onboarding, expired-link refresh).
      if (!this.stripeConnected && !this.stripeConnectAcknowledged) {
        const agreed = await this.askConfirm({
          variant: 'primary',
          title: 'Connect to Stripe',
          message: `Stripe may place this account under Off The Couch's platform control. That lets Off The Couch manage the point of sale app on your Stripe readers${this.showStripeCredentialsPill ? ' and replaces the live API keys in the Credentials pill' : ''}. Payments keep settling in your own Stripe account and you keep your dashboard. Saved cards stay with the Stripe account they were saved in.`,
          confirmText: 'I agree, continue to Stripe',
        });
        if (!agreed) return;
        this.stripeConnectAcknowledged = true;
      }
      this.stripeConnecting = true;
      try {
        const token = await this.getAuthToken();
        const companyId = localStorage.getItem('companyId');
        const settingsId = this.$route.query.id || (this.payment_settings && this.payment_settings.id);
        const url = `${API_LOCATION}companies/${companyId}/payment-settings/${settingsId}/stripe-connection`;
        // Consent was given in the confirm dialog, or earlier for an account that already exists.
        const res = await axios.post(url, { mode, acknowledged: this.stripeConnectAcknowledged || this.stripeConnected }, { headers: { Authorization: token } });
        const redirectUrl = res.data && res.data.url;
        if (redirectUrl) {
          // Keep the spinner through the navigation (see connectSquare).
          window.location.href = redirectUrl;
          setTimeout(() => { this.stripeConnecting = false; }, 8000);
          return;
        }
        this.$notify({ type: 'danger', message: 'Could not start the Stripe connection.' });
        this.stripeConnecting = false;
      } catch (err) {
        const body = err.response && err.response.data;
        const parsed = typeof body === 'string' ? body : (body && body.error);
        this.$notify({ type: 'danger', message: parsed || 'Could not start the Stripe connection.' });
        this.stripeConnecting = false;
      }
    },
    // Read the ?stripe_connected= status the callback or Account Link returned
    // with, surface a toast, refresh the stored state, and strip the params
    // (keeping ?id) so a reload does not re-fire.
    handleStripeReturn() {
      const params = new URLSearchParams(window.location.search);
      const status = params.get('stripe_connected');
      if (!status) return;
      if (status === 'success') {
        this.$notify({ type: 'success', message: 'Stripe account connected.' });
        this.fetchStripeConnection(true);
      } else if (status === 'onboarding') {
        this.$notify({ type: 'info', message: 'Stripe onboarding finished. Checking the account.' });
        this.fetchStripeConnection(true);
      } else if (status === 'refresh') {
        // The onboarding link expired; the account already exists, so re-issue it.
        this.stripeConnectAcknowledged = true;
        this.connectStripe('create');
      } else if (status === 'denied') {
        this.$notify({ type: 'warning', message: 'Stripe connection was cancelled.' });
      } else {
        this.$notify({ type: 'danger', message: `Stripe connection failed (${params.get('reason') || 'error'}).` });
      }
      params.delete('stripe_connected');
      params.delete('reason');
      const qs = params.toString();
      window.history.replaceState({}, document.title, window.location.pathname + (qs ? `?${qs}` : ''));
    },
    // GET .../stripe-connection (?refresh=1 re-reads the account from Stripe).
    async fetchStripeConnection(refresh = false, pickPill = false) {
      try {
        const token = await this.getAuthToken();
        const companyId = localStorage.getItem('companyId');
        const settingsId = this.$route.query.id || (this.payment_settings && this.payment_settings.id);
        if (!settingsId) return;
        const url = `${API_LOCATION}companies/${companyId}/payment-settings/${settingsId}/stripe-connection${refresh ? '?refresh=1' : ''}`;
        const res = await axios.get(url, { headers: { Authorization: token } });
        const data = res.data || {};
        this.stripeConnect = {
          state: data.state || 'none',
          is_live: data.is_live === 0 ? 0 : 1,
          test_mode: data.test_mode === 1 ? 1 : 0,
          account_id: data.account_id || null,
          connected_at: data.connected_at || null,
          platform_controlled: data.platform_controlled === undefined ? null : data.platform_controlled,
          charges_enabled: data.charges_enabled === undefined ? null : data.charges_enabled,
          has_api_key: !!data.has_api_key,
        };
        if (pickPill) this.initStripePillForFirstIncomplete();
        // The Credentials and Webhook pills leave the rail on connect; never strand the view on one.
        if (!this.stripePills.some((pill) => pill.id === this.activeStripePill)) this.activeStripePill = 'connect';
      } catch (err) {
        // Non-fatal: the card keeps its last state.
        console.debug('[stripe connect] status fetch failed', err);
      } finally {
        this.stripeConnectLoaded = true;
      }
    },
    async disconnectStripe() {
      const confirmed = await this.askConfirm({
        title: 'Disconnect Stripe?',
        message: this.stripeConnect.has_api_key
          ? 'Payments switch back to the API keys saved on this page.'
          : 'Staff and customers cannot pay by card on this venue until you reconnect or add API keys.',
        confirmText: 'Disconnect',
        confirmVariant: 'danger',
        variant: 'danger'
      });
      if (!confirmed) return;
      try {
        const token = await this.getAuthToken();
        const companyId = localStorage.getItem('companyId');
        const settingsId = this.$route.query.id || (this.payment_settings && this.payment_settings.id);
        const url = `${API_LOCATION}companies/${companyId}/payment-settings/${settingsId}/stripe-connection`;
        const res = await axios.delete(url, { headers: { Authorization: token } });
        // One toast. A platform-controlled account keeps its Stripe-side link (stripe_side_revoked
        // false); that is OTC's housekeeping, not something the venue acts on.
        this.$notify({ type: 'success', message: 'Stripe account disconnected.' });
        this.stripeConnectAcknowledged = false;
        await this.fetchStripeConnection();
        this.getPaymentSettings();
      } catch (err) {
        const body = err.response && err.response.data;
        const parsed = typeof body === 'string' ? body : (body && body.error);
        this.$notify({ type: 'danger', message: parsed || 'Could not disconnect Stripe.' });
      }
    },
    // PUT .../stripe-connection { enabled } switches the connected account between live and
    // Stripe test mode (stripe-connect-test-mode). The switch is controlled (:value), so the
    // page state only changes after the GET confirms it.
    async setStripeTestMode(enabled) {
      if (this.stripeTestModeSaving) return;
      if (enabled) {
        const confirmed = await this.askConfirm({
          variant: 'warning',
          title: 'Turn on test mode?',
          message: 'Real payments stop on this venue until you turn test mode off. Test payments use Stripe test cards and never charge anyone.',
          confirmText: 'Turn on test mode',
        });
        if (!confirmed) return;
      }
      this.stripeTestModeSaving = true;
      try {
        const token = await this.getAuthToken();
        const companyId = localStorage.getItem('companyId');
        const settingsId = this.$route.query.id || (this.payment_settings && this.payment_settings.id);
        const url = `${API_LOCATION}companies/${companyId}/payment-settings/${settingsId}/stripe-connection`;
        await axios.put(url, { enabled }, { headers: { Authorization: token } });
        this.$notify({ type: 'success', message: enabled ? 'Test mode is on.' : 'Test mode is off. Real payments are back on.' });
        await this.fetchStripeConnection();
        this.getPaymentSettings();
      } catch (err) {
        const body = err.response && err.response.data;
        const parsed = typeof body === 'string' ? body : (body && body.error);
        this.$notify({ type: 'danger', message: parsed || 'Could not change test mode.' });
      } finally {
        this.stripeTestModeSaving = false;
      }
    },

    // ─── Stripe Terminal Card Readers (S700/S710) ─────────────────────
    // Backed by companies-list/register/update/delete-pos-reader(s) lambdas
    // (lambda names kept generic; API Gateway route is /stripe-readers to
    // make the gateway scoping explicit). Wraps Stripe's terminal.readers.*
    // using the venue's API key + auto-created stripe_terminal_location_id.
    // Source of truth is Stripe, no local cache.

    stripeReadersUrl() {
      const companyId = localStorage.getItem('companyId');
      const companyGroupId = JSON.parse(localStorage.getItem('group')).id;
      return `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}/stripe-readers`;
    },

    async fetchReaders() {
      // Only relevant when Stripe is the configured gateway. Other
      // gateways don't expose Terminal readers.
      if (!this.payment_gateway || this.payment_gateway.id !== 3) return;
      this.readersLoading = true;
      try {
        const token = await this.getAuthToken();
        const res = await axios.get(this.stripeReadersUrl(), {
          headers: { Authorization: token },
        });
        this.readers = Array.isArray(res.data?.readers) ? res.data.readers : [];
        this.stripeTerminalLocationId = res.data?.stripe_terminal_location_id || null;
        this.stripeLocations = Array.isArray(res.data?.locations) ? res.data.locations : [];
      } catch (err) {
        // Backend not yet deployed → render the empty state instead of
        // a noisy notification. Once the lambdas ship, real errors
        // surface via the notify in the catch below.
        if (err.response && err.response.status !== 404) {
          this.$notify({
            type: 'danger',
            message: this.readableError(err, 'Could not load readers'),
          });
        }
        this.readers = [];
        this.stripeTerminalLocationId = null;
        this.stripeLocations = [];
      } finally {
        this.readersLoading = false;
      }
    },

    stripeLocationLabel(loc) {
      const name = loc.city ? `${loc.display_name} · ${loc.city}` : loc.display_name;
      const n = loc.reader_count || 0;
      return `${name} (${n} ${n === 1 ? 'reader' : 'readers'})`;
    },

    async setStripeTerminalLocation(locationId) {
      if (!locationId || locationId === this.stripeTerminalLocationId) return;
      this.locationSaving = true;
      try {
        const token = await this.getAuthToken();
        await axios.post(
          this.stripeReadersUrl(),
          { location_id: locationId },
          { headers: { Authorization: token } },
        );
        this.$notify({ type: 'success', message: 'Stripe Terminal location updated' });
        await this.fetchReaders();
      } catch (err) {
        this.$notify({
          type: 'danger',
          message: this.readableError(err, 'Could not update the Stripe Terminal location'),
        });
      } finally {
        this.locationSaving = false;
      }
    },

    copyStripeTerminalLocationId() {
      if (!this.stripeTerminalLocationId) return;
      const text = this.stripeTerminalLocationId;
      const fallback = () => {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (_) {}
        document.body.removeChild(ta);
      };
      const after = () => this.$notify({ type: 'success', message: 'Location ID copied' });
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(after, () => { fallback(); after(); });
      } else {
        fallback();
        after();
      }
    },

    openConnectReaderForm() {
      this.connectReaderForm = {
        open: true,
        code: '',
        label: '',
        error: '',
        submitting: false,
      };
    },

    cancelConnectReaderForm() {
      this.connectReaderForm.open = false;
      this.connectReaderForm.code = '';
      this.connectReaderForm.label = '';
      this.connectReaderForm.error = '';
    },

    async submitConnectReader() {
      const code = (this.connectReaderForm.code || '').trim();
      if (!code) {
        this.connectReaderForm.error = 'Pairing code is required';
        return;
      }
      this.connectReaderForm.error = '';
      this.connectReaderForm.submitting = true;
      try {
        const token = await this.getAuthToken();
        const res = await axios.post(
          this.stripeReadersUrl(),
          {
            registration_code: code,
            label: (this.connectReaderForm.label || '').trim() || undefined,
          },
          { headers: { Authorization: token } },
        );
        // Optimistic: insert the new reader at the top, then fall back to
        // a refetch so server-derived fields (status, last_seen_at) match.
        if (res.data?.reader) {
          this.readers = [res.data.reader, ...this.readers.filter((r) => r.id !== res.data.reader.id)];
        }
        this.cancelConnectReaderForm();
        this.$notify({ type: 'success', message: 'Reader connected' });
        // Refetch in the background to pick up Stripe-side derived fields.
        void this.fetchReaders();
      } catch (err) {
        this.connectReaderForm.error = this.readableError(err, 'Could not connect reader');
      } finally {
        this.connectReaderForm.submitting = false;
      }
    },

    startEditReaderLabel(reader) {
      this.editingReaderId = reader.id;
      this.editingReaderLabel = reader.label || '';
      this.$nextTick(() => {
        const ref = this.$refs[`readerLabelInput-${reader.id}`];
        const el = Array.isArray(ref) ? ref[0] : ref;
        if (el && typeof el.focus === 'function') el.focus();
      });
    },

    cancelEditReaderLabel() {
      this.editingReaderId = null;
      this.editingReaderLabel = '';
    },

    async saveReaderLabel(reader) {
      const newLabel = (this.editingReaderLabel || '').trim();
      const originalLabel = reader.label || '';
      this.cancelEditReaderLabel();
      // No-op if unchanged.
      if (newLabel === originalLabel) return;
      try {
        const token = await this.getAuthToken();
        await axios.put(
          `${this.stripeReadersUrl()}/${encodeURIComponent(reader.id)}`,
          { label: newLabel },
          { headers: { Authorization: token } },
        );
        // Local update for snappy UI; refetch isn't necessary since label
        // is the only mutable field here.
        const idx = this.readers.findIndex((r) => r.id === reader.id);
        if (idx !== -1) this.$set(this.readers[idx], 'label', newLabel);
        this.$notify({ type: 'success', message: 'Reader renamed' });
      } catch (err) {
        this.$notify({
          type: 'danger',
          message: this.readableError(err, 'Could not rename reader'),
        });
      }
    },

    async confirmRemoveReader(reader) {
      const name = reader.label || reader.id;
      const confirmed = await this.askConfirm({
        title: 'Remove this reader?',
        message: `"${name}" will be deregistered from your Stripe account. You'll need a new pairing code to reconnect this device.`,
        confirmText: 'Remove',
        confirmVariant: 'danger',
        variant: 'danger'
      });
      if (confirmed) this.removeReader(reader);
    },

    async removeReader(reader) {
      try {
        const token = await this.getAuthToken();
        await axios.delete(
          `${this.stripeReadersUrl()}/${encodeURIComponent(reader.id)}`,
          { headers: { Authorization: token } },
        );
        this.readers = this.readers.filter((r) => r.id !== reader.id);
        this.$notify({ type: 'success', message: 'Reader removed' });
      } catch (err) {
        this.$notify({
          type: 'danger',
          message: this.readableError(err, 'Could not remove reader'),
        });
      }
    },

    readerStatusLabel(status) {
      if (status === 'online') return 'Online';
      if (status === 'offline') return 'Offline';
      return 'Unknown';
    },

    readerDeviceTypeLabel(deviceType) {
      const map = {
        stripe_s700: 'S700',
        stripe_s710: 'S710',
        simulated_stripe_s700: 'Simulated S700',
        simulated_stripe_s710: 'Simulated S710',
        bbpos_wisepos_e: 'BBPOS WisePOS E',
        verifone_P400: 'Verifone P400',
      };
      return map[deviceType] || deviceType || 'Reader';
    },

    readableError(err, fallback) {
      const data = err && err.response && err.response.data;
      if (typeof data === 'string') return data;
      if (data && typeof data.error === 'string') return data.error;
      return (err && err.message) || fallback;
    },

    async saveStripeSettings(source, field){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let settingsId = this.$route.query.id
      let url = API_LOCATION + 'companies/' + companyId + '/payment-settings/' + settingsId
        +  '/stripe-settings'

      // If disabling create_customer, also disable store_credit_card and both require_card flags
      let alsoDisableStoreCreditCard = false
      if(source === 'customer' && !this.stripe_settings.create_customer){
        this.stripe_settings.store_credit_card = false
        this.stripe_settings.require_card_for_deposit = false
        this.stripe_settings.require_card_for_full_payment = false
        alsoDisableStoreCreditCard = true
      }

      // If disabling store_credit_card, also disable both require_card flags
      if(source === 'payment_method' && !this.stripe_settings.store_credit_card){
        this.stripe_settings.require_card_for_deposit = false
        this.stripe_settings.require_card_for_full_payment = false
      }

      let data = this.stripe_settings
      if(source === 'customer'){
        data.customer = 1
        if(alsoDisableStoreCreditCard){
          data.payment_method = 1
        }
      }
      if(source === 'payment_method'){
        data.payment_method = 1
      }
      if(source === 'description'){
        data.description = 1
      }

      this.stripeSavingField = field || ''
      axios.put(url, data, config)
        .then((res) => {
          this.$notify({ type: 'success', message: 'Stripe settings have been updated', timeout: 3000 })
          this.stripeSavingField = ''
        })
        .catch((err) => {
          this.stripeSavingField = ''
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })
    },
    async generateSquareDeviceCode(){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let settingsId = this.$route.query.id
      let url = API_LOCATION + 'companies/' + companyId + '/payment-settings/' + settingsId
        +  '/square-terminal'

      let data = {}
      this.loading = true
      axios.post(url, data, config)
        .then((res) => {
          this.getDeviceCodes()
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })
    },
    async getDeviceCodes(){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let settingsId = this.$route.query.id
      let url = API_LOCATION + 'companies/' + companyId + '/payment-settings/' + settingsId
        +  '/square-terminal'

      this.loading = true
      axios.get(url, config)
        .then((res) => {
          if(res.data){
            this.square_device_codes = res.data.device_codes
            if(res.data.square_settings){
              const savedRequireCard = this.square_settings.require_card_for_deposit
              const savedRequireCardFullPayment = this.square_settings.require_card_for_full_payment
              this.square_settings = res.data.square_settings
              this.square_settings.create_customer = Boolean(res.data.square_settings.create_customer)
              this.square_settings.store_credit_card = Boolean(res.data.square_settings.store_credit_card)
              this.square_settings.require_card_for_deposit = res.data.square_settings.hasOwnProperty('require_card_for_deposit')
                ? Boolean(res.data.square_settings.require_card_for_deposit)
                : savedRequireCard
              this.square_settings.require_card_for_full_payment = res.data.square_settings.hasOwnProperty('require_card_for_full_payment')
                ? Boolean(res.data.square_settings.require_card_for_full_payment)
                : savedRequireCardFullPayment
            }
            this.square_hardware_types = res.data.square_hardware_types
            if(this.square_settings && this.square_hardware_types){
              this.square_settings.hardware_type = _.find(this.square_hardware_types, {name: this.square_settings.hardware_type})
            }
          }

          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })
    },
    editLiveCreds(){
      this.live_credentials.api_name_edit = this.live_credentials.api_name
      this.live_credentials.api_key_edit = ''
      this.live_credentials.api_location_edit = this.live_credentials.api_location
      this.edit_live_creds = true
    },
    editTestCreds(){
      this.test_credentials.api_name_edit = this.test_credentials.api_name
      this.test_credentials.api_key_edit = ''
      this.test_credentials.api_location_edit = this.test_credentials.api_location
      this.edit_test_creds = true
    },
    editTipOption(item, index){
      this.selectedTipOption = {
        name: item.name,
        amount: item.amount,
        value_type:  item.value_type,
        editing: true,
        index: index
      }
      this.modals.add_tip_option = true
    },
    deleteTipOption(index){
      this.tip_preset_values.splice(index, 1);
    },
    cancelTipCreation(){
      this.modals.add_tip_option = false
    },
    createTip(){
      this.tip_preset_values.push(this.selectedTipOption)
      this.modals.add_tip_option = false
    },
    saveTip(){
      this.tip_preset_values[this.selectedTipOption.index].name = this.selectedTipOption.name
      this.tip_preset_values[this.selectedTipOption.index].value_type = this.selectedTipOption.value_type
      this.tip_preset_values[this.selectedTipOption.index].amount = this.selectedTipOption.amount
      this.modals.add_tip_option = false
    },
    addTipPresetValue(){
      this.modals.add_tip_option = true
      this.selectedTipOption = {
        name: '',
        amount: 0,
        value_type:  {id: 0},
        editing: false
      }
    },
    editPaymentMethod(item){
      this.payment_method = {
        name: item.name,
        content: item.content,
        id: item.id,
        enabled_externally: Boolean(item.enabled_externally),
        enabled_internally: Boolean(item.enabled_internally),
        mark_booking_site_unpaid: Boolean(item.mark_booking_site_unpaid),
        action: 'editing'
      }
      this.modals.custom_payment = true
    },
    async updatePaymentMethodOrder(){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId
        + '/payment-methods'

      let data = {
        payment_methods: this.payment_methods,
      }

      axios.put(url, data, config)
        .then((res) => {
          this.getPaymentSettings()
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })
    },
    async deletePaymentMethod(item){
      if(this.payment_method.name === '') {
        this.payment_method.name_error = 'Payment name cannot be empty'
        this.j++
        return
      }

      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId
        + '/payment-methods/' + item.id

      axios.delete(url, config)
        .then((res) => {
          this.getPaymentSettings()
          this.loading = false
          this.notifySuccess(`Payment method has been deleted`)
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })
    },
    async togglePaymentMethodActivation(item, action, action_text){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId
        + '/payment-methods/' + item.id

      let data = {
        action: action
      }

      axios.put(url, data, config)
        .then((res) => {
          this.getPaymentSettings()
          this.loading = false
          this.notifySuccess(`Payment method has been ` + action_text)
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })
    },
    async updatePaymentMethod(){
      if(this.payment_method.name === '') {
        this.payment_method.name_error = 'Payment name cannot be empty'
        this.j++
        return
      }

      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId
        + '/payment-methods/' + this.payment_method.id

      let data = this.payment_method

      axios.put(url, data, config)
        .then((res) => {
          this.getPaymentSettings()
          this.modals.custom_payment = false
          this.loading = false
          this.notifySuccess(`Payment method has been updated`)
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })
    },
    async createPaymentMethod(){
      if(this.payment_method.name === '') {
        this.payment_method.name_error = 'Payment name cannot be empty'
        this.j++
        return
      }

      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/payment-methods'

      let data = this.payment_method

      axios.post(url, data, config)
        .then((res) => {
          this.getPaymentSettings()
          this.modals.custom_payment = false
          this.loading = false
          this.notifySuccess(`Payment method has been created`)
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })
    },
    createCustomPaymentPrompt(){
      this.payment_method = {
        name: '',
        content: '',
        id: '',
        enabled_externally: false,
        enabled_internally: false,
        mark_booking_site_unpaid: false,
        position: this.payment_methods.length,
        action: 'new'
      }
      this.modals.custom_payment = true
    },
    copyItem(item) {
      navigator.clipboard.writeText(item);
    },
    copy(text){
      navigator.clipboard.writeText(text);
    },
    getLocalTime(d){
      return formatGroupTime(d)
    },
    getLocalDate(d){
      return formatGroupDate(d)
    },
    validatePaymentRequestFields(){
      let errors = 0

      if(this.payment_settings.enable_pay_on_arrival_text && this.payment_settings.pay_on_arrival_text.length > 200){
        this.errs.pay_on_arrival_text = 'Number of characters cannot be greater than 200'
        errors++
      } else {
        this.errs.pay_on_arrival_text = ''
      }

      if(this.payment_settings.payment_request_threshold === ''){
        this.errs.payment_request_threshold = 'Field cannot be empty'
        errors++
      } else {
        this.errs.payment_request_threshold = ''
      }

      if(this.payment_settings.payment_request_timeout_value === ''){
        this.errs.payment_request_timeout_value = 'Field cannot be empty'
        errors++
      } else {
        this.errs.payment_request_timeout_value = ''
      }
      return errors > 0 ? false : true
    },
    async savePaymentRequestSettings(){
      if(!this.validatePaymentRequestFields()){
        return
      }
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let url = API_LOCATION + 'companies/' + companyId + '/payment-settings/' + this.payment_settings.id + '/payment-request'

      let data = {
        payment_request_timeout_value: this.payment_settings.payment_request_timeout_value,
        // Legacy request keys stay in the payload because the lambda binds them
        // positionally; the live values are on the payment request template.
        payment_request_timeout_period: this.payment_settings.payment_request_timeout_period.id,
        payment_request_has_timeout: this.payment_settings.payment_request_has_timeout,
        payment_request_threshold: this.payment_settings.payment_request_threshold,
        allow_pay_on_arrival: this.payment_settings.allow_pay_on_arrival,
        allow_tipping: this.payment_settings.allow_tipping,
        allow_custom_tipping_options: this.payment_settings.allow_custom_tipping_options,
        allow_gift_card_purchase_on_gift_card: this.payment_settings.allow_gift_card_purchase_on_gift_card,
        custom_tipping_value_type: this.payment_settings.custom_tipping_value_type.id,
        allow_preset_tipping_options: this.payment_settings.allow_preset_tipping_options,
        tip_preset_values: this.tip_preset_values,
        tip_label: this.payment_settings.tip_label,
        tip_line_item_label: this.payment_settings.tip_line_item_label,
        enable_pay_on_arrival_text: this.payment_settings.enable_pay_on_arrival_text,
        pay_on_arrival_text: this.payment_settings.pay_on_arrival_text,
        payment_request_allow_custom_amounts: this.payment_settings.payment_request_allow_custom_amounts,
        show_promo_code_field: this.payment_settings.show_promo_code_field,
        payment_layout_type: this.payment_settings.payment_layout_type,
        invoices_address_source: this.payment_settings.invoices_address_source,
        invoice_show_custom_fields: this.payment_settings.invoice_show_custom_fields,
        invoice_list_payments: this.payment_settings.invoice_list_payments,
        invoice_show_ticket_categories: this.payment_settings.invoice_show_ticket_categories,
        promo_code_error_message: this.payment_settings.promo_code_error_message,
        show_custom_promo_code_error_message: this.payment_settings.show_custom_promo_code_error_message,
        request_to_book_payment_mode: this.payment_settings.request_to_book_payment_mode
      }

      axios.put(url, data, config)
        .then((res) => {
          this.getPaymentSettings()
          this.loading = false
          this.notifySuccess(`Payment method settings have been updated`)
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })
    },
    async toggleActivationFeePrompt(item, event){
      if(event){
        event.preventDefault()
      }
      const confirmed = await this.askConfirm({
        title: 'Are you sure?',
        message: item.is_active
          ? 'This action will deactivate the fee and remove it from all future bookings.'
          : 'This action will activate the fee and apply it to all future bookings.'
      })
      if (confirmed) {
        this.toggleFeeActivation(item)
      }
    },
    async editFee(){
      if(this.validateFeeFields() > 0){
        return
      }
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/fees/' + this.selectedFeeId

      let data = {
        name: this.fee.title,
        value_type: this.value_type.value_id,
        amount: (this.value_type.value_id === 2 || this.value_type.value_id === 4) ? parseFloat(this.fee.amount).toFixed(this.fee.amount_precision) : parseFloat(this.fee.amount).toFixed(2),
        amount_precision: (this.value_type.value_id === 2 || this.value_type.value_id === 4) ? this.fee.amount_precision : 2,
        optional: this.optional_fee,
        covered_by_promo_codes: this.covered_by_promo_codes,
        apply_to_all_items: this.apply_to_all_items,
        selected_purchasable_items: this.selected_purchasable_items.map(item => ({
          id: item.id,
          item_type: item.item_type
        }))
      }
      axios.put(url, data, config)
        .then((res) => {
          this.create_new_fee = false
          this.getPaymentSettings()
          this.loading = false
          this.notifySuccess(`Fee has been updated`)
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })
    },
    async deleteFee(id, event){
      if(event){
        event.preventDefault()
      }
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/fees/' + id

      axios.delete(url, config)
        .then((res) => {
          this.getPaymentSettings()
          this.loading = false

          this.notifySuccess(`Fee has been deleted`)
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })
    },
    editFeePrompt(item, event){
      if(event){
        event.preventDefault()
      }
      this.create_new_fee = true
      this.selectedFeeId = item.id
      this.fee.title = item.name
      this.fee.amount = item.amount
      this.fee.amount_precision = item.amount_precision !== undefined ? item.amount_precision : 2
      this.optional_fee = Boolean(item.optional)
      this.covered_by_promo_codes = Boolean(item.covered_by_promo_codes)
      this.apply_to_all_items = Boolean(item.apply_to_all_items)
      this.value_type = _.find(this.valueTypesTaxes, { value_id: item.value_type})
      this.selected_purchasable_items = JSON.parse(item.linked_games).concat(JSON.parse(item.linked_items)).concat(JSON.parse(item.linked_gift_card_types))
      this.errs.fee_title =  ''
      this.errs.fee_value_type =  ''
      this.errs.fee_amount =  ''
      this.changeTaxAmount(this.value_type)
    },
    cancelFeeCreation(){
      this.create_new_fee = false
      this.fee.title = ''
      this.value_type = ''
      this.fee.amount = ''
      this.fee.amount_precision = 2
      this.optional_fee = false
      this.covered_by_promo_codes = false
      this.tax_amount_label = 'Percentage amount (%)'
      this.errs.fee_title =  ''
      this.errs.fee_value_type =  ''
      this.errs.fee_value =  ''
    },
    clearFeeFields(){
      this.create_new_fee = true
      this.selectedFeeId = null
      this.fee.title = ''
      this.value_type = ''
      this.fee.amount = ''
      this.fee.amount_precision = 2
      this.optional_fee = false
      this.covered_by_promo_codes = false
      this.selected_purchasable_items = []
      this.apply_to_all_items = true
      this.tax_amount_label = 'Percentage amount (%)'
    },
    validateFeeFields(){
      let errors = 0
      if(this.value_type.value_id === 2){
        if(this.fee.amount > 100 || this.fee.amount <= 0){
          this.errs.fee_value = 'Amount must be between 0.01 and 100'
          errors++
        } else {
          this.errs.fee_value = ''
        }
      }
      if(this.fee.amount.length <=0){
        this.errs.fee_value = 'Amount cannot be empty'
        errors++
      } else {
        this.errs.fee_value = ''
      }
      if(this.fee.title.length <=0){
        this.errs.fee_title = 'Fee title cannot be empty'
        errors++
      } else {
        this.errs.fee_title = ''
      }
      if (this.value_type.length <= 0) {
        this.errs.fee_value_type = 'Value type cannot be empty'
        errors++
      } else {
        this.errs.fee_value_type = ''
      }

      return errors
    },
    async createFee(){
      if(this.validateFeeFields() > 0){
        return
      }
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/fees'

      let data = {
        name: this.fee.title,
        value_type: this.value_type.value_id,
        amount: (this.value_type.value_id === 2 || this.value_type.value_id === 4) ? parseFloat(this.fee.amount).toFixed(this.fee.amount_precision) : parseFloat(this.fee.amount).toFixed(2),
        amount_precision: (this.value_type.value_id === 2 || this.value_type.value_id === 4) ? this.fee.amount_precision : 2,
        optional: this.optional_fee,
        covered_by_promo_codes: this.covered_by_promo_codes,
        apply_to_all_items: this.apply_to_all_items,
        selected_purchasable_items: this.selected_purchasable_items.map(item => ({
          id: item.id,
          item_type: item.item_type
        }))
      }

      axios.post(url, data, config)
        .then((res) => {
          this.getPaymentSettings()
          this.loading = false
          this.create_new_fee = false
          this.notifySuccess(`Fee has been created`)
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })
    },
    async editTax(){
      if(this.validateTaxFields() > 0){
        return
      }
      if(this.pricingTypeConflict(this.pricing_type.id)){
        this.notifyError(`You cannot mix exclusive and inclusive taxes`)
        return
      }
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/taxes/' + this.selectedTaxId

      let data = {
        'name': this.tax_title,
        'pricing_type': this.pricing_type.id,
        'value_type': this.value_type.value_id,
        'tax_number': this.tax_number,
        'amount': (this.value_type.value_id === 2 || this.value_type.value_id === 4) ? parseFloat(this.tax_amount).toFixed(this.tax_amount_precision) :  parseFloat(this.tax_amount).toFixed(2),
        'is_compound': this.is_compound_tax,
        'apply_after_discount': this.apply_after_discount,
        'optional': this.optional_tax,
        'show_tax_line_items': this.show_tax_line_items,
        'apply_to_all_items': this.apply_to_all_items,
        'tax_amount_precision': this.tax_amount_precision,
        'selected_purchasable_items': this.selected_purchasable_items.map(item => ({
          id: item.id,
          item_type: item.item_type
        }))
      }
      axios.put(url, data, config)
        .then((res) => {
          this.getPaymentSettings()
          this.loading = false
          this.clearTaxFields()
          this.notifySuccess(`Tax has been updated`)
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })
    },
    editTaxPrompt(item, event){
      if(event){
        event.preventDefault()
      }

      this.selectedTaxId = item.id
      this.tax_title = item.name
      this.tax_amount = item.amount
      this.tax_number = item.tax_number
      this.is_compound_tax = Boolean(item.is_compound)
      this.optional_tax = Boolean(item.optional)
      this.apply_after_discount = Boolean(item.apply_after_discount)
      this.show_tax_line_items = Boolean(item.show_tax_line_items)
      this.apply_to_all_items = Boolean(item.apply_to_all_items)
      this.tax_amount_precision = item.tax_amount_precision
      this.selected_purchasable_items = JSON.parse(item.linked_games).concat(JSON.parse(item.linked_items))
      this.pricing_type = { id: item.pricing_type}
      this.value_type = _.find(this.valueTypesTaxes, { value_id: item.value_type})
      this.create_new_tax = true
      this.errs.tax_title =  ''
      this.errs.pricing_type =  ''
      this.errs.value_type =  ''
      this.errs.tax_amount =  ''
      this.changeTaxAmount(this.value_type)
    },
    async deleteTax(id, event){
      if(event){
        event.preventDefault()
      }
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/taxes/' + id

      axios.delete(url, config)
        .then((res) => {
          this.getPaymentSettings()
          this.loading = false

          this.notifySuccess(`Tax has been deleted`)
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })
    },
    async toggleActivationPrompt(item, event){
      if(event){
        event.preventDefault()
      }
      if(!item.is_active && this.pricingTypeConflict(item.pricing_type)){
        this.notifyError('You cannot mix exclusive and inclusive taxes')
        return
      }
      const confirmed = await this.askConfirm({
        title: 'Are you sure?',
        message: item.is_active
          ? 'This action will deactivate the tax and remove it from all future bookings.'
          : 'This action will activate the tax and apply it to all future bookings.'
      })
      if (confirmed) {
        this.toggleActivation(item)
      }
    },
    async toggleFeeActivation(item){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId
        + '/fees/' + item.id + '/activate'

      let data = {
        'is_active': !item.is_active
      }
      axios.post(url, data, config)
        .then((res) => {
          this.getPaymentSettings()
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })
    },
    async toggleActivation(item){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId
        + '/taxes/' + item.id + '/activate'

      let data = {
        'is_active': !item.is_active
      }
      axios.post(url, data, config)
        .then((res) => {
          this.getPaymentSettings()
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })
    },
    clearTaxFields(){
      this.create_new_tax = false
      this.tax_title = ''
      this.is_compound_tax = false
      this.optional_tax = false
      this.pricing_type = ''
      this.value_type = ''
      this.tax_amount = ''
      this.tax_number = ''
      this.tax_amount_label = 'Percentage amount (%)'
    },
    validateTaxFields(){
      let errors = 0
      if(this.value_type.value_id === 2){
        if(this.tax_amount > 100 || this.tax_amount <= 0){
          this.errs.tax_amount = 'Amount must be between 0.01 and 100'
          errors++
        } else {
          this.errs.tax_amount = ''
        }
      }
      if(this.tax_amount.length <=0){
        this.errs.tax_amount = 'Amount cannot be empty'
        errors++
      } else {
        this.errs.tax_amount = ''
      }
      if(this.tax_title.length <=0){
        this.errs.tax_title = 'Tax title cannot be empty'
        errors++
      } else {
        this.errs.tax_title = ''
      }
      if (this.pricing_type.length <= 0) {
        this.errs.pricing_type = 'Pricing type cannot be empty'
        errors++
      } else {
        this.errs.pricing_type = ''
      }
      if (this.value_type.length <= 0) {
        this.errs.value_type = 'Value type cannot be empty'
        errors++
      } else {
        this.errs.value_type = ''
      }

      return errors
    },
    async createTax(){

      if(this.validateTaxFields() > 0){
        return
      }
      if(this.pricingTypeConflict(this.pricing_type.id)){
        this.notifyError(`You cannot mix exclusive and inclusive taxes`)
        return
      }
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/taxes'

      let data = {
        'name': this.tax_title,
        'tax_number': this.tax_number,
        'pricing_type': this.pricing_type.id,
        'value_type': this.value_type.value_id,
        'tax_amount_precision': this.tax_amount_precision,
        'amount': (this.value_type.value_id === 2 || this.value_type.value_id === 4) ? parseFloat(this.tax_amount).toFixed(this.tax_amount_precision) :  parseFloat(this.tax_amount).toFixed(2),
        'is_compound': this.is_compound_tax,
        'apply_after_discount': this.apply_after_discount,
        'optional': this.optional_tax,
        'show_tax_line_items': this.show_tax_line_items,
        'apply_to_all_items': this.apply_to_all_items,
        'selected_purchasable_items': this.selected_purchasable_items.map(item => ({
          id: item.id,
          item_type: item.item_type
        }))
      }
      axios.post(url, data, config)
        .then((res) => {
          this.getPaymentSettings()
          this.loading = false
          this.notifySuccess(`Tax has been created`)
          this.clearTaxFields()

        })
        .catch((err) => {
          this.loading = false
          console.error(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })
    },
    cancelTaxCreation(){
      this.create_new_tax = false
      this.tax_title = ''
      this.is_compound_tax = false
      this.apply_after_discount = false
      this.optional_tax = false
      this.pricing_type = ''
      this.value_type = ''
      this.tax_amount = ''
      this.tax_number = ''
      this.tax_amount_label = 'Percentage amount (%)'
      this.errs.tax_title =  ''
      this.errs.pricing_type =  ''
      this.errs.value_type =  ''
      this.errs.tax_amount =  ''
    },
    changeTaxAmount(value_type){
      if(value_type.value_id !== 2 && value_type.value_id !== 4){
        this.tax_amount_label = 'Amount (' + this.currency_symbol + ')'
      } else {
        this.tax_amount_label = 'Percentage amount (%)'
      }

      //Per transaction settings
      if(value_type.value_id === 2 || value_type.value_id === 0){
        this.apply_to_all_items = true
      }
    },
    getAmount(type, amount, feature, precision) {
      if (type === 2 || type === 4 || (type === 0 && feature === 'tip')) {
        return amount.toFixed(precision !== undefined ? precision : 2) + '%';
      } else {
        // Get currency info for postfix check
        const currencyInfo = _.find(this.currencies, { code: this.currency });
        const isPostfix = currencyInfo ? currencyInfo.postfix : false;

        let formattedAmount;

        if (this.number_format === 1) {
          // European formatting (comma as decimal separator)
          formattedAmount = amount.toLocaleString(undefined, { minimumFractionDigits: 2 }).replace('.', ',');
        } else {
          // Standard formatting (dot as decimal separator)
          formattedAmount = amount.toFixed(2);
        }

        if (isPostfix) {
          return formattedAmount + this.currency_symbol;  // 12.34kr or 12,34kr
        } else {
          return this.currency_symbol + formattedAmount;  // $12.34 or $12,34
        }
      }
    },
    getValueType(type){
      return _.find(this.valueTypesTaxes, {value_id: type}).name
    },
    getDate(d){
      return formattedDate(this.date_format, d)
    },
    getTime(d){
      return time(this.time_format, d)
    },
    async getGames () {
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/games'
      this.axios.get(url, config)
        .then(response => {
          this.games = response.data
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })
    },
    switchTab(index){
      this.activeTabIndex = index
      this.create_new_tax = false
      this.create_new_fee = false
      if(this.activeTabIndex === 4 && this.payment_gateway.id === 3){
        this.getDeviceCodes()
      }
      this.addQueryParameters()
    },
    // Shared confirm dialog (base-alert-dialog). Resolves true on confirm,
    // false on cancel or dismiss.
    askConfirm({ title, message, confirmText = 'Confirm', confirmVariant = 'primary', variant = 'warning' }){
      return new Promise((resolve) => {
        this.confirmDialog = { show: true, title, message, confirmText, confirmVariant, variant, resolve }
      })
    },
    onConfirmDialogConfirm(){
      const resolve = this.confirmDialog.resolve
      this.confirmDialog.show = false
      if (resolve) resolve(true)
    },
    onConfirmDialogCancel(){
      const resolve = this.confirmDialog.resolve
      this.confirmDialog.show = false
      if (resolve) resolve(false)
    },
    notifySuccess(message){
      this.$notify({ type: 'success', message, icon: 'tim-icons icon-check-2' })
    },
    notifyError(message){
      this.$notify({ type: 'danger', message, icon: 'tim-icons icon-alert-circle-exc' })
    },
    isValidForm(type){
      let errors = 0
      if(type === 'test'){
        if(this.test_credentials.api_name_edit === '' || this.test_credentials.api_name_edit === null){
          this.err.test_credentials.api_name = 'Invalid ' + this.api_name
          errors++
        } else {
          this.err.test_credentials.api_name = ''
        }
        if(this.test_credentials.api_key_edit === '' || this.test_credentials.api_key_edit === null){
          this.err.test_credentials.api_key = 'Invalid ' + this.api_key
          errors++
        } else {
          this.err.test_credentials.api_key = ''
        }
        if(this.payment_gateway.id === 2 && (this.test_credentials.api_location_edit === '' || this.test_credentials.api_location_edit === null)){
          if(this.test_credentials.api_location_edit === '' || this.test_credentials.api_location_edit === null){
            this.err.test_credentials.api_location = 'Invalid ' + this.api_location
            errors++
          } else {
            this.err.test_credentials.api_location = ''
          }
        }

      } else {
        if(this.live_credentials.api_name_edit === '' || this.live_credentials.api_name_edit === null){
          this.err.live_credentials.api_name = 'Invalid ' + this.api_name
          errors++
        } else {
          this.err.live_credentials.api_name = ''
        }
        if(this.live_credentials.api_key_edit === '' || this.live_credentials.api_key_edit === null){
          this.err.live_credentials.api_key = 'Invalid ' + this.api_key
          errors++
        } else {
          this.err.live_credentials.api_key = ''
        }
        if(this.payment_gateway.id === 2 && (this.live_credentials.api_location_edit === '' || this.live_credentials.api_location_edit === null)){
          if(this.live_credentials.api_location_edit === '' || this.live_credentials.api_location_edit === null){
            this.err.live_credentials.api_location = 'Invalid ' + this.api_location
            errors++
          } else {
            this.err.live_credentials.api_location = ''
          }
        }
      }
      if(errors > 0){
        return false
      }
      return true
    },
    async updateCredentials(type, status){
      let companyId = localStorage.getItem('companyId')
      let settingsId = this.$route.query.id
      let url = API_LOCATION + 'companies/' + companyId + '/payment-settings/' + settingsId
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}

      // Activate and deactivate send only the id and the flag. The stored key
      // never leaves the backend, so it is never echoed back here.
      let data = {}
      data.id = type === 'test' ? this.test_credentials.id : this.live_credentials.id
      data.is_live = type === 'test' ? 0 : 1
      data.update_only = false
      if(status === 0){
        data.is_active = 0
      } else if(status === 1) {
        //check that other creds aren't also live
        if(type === 'test'){
          if(this.live_credentials.is_active === 1){
            const cont = await this.askConfirm({
              title: 'Are you sure?',
              message: 'Activating test credentials will deactivate your live credentials.',
              confirmText: 'Activate'
            })
            if(!cont){
              return
            }
          }
        } else {
          if(this.test_credentials.is_active === 1){
            const cont = await this.askConfirm({
              title: 'Are you sure?',
              message: 'Activating live credentials will deactivate your test credentials.',
              confirmText: 'Activate'
            })
            if(!cont){
              return
            }
          }
        }
        data.is_active = 1
      } else {
        if(!this.isValidForm(type)){
          return
        }
        const creds = type === 'test' ? this.test_credentials : this.live_credentials
        data.api_name = creds.api_name_edit
        data.api_key = creds.api_key_edit
        data.api_location = creds.api_location_edit
        data.update_only = true
      }

      data.payment_gateway_id = this.payment_gateway.id

      this.loading = true
      try {
        const response = await axios.put(url, data, config)
        if (status === 1) {
          this.showCredentialsAlert('Credentials activated', (type === 'test' ? 'Test' : 'Live') + ' credentials have been activated.', 'success')
        } else if (status === 0) {
          this.showCredentialsAlert('Credentials deactivated', (type === 'test' ? 'Test' : 'Live') + ' credentials have been deactivated.', 'success')
        } else {
          let webhook = null
          try {
            const body = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
            webhook = body && body.webhook ? body.webhook : null
          } catch (e) {
            webhook = null
          }
          const copy = this.webhookOutcomeCopy(type, webhook)
          this.showCredentialsAlert(copy.title, copy.message, copy.variant)
          if (type === 'test') this.edit_test_creds = false
          else this.edit_live_creds = false
        }
        this.err = {
          live_credentials: { api_name: '', api_key: '', api_location: '' },
          test_credentials: { api_name: '', api_key: '', api_location: '' }
        }
        this.getPaymentSettings()
      } catch (err) {
        this.loading = false
        console.log(err)
        if (err.response && err.response.status == 401) {
          this.$router.push('/forbidden')
        } else {
          this.showCredentialsAlert('Something went wrong', 'The credentials could not be saved. Try again later.', 'danger')
        }
      }
    },
    showCredentialsAlert(title, message, variant) {
      this.credentialsAlert = { show: true, title: title, message: message, variant: variant }
    },
    webhookOutcomeCopy(type, webhook) {
      const label = type === 'test' ? 'Test credentials' : 'Live credentials'
      const result = webhook ? webhook.result : 'skipped'
      switch (result) {
        case 'created':
          return { title: 'Credentials saved', variant: 'success',
            message: label + ' saved. The Stripe webhook is set up and signature verification is on.' }
        case 'existing_endpoint_needs_secret':
          return { title: 'Webhook needs your signing secret', variant: 'warning',
            message: label + ' saved. A webhook for Off The Couch already exists in your Stripe account but its signing secret is not stored here. Open the Webhook tab and paste the signing secret, or delete that endpoint in Stripe and save your key again.' }
        case 'permission_denied':
          return { title: 'Webhook not created', variant: 'warning',
            message: label + ' saved. Your Stripe key cannot create webhooks. Give it webhook write access and save again, or set up the webhook manually on the Webhook tab.' }
        case 'invalid_key':
          return { title: 'Stripe rejected the key', variant: 'warning',
            message: label + ' saved, but Stripe did not accept the secret key. Check the key and save again.' }
        case 'unreachable':
          return { title: 'Webhook not created', variant: 'warning',
            message: label + ' saved. Stripe could not be reached to set up the webhook. Save the key again later, or set it up manually on the Webhook tab.' }
        default:
          return { title: 'Credentials saved', variant: 'success', message: label + ' have been updated.' }
      }
    },
    getAuthToken() {
      return new Promise ( function(resolve) {
        Auth.currentSession()
          .then(data =>{
            resolve(data.idToken.jwtToken)
          })
          .catch(err => console.log(err))
      })
    },
    pricingTypeConflict(self_pricing_type){
      if(self_pricing_type === 1){
        for(let m in this.taxes){
          if(this.taxes[m].pricing_type === 0 && this.taxes[m].is_active && this.selectedTaxId !== this.taxes[m].id){
            return true
          }
        }
      }
      else if(self_pricing_type === 0){
        for(let n in this.taxes){
          if(this.taxes[n].pricing_type === 1 && this.taxes[n].is_active && this.selectedTaxId !== this.taxes[n].id){
            return true
          }
        }
      }
      return false
    },
    async getPaymentSettings() {
      let settingsId = this.$route.query.id
      this.loading = true
      let companyId = localStorage.getItem('companyId')
      let url = API_LOCATION + 'companies/' + companyId + '/payment-settings/' + settingsId
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}

      axios.get(url, config)
        .then(response => {
          this.payment_settings = response.data.payment_settings
          this.payment_settings.payment_request_timeout_period = _.find(this.request_periods, {id: this.payment_settings.payment_request_timeout_period})
          this.payment_settings.custom_tipping_value_type = _.find(this.valueTypesTipping, {id: this.payment_settings.custom_tipping_value_type})
          this.payment_settings.allow_custom_tipping_options = Boolean(this.payment_settings.allow_custom_tipping_options)
          this.payment_settings.allow_tipping = Boolean(this.payment_settings.allow_tipping)
          this.payment_settings.enable_pay_on_arrival_text = Boolean(this.payment_settings.enable_pay_on_arrival_text)
          this.payment_settings.allow_pay_on_arrival = Boolean(this.payment_settings.allow_pay_on_arrival)
          this.payment_settings.allow_gift_card_purchase_on_gift_card = Boolean(this.payment_settings.allow_gift_card_purchase_on_gift_card)
          this.payment_settings.allow_preset_tipping_options = Boolean(this.payment_settings.allow_preset_tipping_options)
          this.payment_settings.allow_preset_tipping_options = Boolean(this.payment_settings.allow_preset_tipping_options)
          this.payment_settings.show_promo_code_field = Boolean(this.payment_settings.show_promo_code_field)
          this.payment_settings.show_custom_promo_code_error_message = Boolean(this.payment_settings.show_custom_promo_code_error_message)
          this.payment_settings.payment_request_allow_custom_amounts = Boolean(this.payment_settings.payment_request_allow_custom_amounts)
          this.payment_settings.payment_request_has_timeout = Boolean(this.payment_settings.payment_request_has_timeout)
          this.payment_settings.invoice_show_custom_fields = Boolean(this.payment_settings.invoice_show_custom_fields)
          this.payment_settings.invoice_list_payments = Boolean(this.payment_settings.invoice_list_payments)
          this.$set(this.payment_settings, 'invoice_show_ticket_categories', Boolean(this.payment_settings.invoice_show_ticket_categories))

          this.stripe_webhook = { live: null, test: null }
          if (response.data.credentials) {
            for (let cred of response.data.credentials) {
              if (cred.payment_gateway_id !== 3) continue
              const entry = {
                has_secret: Boolean(cred.has_webhook_secret || cred.webhook_secret),
                endpoint_id: cred.webhook_endpoint_id || null,
                status: cred.webhook_endpoint_status || null,
                checked_at: cred.webhook_status_checked_at || null,
                is_active: cred.is_active === 1
              }
              if (cred.is_live === 1) this.stripe_webhook.live = entry
              else this.stripe_webhook.test = entry
            }
          }
          const activeStripe = this.activeStripeWebhook
          this.webhook_secret = activeStripe && activeStripe.has_secret ? '••••••••••••••••••••••••••••••' : ''

          if(response.data.payment_methods.length > 0){
            this.payment_methods = response.data.payment_methods
          } else {
            if(response.data.payment_gateway.id === 5){
              this.payment_methods.push({id: 2, name: 'Yappy', status: 1, content: ''})
            }
          }
          this.tip_preset_values = response.data.tip_preset_values
          for(let n in this.tip_preset_values){
            this.tip_preset_values[n].value_type = _.find(this.valueTypesTipping, {id: this.tip_preset_values[n].value_type})
          }
          this.credentials = response.data.credentials
          this.taxes = response.data.taxes
          this.fees = response.data.fees
          this.valueTypesTaxes = response.data.value_types.filter(item => item.applies_to_tax === 1);
          this.purchasable_items_fees = response.data.purchasable_items
          this.purchasable_items_taxes = response.data.purchasable_items.filter(obj => {
            return obj.item_type === 'game' || obj.item_type === 'item'
          })

          if(this.payment_gateway.hasOwnProperty('id')){
            // this.gateway_configured = false
            this.payment_gateway = _.find(this.payment_gateways, {id: this.payment_gateway.id})

          } else if(response.data.payment_gateway === undefined){
            // this.gateway_configured = false
            if(this.credentials.length > 0){
              this.payment_gateway = _.find(this.payment_gateways, {id: this.credentials[0].payment_gateway_id})
            }
          } else {
            this.gateway_configured = true
            this.payment_gateway = response.data.payment_gateway
          }

          if(this.payment_gateway.id === 1){
            this.api_name = 'API Login ID'
            this.api_key = 'Transaction Key'
          } else if (this.payment_gateway.id === 2){
            this.api_name = 'Application ID'
            this.api_key = 'Access token'
            this.api_location = 'Location ID'
            // Square is active — load the in-person OAuth connection status now
            // that settingsId + gateway are known (so the In-person pill shows
            // Connected across reloads).
            this.fetchSquareStatus()
          } else if (this.payment_gateway.id === 3){
            this.api_name = 'Publishable key'
            this.api_key = 'Secret key'
            // Stripe Connect state for the live row (Connection pill). Re-picks the
            // landing pill once the state is known.
            this.fetchStripeConnection(false, true)
            // Pick the pill to land on based on what's still incomplete.
            // Card readers are fetched lazily when the user opens the
            // Hardware pill (see setStripePill).
            this.$nextTick(() => this.initStripePillForFirstIncomplete())
          } else if (this.payment_gateway.id === 4){
            this.api_name = 'Public key'
            this.api_key = 'Secret key'
          }
          else if (this.payment_gateway.id === 5){
            this.api_name = 'Merchant ID'
            this.api_key = 'Secret key'
          }

          for(let n in this.credentials){
            if(this.credentials[n].is_live === 0 && this.payment_gateway.id === this.credentials[n].payment_gateway_id){
              this.test_credentials.id = this.credentials[n].id
              this.test_credentials.has_api_key = Boolean(this.credentials[n].has_api_key || this.credentials[n].api_key)
              this.test_credentials.api_name = this.credentials[n].api_name
              this.test_credentials.is_active = this.credentials[n].is_active
              this.test_credentials.is_live = this.credentials[n].is_live
              this.test_credentials.api_location = this.credentials[n].api_location
              this.test_credentials.td_api_enabled = this.credentials[n].td_api_enabled
            } else if(this.credentials[n].is_live === 1 && this.payment_gateway.id === this.credentials[n].payment_gateway_id) {
              this.live_credentials.id = this.credentials[n].id
              this.live_credentials.has_api_key = Boolean(this.credentials[n].has_api_key || this.credentials[n].api_key)
              this.live_credentials.api_name = this.credentials[n].api_name
              this.live_credentials.is_active = this.credentials[n].is_active
              this.live_credentials.is_live = this.credentials[n].is_live
              this.live_credentials.api_location = this.credentials[n].api_location
              this.live_credentials.td_api_enabled = this.credentials[n].td_api_enabled

            }
          }
          if(this.activeTabIndex === 3 && this.payment_gateway.id === 2){
            this.getDeviceCodes()
          }

          // Load Stripe settings if available
          if(this.payment_gateway.id === 3 && response.data.stripe_settings){
            this.stripe_settings = response.data.stripe_settings
            this.stripe_settings.create_customer = Boolean(response.data.stripe_settings.create_customer)
            this.stripe_settings.store_credit_card = Boolean(response.data.stripe_settings.store_credit_card)
            this.stripe_settings.require_card_for_deposit = Boolean(response.data.stripe_settings.require_card_for_deposit)
            this.stripe_settings.require_card_for_full_payment = Boolean(response.data.stripe_settings.require_card_for_full_payment)
          }

          // Load Square settings if available
          if(this.payment_gateway.id === 2 && response.data.square_settings){
            this.square_settings = response.data.square_settings
            this.square_settings.create_customer = Boolean(response.data.square_settings.create_customer)
            this.square_settings.store_credit_card = Boolean(response.data.square_settings.store_credit_card)
            this.square_settings.require_card_for_deposit = Boolean(response.data.square_settings.require_card_for_deposit)
            this.square_settings.require_card_for_full_payment = Boolean(response.data.square_settings.require_card_for_full_payment)
          }

          this.addQueryParameters()
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })

    },
    async getPaymentGateways(){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let url = API_LOCATION + 'companies/' + companyId + '/integrations/payment-gateways'
      this.axios.get(url, config)
        .then(response => {
          this.payment_gateways = response.data.payment_gateways
          if(this.payment_gateways.length <= 0){
            this.empty = true
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.notifyError('Something went wrong')
          }
        })
    },
    async changePaymentGateway(){
      const cont = await this.askConfirm({
        title: 'Are you sure?',
        message: 'This will deactivate credentials for your current payment gateway.',
        confirmText: 'Change payment gateway'
      })
      if(!cont){
        return
      }
      this.gateway_configured = false
    },
    goToIntegrationSetup(gateway){
      this.payment_gateway = gateway
      this.gateway_configured = true
      if (gateway && gateway.id === 3) {
        // The pill rail waits for the connection state (stripeConnectLoaded), so a gateway
        // picked from the tiles must load it here too, not only in getPaymentSettings;
        // without this the rail stayed on its skeleton for a venue picking Stripe (2026-10-21).
        this.fetchStripeConnection(false, true)
        // Card readers are fetched lazily when the user opens the
        // Hardware pill (see setStripePill).
        this.$nextTick(() => this.initStripePillForFirstIncomplete())
      }

      this.test_credentials = {
        api_name: '',
        api_key: '',
        api_location: '',
        is_active: 0
      }
      this.live_credentials = {
        api_name: '',
        api_key: '',
        api_location: '',
        is_active: 0
      }

      if(this.payment_gateway.id === 1){
        this.api_name = 'API Login ID'
        this.api_key = 'Transaction Key'
      } else if (this.payment_gateway.id === 2){
        this.api_name = 'Application ID'
        this.api_key = 'Access token'
        this.api_location = 'Location ID'
      }  else if (this.payment_gateway.id === 3){
        this.api_name = 'Publishable key'
        this.api_key = 'Secret key'
      } else if (this.payment_gateway.id === 4){
        this.api_name = 'Public key'
        this.api_key = 'Secret key'
      } else if (this.payment_gateway.id === 5){
        this.api_name = 'Merchant ID'
        this.api_key = 'Secret key'
      }

      for(let n in this.credentials){
        if(this.credentials[n].is_live === 0 && this.payment_gateway.id === this.credentials[n].payment_gateway_id){
          this.test_credentials.id = this.credentials[n].id
          this.test_credentials.has_api_key = Boolean(this.credentials[n].has_api_key || this.credentials[n].api_key)
          this.test_credentials.api_name = this.credentials[n].api_name
          this.test_credentials.is_active = this.credentials[n].is_active
          this.test_credentials.is_live = this.credentials[n].is_live
          this.test_credentials.api_location = this.credentials[n].api_location
        } else if(this.credentials[n].is_live === 1 && this.payment_gateway.id === this.credentials[n].payment_gateway_id) {
          this.live_credentials.id = this.credentials[n].id
          this.live_credentials.has_api_key = Boolean(this.credentials[n].has_api_key || this.credentials[n].api_key)
          this.live_credentials.api_name = this.credentials[n].api_name
          this.live_credentials.is_active = this.credentials[n].is_active
          this.live_credentials.is_live = this.credentials[n].is_live
          this.live_credentials.api_location = this.credentials[n].api_location

        }
      }
    },
    addQueryParameters() {
      this.$nextTick(() => {
        this.currentPage = this.$route.query.page
      });

      const newQuery = {
        ...this.$route.query,
        id: this.payment_settings.id,
        tab: this.activeTabIndex
      }
      this.$router.replace({query: newQuery}).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
  },
  mounted() {
    this.currency_symbol =  _.find(this.currencies, { code: JSON.parse(localStorage.getItem('group')).currency }).symbol
    this.date_format_cal = this.date_format
    this.date_format_cal =  this.date_format_cal.replaceAll('Y', 'y')
    this.date_format_cal = this.date_format_cal.replaceAll('D', 'd')
    this.group = JSON.parse(localStorage.getItem('group'))
    if (this.time_format === 'HH:mm') {
      this.picker_time_format = 'HH:mm'
    }
    this.getGames()
    this.getPaymentSettings()
    this.getPaymentGateways()
    // Surface the Square OAuth connect result if we just came back from Square.
    // (The connection status itself is loaded in getPaymentSettings once the
    // Square gateway + settingsId are known.)
    this.handleSquareReturn()
    this.handleStripeReturn()
    let tab = this.$route.query.hasOwnProperty('tab') ? this.$route.query.tab : 0
    this.switchTab(Number(tab))
  }
}
</script>

<style scoped>
.button-wide{
  width: 90%;
}
.card-list {
  list-style-type: none;
  padding: 0;
  flex-wrap: wrap;
  display: flex;
}

.rounded-table {
  border: 2px solid #ffffff; /* Outer border */
  border-radius: 15px;    /* Rounded corners for the outer border */
  border-collapse: collapse; /* Collapse inner borders to remove them */
  /*overflow: hidden; !* Ensures table content respects the rounded border *!*/
  width: 100%; /* Optional: Table width adjustment */
}
/*.rounded-table td, .rounded-table th {*/
/*  padding: 10px;*/
/*  border: 1px solid #000; !* Optional: Add borders to cells if needed *!*/
/*}*/

/* ─── Stripe gateway sections (collapsible) ─────────────────────────── */
.stripe-section {
  margin-bottom: 16px;
}
/* Inside a pill panel: drop trailing margin on the final section (the pill
   itself is the visual container) but keep generous gap between siblings
   when a pill holds two stacked sections (Policies = Customer mgmt +
   Statement description). */
.stripe-section--in-pill {
  margin-bottom: 0;
}
.stripe-section--in-pill + .stripe-section--in-pill {
  margin-top: 24px;
}
/* The pill nav IS the section switcher, so sections inside pills should
   not also be collapsible. Hide the chevron + make the header
   non-interactive; the section stays expanded. */
.stripe-section--in-pill ::v-deep .collapsible-section__chevron {
  display: none;
}
.stripe-section--in-pill ::v-deep .collapsible-section__header {
  cursor: default;
  pointer-events: none;
}

/* ─── Stripe two-column layout (left rail + right pill nav) ──────────── */
.stripe-layout {
  margin: 0;
}
.stripe-layout__rail,
.stripe-layout__main {
  padding-left: 8px;
  padding-right: 8px;
}

.stripe-rail {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 20px 16px;
  text-align: center;
  position: sticky;
  top: 16px;
}
.stripe-rail__eyebrow {
  margin: 0 0 12px;
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: rgba(255, 255, 255, 0.7);
}
.stripe-rail__logo {
  position: relative;
  background: #fff;
  border-radius: 8px;
  padding: 22px 18px;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 96px;
}
.stripe-rail__logo-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  display: inline-flex;
  align-items: center;
  padding: 2px 7px;
  border-radius: 10px;
  font-size: 9.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
  line-height: 1.4;
}
/* Tinted backgrounds + darker text so the badge reads against the white
   logo box. */
.stripe-rail__logo-badge--ok {
  background: rgba(0, 170, 130, 0.15);
  color: #00956d;
}
.stripe-rail__logo-badge--partial {
  background: rgba(255, 152, 0, 0.18);
  color: #b56a00;
}
.stripe-rail__logo-badge--off {
  background: rgba(0, 0, 0, 0.07);
  color: rgba(0, 0, 0, 0.55);
}
.stripe-rail__logo img {
  max-width: 100%;
  max-height: 36px;
  object-fit: scale-down;
}
.stripe-rail__name {
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
}
.stripe-rail__change {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 8px 12px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;
}
.stripe-rail__change:hover {
  background: rgba(225, 78, 202, 0.08);
  border-color: rgba(225, 78, 202, 0.5);
  color: #e14eca;
}
.stripe-rail__change i {
  font-size: 11px;
}
.white-content .stripe-rail {
  background: rgba(0, 0, 0, 0.02);
  border-color: rgba(0, 0, 0, 0.08);
}
.white-content .stripe-rail__eyebrow { color: rgba(0, 0, 0, 0.6); }
.white-content .stripe-rail__logo { border: 1px solid rgba(0, 0, 0, 0.08); }
.white-content .stripe-rail__name { color: rgba(0, 0, 0, 0.85); }
.white-content .stripe-rail__change {
  border-color: rgba(0, 0, 0, 0.2);
  color: rgba(0, 0, 0, 0.7);
}

/* Pill sub-nav (matches booking-site editor pill style per MEMORY.md) */
.stripe-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(125, 125, 125, 0.15);
  margin-bottom: 16px;
}
.stripe-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: transparent;
  border: 1px solid rgba(125, 125, 125, 0.25);
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}
.stripe-pill:hover {
  background: rgba(225, 78, 202, 0.06);
  color: rgba(255, 255, 255, 0.95);
}
.stripe-pill--active {
  background: rgba(225, 78, 202, 0.15);
  border-color: #e14eca;
  color: #e14eca;
}
.stripe-pill__icon {
  font-size: 13px;
}
.stripe-pill__status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  margin-left: 2px;
  border-radius: 50%;
  font-size: 11px;
}
.stripe-pill--ok .stripe-pill__status {
  background: rgba(0, 242, 195, 0.18);
  color: #00f2c3;
}
.stripe-pill--incomplete .stripe-pill__status {
  background: rgba(253, 93, 147, 0.18);
  color: #fd5d93;
}
.stripe-pill--neutral .stripe-pill__status {
  /* No tinted background for the neutral (policies) pill — but hardware
     uses its count label inside the bubble, so keep a subtle background. */
  background: rgba(125, 125, 125, 0.18);
  color: rgba(255, 255, 255, 0.75);
}
.stripe-pill__count {
  font-size: 10.5px;
  font-weight: 700;
  font-variant: tabular-nums;
  line-height: 1;
}
.stripe-pill__status i {
  font-size: 10px;
  font-weight: 700;
}
.white-content .stripe-pill { color: rgba(0, 0, 0, 0.6); }
.white-content .stripe-pill:hover { color: rgba(0, 0, 0, 0.85); }
.white-content .stripe-pill--active { color: #e14eca; }
.white-content .stripe-pill--neutral .stripe-pill__status { color: rgba(0, 0, 0, 0.6); }

.stripe-panel {
  /* Pill panel is just a container — content is each (now-pill-gated)
     collapsible-section. Spacing handled by the inner sections. */
}

/* ─── Empty-state CTA panel (used inside credentials + webhook sections) ─
   Replaces the alarmist fa-exclamation-triangle pattern. "Not configured"
   isn't an error state — it's just an unconfigured optional/required
   piece — so the visual should read as "next action available" not "alert". */
.stripe-empty {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding: 18px 20px;
  background: rgba(125, 125, 125, 0.04);
  border: 1px dashed rgba(125, 125, 125, 0.3);
  border-radius: 8px;
  max-width: 500px;
}
.stripe-empty--required {
  /* Required pieces get a subtle pink accent so they read as "needed to
     proceed" without being alarmist. */
  border-color: rgba(225, 78, 202, 0.35);
  background: rgba(225, 78, 202, 0.04);
}
.stripe-empty__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(225, 78, 202, 0.12);
  color: #e14eca;
  font-size: 16px;
  margin-bottom: 4px;
}
.stripe-empty__title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
}
.stripe-empty__hint {
  margin: 0 0 8px;
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.5;
  max-width: 50ch;
}
.stripe-empty__hint a { color: #e14eca; }
.white-content .stripe-empty__title { color: rgba(0, 0, 0, 0.85); }
.white-content .stripe-empty__hint { color: rgba(0, 0, 0, 0.6); }

/* Square connected metadata box. The connected message + Disconnect button
   reuse the global info-hint + base-button; only this key/value box has no
   global equivalent, so it's the one local block kept. */
.sq-connected__meta {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 2px 14px;
  margin-bottom: 16px;
}
.sq-connected__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 0;
}
.sq-connected__row + .sq-connected__row {
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}
.sq-connected__label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.5);
}
.sq-connected__value {
  font-family: 'SFMono-Regular', Menlo, Consolas, 'Liberation Mono', monospace;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.92);
}
/* Sentence values: label column fixed, text left-aligned in the body font */
.sq-connected__row--text {
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px;
}
.sq-connected__row--text .sq-connected__label {
  flex: 0 0 150px;
  padding-top: 2px;
}
.sq-connected__value--text {
  font-family: inherit;
  color: rgba(255, 255, 255, 0.85);
}
.white-content .sq-connected__value--text { color: rgba(0, 0, 0, 0.75); }
.white-content .sq-connected__meta {
  background: rgba(0, 0, 0, 0.02);
  border-color: rgba(0, 0, 0, 0.08);
}
.white-content .sq-connected__label { color: rgba(0, 0, 0, 0.5); }
.white-content .sq-connected__value { color: rgba(0, 0, 0, 0.85); }

/* ─── Webhook section sub-blocks (URL + signing secret) ──────────────── */
.webhook-url {
  display: flex;
  align-items: stretch;
  max-width: 560px;
  background: rgba(125, 125, 125, 0.08);
  border: 1px solid rgba(125, 125, 125, 0.22);
  border-radius: 6px;
  overflow: hidden;
}
.webhook-url__value {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: transparent;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.92);
  overflow-x: auto;
  white-space: nowrap;
}
.webhook-url__copy {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  background: transparent;
  border: none;
  border-left: 1px solid rgba(125, 125, 125, 0.22);
  color: rgba(255, 255, 255, 0.55);
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.webhook-url__copy:hover {
  background: rgba(225, 78, 202, 0.08);
  color: #e14eca;
}
.webhook-url__copy:active {
  background: rgba(225, 78, 202, 0.16);
}

.webhook-block__title {
  margin: 0 0 4px;
  font-size: 12.5px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.webhook-block__sub {
  margin: 0 0 10px;
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.5;
}
.webhook-block__sub a { color: #e14eca; }
.webhook-block__sub code {
  font-size: 11.5px;
  padding: 1px 5px;
  background: rgba(125, 125, 125, 0.12);
  border-radius: 3px;
}
.white-content .webhook-url__value { color: rgba(0, 0, 0, 0.85); }
.white-content .webhook-url__copy { color: rgba(0, 0, 0, 0.5); }
.white-content .webhook-block__title { color: rgba(0, 0, 0, 0.85); }
.white-content .webhook-block__sub { color: rgba(0, 0, 0, 0.6); }

/* ─── Stripe credentials sub-block (test + live) ─────────────────────── */
.stripe-creds-block {
  padding: 12px 14px;
  background: rgba(125, 125, 125, 0.04);
  border: 1px solid rgba(125, 125, 125, 0.15);
  border-radius: 6px;
}
.stripe-creds-block__head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 10px;
}
.stripe-creds-block__title {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.white-content .stripe-creds-block__title { color: rgba(0, 0, 0, 0.85); }

/* ─── Card readers (Stripe Terminal smart readers) ──────────────────── */
/* Readers empty state now uses the shared .stripe-empty pattern (same as
   the webhook signing-secret empty state). Old .readers-empty rules
   removed when consolidating. */
.stripe-location-row {
  margin: 12px 0;
}
.stripe-location-row__label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}
.stripe-location-row__info {
  color: #1d8cf8;
  cursor: pointer;
}
.stripe-location-row__controls {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}
.stripe-location-row__select {
  flex: 1 1 260px;
  max-width: 420px;
}
.stripe-location-row__count {
  float: right;
  color: rgba(125, 125, 125, 0.9);
  font-size: 12px;
}
.stripe-location-chip--inline {
  margin: 0;
}
.stripe-location-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  margin: 12px 0;
  border-radius: 6px;
  background: rgba(125, 125, 125, 0.08);
  border: 1px solid rgba(125, 125, 125, 0.18);
  font-size: 12px;
  max-width: 100%;
}
.stripe-location-chip__label {
  color: rgba(255, 255, 255, 0.55);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 10px;
  font-weight: 600;
}
.stripe-location-chip__value {
  color: #fff;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  padding: 0;
  background: transparent;
  border: none;
}
.stripe-location-chip__copy {
  appearance: none;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.55);
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 4px;
  line-height: 1;
  transition: color 0.15s ease, background 0.15s ease;
}
.stripe-location-chip__copy:hover {
  color: #e14eca;
  background: rgba(225, 78, 202, 0.08);
}
.white-content .stripe-location-chip__label,
.white-content .stripe-location-chip__copy {
  color: rgba(34, 42, 66, 0.55);
}
.white-content .stripe-location-chip__value {
  color: #222a42;
}

.readers-list {
  list-style: none;
  padding: 0;
  margin: 0 0 12px;
}
.reader-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  margin-bottom: 8px;
  background: rgba(125, 125, 125, 0.04);
  border: 1px solid rgba(125, 125, 125, 0.15);
  border-radius: 6px;
}
.reader-row__body {
  min-width: 0;
  flex: 1;
}
.reader-row__name-display {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 2px 4px;
  margin: -2px -4px 0;
  border-radius: 4px;
  outline: none;
}
.reader-row__name-display:hover {
  background: rgba(255, 255, 255, 0.04);
}
.reader-row__name {
  font-size: 13.5px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
}
.reader-row__pencil {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
}
.reader-row__name-edit {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.reader-row__name-input {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(225, 78, 202, 0.4);
  border-radius: 4px;
  color: #fff;
  font-size: 13.5px;
  font-weight: 600;
  padding: 2px 8px;
  min-width: 180px;
  outline: none;
}
.reader-row__name-icon {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  padding: 2px 4px;
  font-size: 14px;
}
.reader-row__name-icon:hover {
  color: rgba(255, 255, 255, 0.9);
}
.reader-row__name-icon--save {
  color: #00f2c3;
}
.reader-row__meta {
  margin: 4px 0 0;
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.6);
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.reader-row__status {
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 8px;
  font-size: 10.5px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.reader-row__status--online {
  background: rgba(0, 242, 195, 0.12);
  color: #00f2c3;
}
.reader-row__status--offline {
  background: rgba(125, 125, 125, 0.12);
  color: rgba(255, 255, 255, 0.5);
}
.reader-row__dot {
  color: rgba(255, 255, 255, 0.3);
}
.reader-row__id {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.4);
}
.white-content .reader-row__name-display:hover { background: rgba(0, 0, 0, 0.04); }
.white-content .reader-row__name { color: rgba(0, 0, 0, 0.85); }
.white-content .reader-row__pencil { color: rgba(0, 0, 0, 0.45); }
.white-content .reader-row__name-input {
  background: rgba(0, 0, 0, 0.03);
  color: rgba(0, 0, 0, 0.85);
}
.white-content .reader-row__name-icon { color: rgba(0, 0, 0, 0.5); }
.white-content .reader-row__name-icon:hover { color: rgba(0, 0, 0, 0.85); }
.white-content .reader-row__name-icon--save,
.white-content .reader-row__name-icon--save:hover { color: #00f2c3; }
.white-content .reader-row__meta { color: rgba(0, 0, 0, 0.55); }
.white-content .reader-row__status--offline { color: rgba(0, 0, 0, 0.5); }
.white-content .reader-row__dot { color: rgba(0, 0, 0, 0.3); }
.white-content .reader-row__id { color: rgba(0, 0, 0, 0.45); }
.readers-add-row {
  margin-top: 12px;
}
/* ─── Card reader inline pair form ────────────────────────────────────
   No card chrome — matches the webhook + credentials edit-mode pattern
   (plain fields inside the section body, action row at the bottom). */
.reader-pair-form__field {
  margin-bottom: 8px;
}
.reader-pair-form__actions {
  margin-top: 16px;
}

</style>

<style>
/* Tighten the gap above the first info-hint when it sits as the section
   intro (inside a collapsible-section body or a drawer-section content).
   Default info-hint has margin-top: 12px, which stacks on the parent's
   own 16-20px padding for ~32px of empty space before the text starts. */
.stripe-section .info-hint:first-child,
.drawer-section__content > .info-hint:first-child {
  margin-top: 0;
}

.recommended-badge {
  font-size: 10px;
  font-weight: 500;
  color: #e14eca;
  background: rgba(225, 78, 202, 0.12);
  border-radius: 3px;
  padding: 1px 6px;
  margin-left: 8px;
  letter-spacing: 0.3px;
}
</style>
